export const searchAutoCompleteList = [
  'Aion ES Electric',
  'Aion Y Plus Electric',
  'Alfa Romeo Giulia',
  'Alfa Romeo Stelvio',
  'Alfa Romeo Tonale Mild Hybrid',
  'Alpine A110',
  'Aston Martin DB11 Volante',
  'Aston Martin DB11',
  'Aston Martin DB12 Volante',
  'Aston Martin DB12',
  'Aston Martin DBX707',
  'Aston Martin Vantage',
  'Audi A3 Sedan Mild Hybrid',
  'Audi A5 Sportback Mild Hybrid',
  'Audi A6 Sedan Mild Hybrid',
  'Audi A6 Sedan Plug-in Hybrid',
  'Audi A8L Mild Hybrid',
  'Audi e-tron Electric',
  'Audi e-tron Sportback Electric',
  'Audi Q2',
  'Audi Q3 Mild Hybrid',
  'Audi Q3 Sportback Mild Hybrid',
  'Audi Q4 e-tron Electric',
  'Audi Q4 Sportback e-tron Electric',
  'Audi Q5 Mild Hybrid',
  'Audi Q5 Sportback Mild Hybrid',
  'Audi Q7 Mild Hybrid',
  'Audi Q8 e-tron Electric',
  'Audi Q8 Sportback e-tron Electric',
  'Audi RS 3 Sedan',
  'Audi RS 4 Avant',
  'Audi RS 6 Avant Mild Hybrid',
  'Audi RS 7 Sportback Mild Hybrid',
  'Audi RS e-tron GT Electric',
  'Audi S8 Mild Hybrid',
  'Audi SQ8',
  'Audi TT Coupe',
  'BAC Mono R',
  'BAC Mono',
  'Bentley Bentayga EWB',
  'Bentley Bentayga Hybrid',
  'Bentley Bentayga',
  'Bentley Continental GT 1 Auto Cars Edition',
  'Bentley Continental GT Convertible',
  'Bentley Continental GT',
  'Bentley Flying Spur Plug-in Hybrid',
  'Bentley Flying Spur',
  'BMW 2 Series Active Tourer',
  'BMW 2 Series Coupe',
  'BMW 2 Series Gran Coupe',
  'BMW 3 Series Sedan',
  'BMW 4 Series Convertible',
  'BMW 4 Series Coupe',
  'BMW 4 Series Gran Coupe',
  'BMW 5 Series Sedan Mild Hybrid',
  'BMW 5 Series Sedan Plug-in Hybrid',
  'BMW 7 Series Mild Hybrid',
  'BMW 7 Series',
  'BMW 8 Series Coupe',
  'BMW 8 Series Gran Coupe',
  'BMW ALPINA B5 Bi-Turbo Saloon',
  'BMW ALPINA B5 Bi-Turbo Touring',
  'BMW ALPINA B6 Bi-Turbo Convertible',
  'BMW ALPINA XD3 Diesel',
  'BMW i4 Gran Coupe Electric',
  'BMW i4 M50 Gran Coupe Electric',
  'BMW i5 Electric',
  'BMW i5 M60 Electric',
  'BMW i5 Touring Electric',
  'BMW i7 Electric',
  'BMW i7 M70 Electric',
  'BMW iX Electric',
  'BMW iX1 Electric',
  'BMW iX2 Electric',
  'BMW iX3 Electric',
  'BMW M135',
  'BMW M2 Coupe',
  'BMW M235i Gran Coupe',
  'BMW M240i Coupe',
  'BMW M3 Sedan',
  'BMW M3 Touring',
  'BMW M340i',
  'BMW M4 Convertible',
  'BMW M4 Coupe',
  'BMW M5 Sedan Plug-in Hybrid',
  'BMW M8 Coupe',
  'BMW X1 M35i',
  'BMW X1',
  'BMW X2 M35i',
  'BMW X2',
  'BMW X3 M50 Mild Hybrid',
  'BMW X3 Mild Hybrid',
  'BMW X4 Mild Hybrid',
  'BMW X5 Mild Hybrid',
  'BMW X6 M',
  'BMW X6 Mild Hybrid',
  'BMW X7 M60i Mild Hybrid',
  'BMW X7',
  'BMW XM Plug-in Hybrid',
  'BMW Z4 Roadster',
  'BYD Atto 3 Electric',
  'BYD C6 Electric',
  'BYD Dolphin Electric',
  'BYD e6 Electric',
  'BYD M6 Electric',
  'BYD Seal Electric',
  'BYD T3 Electric',
  'Chevrolet Corvette',
  'Citroen e-Berlingo Electric',
  'Citroen e-C4 Electric',
  'Citroen e-C4 X Sedan Electric',
  'Citroen e-Dispatch Electric',
  'DENZA D9',
  'DFSK EC31 Electric',
  'DFSK EC31 Refrigerated Electric',
  'DFSK EC35 Electric',
  'DFSK EC35 Gen 2 Electric',
  'Dongfeng Box',
  'Farizon H9E Electric',
  'Farizon SuperVan Electric',
  'Ferrari 12Cilindri Spider',
  'Ferrari 12Cilindri',
  'Ferrari 296 GTB Plug-in Hybrid',
  'Ferrari 296 GTS Plug-in Hybrid',
  'Ferrari 488 Pista',
  'Ferrari F8 Tributo',
  'Ferrari Purosangue',
  'Ferrari Roma 1 Auto Cars Edition',
  'Ferrari Roma Spider',
  'Ferrari Roma',
  'Ferrari SF90 Stradale Plug-in Hybrid',
  'Ford Ranger Raptor Diesel',
  'Ford Ranger Raptor Petrol',
  'Ford Ranger Wildtrak Diesel',
  'Foton Aumark S Diesel',
  'Foton eTruck Mate Electric Mini Truck',
  'Foton Iblue T5 Electric Truck',
  'Foton Iblue V6 Electric Commuter Bus',
  'Foton Iblue V6 Electric Van',
  'Golden Dragon ABS EV Electric',
  'Golden Dragon Big Coaster Bus Diesel',
  'Golden Dragon XML5036 Minibus Electric',
  'Golden Dragon XML6107 Diesel',
  'Golden Dragon XML6112 Diesel',
  'Golden Dragon XML6129 Diesel',
  'Golden Dragon XML6957 Diesel',
  'Higer H5C',
  'Higer H5F Electric',
  'Higer H5F Standard Roof Electric',
  'Hino 200 Diesel',
  'Hino 300 Diesel',
  'Hino 500 Diesel',
  'Honda Accord Hybrid',
  'Honda City',
  'Honda Civic Hatchback',
  'Honda Civic Hybrid',
  'Honda Civic Type-R',
  'Honda Civic',
  'Honda CR-V 2017',
  'Honda CR-V',
  'Honda E Electric',
  'Honda Fit 2017',
  'Honda Fit Hybrid',
  'Honda Fit Venture Cars Edition',
  'Honda Fit',
  'Honda Freed 2020',
  'Honda Freed Hybrid 2020',
  'Honda Freed Hybrid',
  'Honda Freed',
  'Honda HR-V Hybrid',
  'Honda HR-V',
  'Honda Jazz Crosstar Hybrid',
  'Honda Jazz Hybrid',
  'Honda N-Box',
  'Honda N-Van Petrol',
  'Honda Odyssey Hybrid',
  'Honda Odyssey',
  'Honda Shuttle Hybrid',
  'Honda Shuttle',
  'Honda Stepwagon Hybrid Vin\'s Auto Edition',
  'Honda Stepwagon Hybrid',
  'Honda Vezel Hybrid',
  'Honda Vezel Vin\'s Auto Edition',
  'Honda Vezel',
  'Honda WR-V Vin\'s Auto Edition',
  'Honda WR-V',
  'Honda ZR-V Hybrid',
  'Hyundai Avante Hybrid',
  'Hyundai Ioniq 5 Electric',
  'Hyundai Ioniq 5 N Electric',
  'Hyundai Ioniq 6 Electric',
  'Hyundai Kona Electric',
  'Hyundai Kona Hybrid',
  'Hyundai Palisade',
  'Hyundai Santa Fe Turbo Hybrid',
  'Hyundai Staria',
  'Hyundai Tucson Hybrid',
  'Isuzu F Series Diesel',
  'Isuzu N Series Diesel',
  'Jaecoo J7 Plug-in Hybrid',
  'Jaguar F-PACE',
  'Jaguar F-TYPE Coupe',
  'Jaguar I-PACE Electric',
  'Jaguar XF',
  'Jeep Grand Cherokee L',
  'Jeep Wrangler Rubicon 4-Door',
  'Jeep Wrangler Sahara 4-Door',
  'Joylong EA5 Electric',
  'Joylong EW4 Electric',
  'Kia Carnival Hybrid',
  'Kia EV9 Electric',
  'Kia Niro Electric',
  'Kia Niro Hybrid',
  'Kia Niro Plus Electric',
  'Kia Sorento Hybrid',
  'KYC V7 Electric',
  'Lamborghini Aventador',
  'Lamborghini Revuelto Plug-in Hybrid',
  'Lamborghini Temerario Plug-in Hybrid',
  'Lamborghini Urus Plug-in Hybrid',
  'Lamborghini Urus',
  'Land Rover Defender 110 Mild Hybrid Diesel',
  'Land Rover Defender 110 Mild Hybrid',
  'Land Rover Defender 110 Plug-in Hybrid',
  'Land Rover Defender 110',
  'Land Rover Defender 90 Mild Hybrid Diesel',
  'Land Rover Defender 90 Mild Hybrid',
  'Land Rover Defender 90',
  'Land Rover Discovery Sport Mild Hybrid',
  'Land Rover Discovery',
  'Land Rover Range Rover Evoque Mild Hybrid',
  'Land Rover Range Rover Mild Hybrid',
  'Land Rover Range Rover Plug-in Hybrid',
  'Land Rover Range Rover Sport Mild Hybrid',
  'Land Rover Range Rover Velar Mild Hybrid',
  'Land Rover Range Rover Velar',
  'LEVC VN5 Plug-in Hybrid',
  'Lexus ES 300h Hybrid',
  'Lexus IS 300h Hybrid',
  'Lexus LBX Hybrid',
  'Lexus LC 500 Convertible',
  'Lexus LM Hybrid',
  'Lexus LS Hybrid',
  'Lexus LX 600',
  'Lexus NX 350h Hybrid',
  'Lexus NX 450h+ Plug-in Hybrid',
  'Lexus RX 300',
  'Lexus RX 350h Hybrid',
  'Lexus RX 450h+ Plug-in Hybrid',
  'Lexus RX 500h Hybrid',
  'Lexus RZ Electric',
  'Lexus UX 300h Hybrid',
  'Lotus Eletre',
  'Lotus Elise',
  'Lotus Emeya',
  'Lotus Emira',
  'Maserati Ghibli Mild Hybrid',
  'Maserati GranCabrio',
  'Maserati GranTurismo',
  'Maserati Grecale Mild Hybrid',
  'Maserati Grecale',
  'Maserati Levante',
  'Maserati MC20',
  'Maserati Quattroporte',
  'Maxus eDeliver 3 Electric',
  'Maxus eDeliver 5 Electric',
  'Maxus eDeliver 7 Electric',
  'Maxus eDeliver 9 Electric',
  'Maxus MIFA 7 Electric',
  'Maxus MIFA 9 Electric',
  'Maxus T90 Electric',
  'Maxus T90 EV Electric',
  'Mazda 2 Hatchback',
  'Mazda 3 Hatchback Mild Hybrid',
  'Mazda 3 Sedan Mild Hybrid',
  'Mazda 6 Sedan',
  'Mazda CX-30',
  'Mazda CX-5 Mild Hybrid',
  'Mazda CX-60',
  'Mazda MX-30 Electric',
  'Mazda MX-5 RF',
  'McLaren 750S Coupe',
  'McLaren 750S Spider',
  'McLaren 765LT',
  'McLaren Artura Plug-in Hybrid',
  'McLaren Artura Spider Plug-in Hybrid',
  'McLaren GT',
  'Mercedes-Benz A-Class Hatchback',
  'Mercedes-Benz A-Class Saloon Mild Hybrid',
  'Mercedes-Benz A-Class Saloon',
  'Mercedes-Benz AMG GT 4-Door Coupe Mild Hybrid',
  'Mercedes-Benz AMG GT 4-Door Coupe',
  'Mercedes-Benz AMG GT Coupe',
  'Mercedes-Benz AMG GT Roadster',
  'Mercedes-Benz AMG GT',
  'Mercedes-Benz B-Class',
  'Mercedes-Benz C-Class Saloon Mild Hybrid',
  'Mercedes-Benz C-Class Saloon Plug-in Hybrid',
  'Mercedes-Benz CLA-Class Coupe Mild Hybrid',
  'Mercedes-Benz CLA-Class Coupe',
  'Mercedes-Benz CLE-Class Cabriolet Mild Hybrid',
  'Mercedes-Benz CLE-Class Coupe Mild Hybrid',
  'Mercedes-Benz E-Class Cabriolet Mild Hybrid',
  'Mercedes-Benz E-Class Coupe Mild Hybrid',
  'Mercedes-Benz E-Class Saloon Diesel 2020',
  'Mercedes-Benz E-Class Saloon Mild Hybrid 2020',
  'Mercedes-Benz E-Class Saloon Mild Hybrid',
  'Mercedes-Benz E-Class Saloon Plug-in Hybrid',
  'Mercedes-Benz EQA Electric',
  'Mercedes-Benz EQB Electric',
  'Mercedes-Benz EQC Electric',
  'Mercedes-Benz EQE Electric',
  'Mercedes-Benz EQE SUV Electric',
  'Mercedes-Benz EQS Electric',
  'Mercedes-Benz EQS SUV Electric',
  'Mercedes-Benz EQV Electric',
  'Mercedes-Benz eVito Electric',
  'Mercedes-Benz G-Class 1 Auto Cars Edition',
  'Mercedes-Benz G-Class Diesel',
  'Mercedes-Benz G-Class',
  'Mercedes-Benz GLA-Class Mild Hybrid',
  'Mercedes-Benz GLA-Class',
  'Mercedes-Benz GLB-Class Mild Hybrid',
  'Mercedes-Benz GLB-Class',
  'Mercedes-Benz GLC-Class Coupe Mild Hybrid 2019',
  'Mercedes-Benz GLC-Class Coupe Mild Hybrid',
  'Mercedes-Benz GLC-Class Coupe Plug-in Hybrid',
  'Mercedes-Benz GLC-Class Mild Hybrid',
  'Mercedes-Benz GLC-Class Plug-in Hybrid',
  'Mercedes-Benz GLE-Class Coupe Diesel',
  'Mercedes-Benz GLE-Class Coupe Mild Hybrid',
  'Mercedes-Benz GLE-Class Diesel',
  'Mercedes-Benz GLE-Class Mild Hybrid 1 Auto Cars Edition',
  'Mercedes-Benz GLE-Class Mild Hybrid',
  'Mercedes-Benz GLS-Class Diesel',
  'Mercedes-Benz GLS-Class Mild Hybrid',
  'Mercedes-Benz Maybach EQS Electric',
  'Mercedes-Benz Maybach GLS-Class 1 Auto Cars Edition',
  'Mercedes-Benz Maybach GLS-Class Mild Hybrid',
  'Mercedes-Benz Maybach GLS-Class',
  'Mercedes-Benz Maybach S-Class Mild Hybrid',
  'Mercedes-Benz Maybach S-Class',
  'Mercedes-Benz S-Class Diesel',
  'Mercedes-Benz S-Class Mild Hybrid',
  'Mercedes-Benz SL-Class Cabriolet',
  'Mercedes-Benz V-Class Diesel',
  'Mercedes-Benz Vito Diesel',
  'Mercedes-Benz Vito Tourer Diesel',
  'MG 4 EV',
  'MG 5 EV',
  'MG Cyberster',
  'MG M9 EV',
  'MG ZS EV',
  'MINI Aceman Electric',
  'MINI Cooper 3-Door Electric',
  'MINI Cooper C 5-Door',
  'MINI Cooper S 3-Door',
  'MINI Countryman C',
  'MINI Countryman Electric',
  'MINI Countryman S',
  'MINI John Cooper Works Countryman',
  'MINI John Cooper Works GP',
  'Mitsubishi Fuso Canter Diesel',
  'Mitsubishi Space Star',
  'Mitsuoka Rock Star',
  'Mitsuoka Viewt',
  'Morgan Plus Four',
  'Morgan Plus Six',
  'Nissan Ariya Electric',
  'Nissan Fairlady',
  'Nissan Kicks e-POWER Hybrid',
  'Nissan Leaf Electric',
  'Nissan Note e-POWER Hybrid',
  'Nissan NV200 Petrol',
  'Nissan NV350 Petrol',
  'Nissan Serena e-POWER Hybrid',
  'Nissan X-Trail e-POWER e-4ORCE Hybrid',
  'Nissan X-Trail e-POWER Hybrid',
  'OHM 35 Electric',
  'Omoda E5 Electric',
  'Opel Combo-e Electric',
  'Opel Combo-e Life Electric',
  'Opel Mokka-e Electric',
  'Opel Vivaro-e Electric',
  'Opel Zafira-e Life Electric',
  'ORA Good Cat Electric',
  'Pagani Huayra',
  'Perodua Aruz',
  'Perodua Bezza',
  'Perodua Myvi',
  'Peugeot 408',
  'Peugeot 5008',
  'Peugeot E-2008 Electric',
  'Peugeot e-Expert Electric',
  'Peugeot e-Partner Electric',
  'Polestar 2 Electric',
  'Polestar 3 Electric',
  'Polestar 4 Electric',
  'Porsche 718 Boxster',
  'Porsche 718 Cayman',
  'Porsche 911 Cabriolet',
  'Porsche 911 GT3',
  'Porsche 911 Targa',
  'Porsche 911',
  'Porsche Cayenne Coupe Plug-in Hybrid',
  'Porsche Cayenne Coupe',
  'Porsche Cayenne Plug-in Hybrid Coupe',
  'Porsche Cayenne Plug-in Hybrid',
  'Porsche Cayenne',
  'Porsche Macan Electric',
  'Porsche Macan',
  'Porsche Panamera Plug-in Hybrid',
  'Porsche Panamera',
  'Porsche Taycan Cross Turismo Electric',
  'Porsche Taycan Electric',
  'Renault Kangoo E-Tech Electric',
  'Rolls-Royce Cullinan 1 Auto Cars Edition',
  'Rolls-Royce Cullinan',
  'Rolls-Royce Dawn 1 Auto Cars Edition',
  'Rolls-Royce Dawn',
  'Rolls-Royce Ghost 1 Auto Cars Edition',
  'Rolls-Royce Ghost Series II',
  'Rolls-Royce Ghost',
  'Rolls-Royce Phantom 1 Auto Cars Edition',
  'Rolls-Royce Phantom',
  'Rolls-Royce Spectre Electric',
  'Rolls-Royce Wraith 1 Auto Cars Edition',
  'Rolls-Royce Wraith',
  'SANY EV490 Electric',
  'SANY FR601 Electric',
  'Seres 3 Electric',
  'Skoda Enyaq Coupe Electric',
  'Skoda Enyaq Electric',
  'Skoda Kamiq',
  'Skoda Kodiaq Mild Hybrid',
  'Skoda Octavia Combi Mild Hybrid',
  'Skoda Octavia Mild Hybrid',
  'smart #1 electric',
  'smart #3 electric',
  'smart Forfour Electric',
  'smart Fortwo Cabrio Electric',
  'SOKON EC31 Electric',
  'SOKON EC35II Electric',
  'SRM T3EV Electric',
  'SsangYong Actyon Sports Diesel',
  'SsangYong Korando Electric',
  'SsangYong Tivoli Diesel',
  'Subaru BRZ',
  'Subaru Crosstrek e-BOXER Mild Hybrid',
  'Subaru Forester e-BOXER Mild Hybrid',
  'Suzuki Every Petrol',
  'Suzuki Jimny 5-Door',
  'Suzuki Jimny',
  'Suzuki Landy Hybrid',
  'Suzuki Spacia Base Petrol',
  'Suzuki Spacia Mild Hybrid',
  'Suzuki Swift Mild Hybrid',
  'Suzuki Vitara',
  'Tesla Model 3 Electric',
  'Tesla Model Y Electric',
  'Toyota Alphard 1 Auto Cars Edition',
  'Toyota Alphard 2018',
  'Toyota Alphard Hybrid 2020',
  'Toyota Alphard Hybrid',
  'Toyota Alphard',
  'Toyota Camry Hybrid',
  'Toyota Century Hybrid',
  'Toyota Coaster Bus Diesel',
  'Toyota Corolla Altis',
  'Toyota Corolla Cross Hybrid',
  'Toyota Corolla Sedan Hybrid',
  'Toyota Corolla Touring Hybrid',
  'Toyota Crown Crossover Hybrid',
  'Toyota Crown Hybrid',
  'Toyota Dyna 150 Diesel',
  'Toyota GR Supra',
  'Toyota GR Yaris',
  'Toyota GR86',
  'Toyota Granace Diesel',
  'Toyota Harrier Hybrid',
  'Toyota Hiace Diesel',
  'Toyota Hiace High Roof Diesel',
  'Toyota Hiace Standard Roof Diesel',
  'Toyota Hiace Standard Roof Petrol',
  'Toyota Highlander Hybrid',
  'Toyota Hilux Double Cab Diesel',
  'Toyota Land Cruiser 250',
  'Toyota Land Cruiser 300',
  'Toyota Land Cruiser Prado',
  'Toyota Noah Hybrid 2017',
  'Toyota Noah Hybrid Vin\'s Auto Edition',
  'Toyota Noah Hybrid',
  'Toyota Prius Hybrid 2016',
  'Toyota Prius Hybrid',
  'Toyota Proace City Electric',
  'Toyota Proace Electric',
  'Toyota Raize Hybrid',
  'Toyota Raize',
  'Toyota RAV4 Hybrid',
  'Toyota Sienta Hybrid',
  'Toyota Townace Petrol',
  'Toyota Vellfire 2018',
  'Toyota Vellfire Hybrid',
  'Toyota Vellfire',
  'Toyota Voxy Hybrid',
  'Toyota Voxy',
  'Toyota Yaris Cross Hybrid',
  'Toyota Yaris Cross',
  'Victory e-Reliance Electric',
  'Victory e-Response Electric',
  'Volkswagen Arteon R',
  'Volkswagen Caddy Diesel',
  'Volkswagen Golf GTI',
  'Volkswagen Golf Mild Hybrid',
  'Volkswagen Golf R',
  'Volkswagen ID. Buzz Cargo Electric',
  'Volkswagen ID. Buzz Electric',
  'Volkswagen ID.3 Electric',
  'Volkswagen ID.4 Electric',
  'Volkswagen ID.4 GTX Electric',
  'Volkswagen ID.5 Electric',
  'Volkswagen ID.5 GTX Electric',
  'Volkswagen Sharan',
  'Volkswagen T-Cross',
  'Volkswagen Tiguan Mild Hybrid',
  'Volkswagen Transporter Diesel',
  'Volvo EC40 Electric',
  'Volvo EX30 Electric',
  'Volvo EX40 Electric',
  'Volvo S90 Mild Hybrid',
  'Volvo V60 Mild Hybrid',
  'Volvo XC40 Mild Hybrid',
  'Volvo XC60 Mild Hybrid',
  'Volvo XC60 Plug-in Hybrid',
  'Volvo XC90 Mild Hybrid',
  'XPENG G6 Electric',
  'Yutong C11H Hybrid',
  'Yutong ZK6117H',
  'ZEEKR 009 Electric',
  'ZEEKR X Electric',
  '#1 electric',
  '#3 electric',
  '009 Electric',
  '12Cilindri Spider',
  '12Cilindri',
  '2 Electric',
  '2 Hatchback',
  '2 Series Active Tourer',
  '2 Series Coupe',
  '2 Series Gran Coupe',
  '200 Diesel',
  '296 GTB Plug-in Hybrid',
  '296 GTS Plug-in Hybrid',
  '3 Electric',
  '3 Hatchback Mild Hybrid',
  '3 Sedan Mild Hybrid',
  '3 Series Sedan',
  '300 Diesel',
  '35 Electric',
  '4 Electric',
  '4 EV',
  '4 Series Convertible',
  '4 Series Coupe',
  '4 Series Gran Coupe',
  '408',
  '488 Pista',
  '5 EV',
  '5 Series Sedan Mild Hybrid',
  '5 Series Sedan Plug-in Hybrid',
  '500 Diesel',
  '5008',
  '6 Sedan',
  '7 Series Mild Hybrid',
  '7 Series',
  '718 Boxster',
  '718 Cayman',
  '750S Coupe',
  '750S Spider',
  '765LT',
  '8 Series Coupe',
  '8 Series Gran Coupe',
  '911 Cabriolet',
  '911 GT3',
  '911 Targa',
  '911',
  'A-Class Hatchback',
  'A-Class Saloon Mild Hybrid',
  'A-Class Saloon',
  'A110',
  'A3 Sedan Mild Hybrid',
  'A5 Sportback Mild Hybrid',
  'A6 Sedan Mild Hybrid',
  'A6 Sedan Plug-in Hybrid',
  'A8L Mild Hybrid',
  'ABS EV Electric',
  'Accord Hybrid',
  'Aceman Electric',
  'Actyon Sports Diesel',
  'Alphard 1 Auto Cars Edition',
  'Alphard 2018',
  'Alphard Hybrid 2020',
  'Alphard Hybrid',
  'Alphard',
  'AMG GT 4-Door Coupe Mild Hybrid',
  'AMG GT 4-Door Coupe',
  'AMG GT Coupe',
  'AMG GT Roadster',
  'AMG GT',
  'Ariya Electric',
  'Arteon R',
  'Artura Plug-in Hybrid',
  'Artura Spider Plug-in Hybrid',
  'Aruz',
  'Atto 3 Electric',
  'Aumark S Diesel',
  'Avante Hybrid',
  'Aventador',
  'B-Class',
  'B5 Bi-Turbo Saloon',
  'B5 Bi-Turbo Touring',
  'B6 Bi-Turbo Convertible',
  'Bentayga EWB',
  'Bentayga Hybrid',
  'Bentayga',
  'Bezza',
  'Big Coaster Bus Diesel',
  'Box',
  'BRZ',
  'C-Class Saloon Mild Hybrid',
  'C-Class Saloon Plug-in Hybrid',
  'C11H Hybrid',
  'C6 Electric',
  'Caddy Diesel',
  'Camry Hybrid',
  'Carnival Hybrid',
  'Cayenne Coupe Plug-in Hybrid',
  'Cayenne Coupe',
  'Cayenne Plug-in Hybrid Coupe',
  'Cayenne Plug-in Hybrid',
  'Cayenne',
  'Century Hybrid',
  'City',
  'Civic Hatchback',
  'Civic Hybrid',
  'Civic Type-R',
  'Civic',
  'CLA-Class Coupe Mild Hybrid',
  'CLA-Class Coupe',
  'CLE-Class Cabriolet Mild Hybrid',
  'CLE-Class Coupe Mild Hybrid',
  'Coaster Bus Diesel',
  'Combo-e Electric',
  'Combo-e Life Electric',
  'Continental GT 1 Auto Cars Edition',
  'Continental GT Convertible',
  'Continental GT',
  'Cooper 3-Door Electric',
  'Cooper C 5-Door',
  'Cooper S 3-Door',
  'Corolla Altis',
  'Corolla Cross Hybrid',
  'Corolla Sedan Hybrid',
  'Corolla Touring Hybrid',
  'Corvette',
  'Countryman C',
  'Countryman Electric',
  'Countryman S',
  'CR-V 2017',
  'CR-V',
  'Crosstrek e-BOXER Mild Hybrid',
  'Crown Crossover Hybrid',
  'Crown Hybrid',
  'Cullinan 1 Auto Cars Edition',
  'Cullinan',
  'CX-30',
  'CX-5 Mild Hybrid',
  'CX-60',
  'Cyberster',
  'D9',
  'Dawn 1 Auto Cars Edition',
  'Dawn',
  'DB11 Volante',
  'DB11',
  'DB12 Volante',
  'DB12',
  'DBX707',
  'Defender 110 Mild Hybrid Diesel',
  'Defender 110 Mild Hybrid',
  'Defender 110 Plug-in Hybrid',
  'Defender 110',
  'Defender 90 Mild Hybrid Diesel',
  'Defender 90 Mild Hybrid',
  'Defender 90',
  'Discovery Sport Mild Hybrid',
  'Discovery',
  'Dolphin Electric',
  'Dyna 150 Diesel',
  'E Electric',
  'E-2008 Electric',
  'e-Berlingo Electric',
  'e-C4 Electric',
  'e-C4 X Sedan Electric',
  'E-Class Cabriolet Mild Hybrid',
  'E-Class Coupe Mild Hybrid',
  'E-Class Saloon Diesel 2020',
  'E-Class Saloon Mild Hybrid 2020',
  'E-Class Saloon Mild Hybrid',
  'E-Class Saloon Plug-in Hybrid',
  'e-Dispatch Electric',
  'e-Expert Electric',
  'e-Partner Electric',
  'e-Reliance Electric',
  'e-Response Electric',
  'e-tron Electric',
  'e-tron Sportback Electric',
  'E5 Electric',
  'e6 Electric',
  'EA5 Electric',
  'EC31 Electric',
  'EC31 Refrigerated Electric',
  'EC35 Electric',
  'EC35 Gen 2 Electric',
  'EC35II Electric',
  'EC40 Electric',
  'eDeliver 3 Electric',
  'eDeliver 5 Electric',
  'eDeliver 7 Electric',
  'eDeliver 9 Electric',
  'Eletre',
  'Elise',
  'Emeya',
  'Emira',
  'Enyaq Coupe Electric',
  'Enyaq Electric',
  'EQA Electric',
  'EQB Electric',
  'EQC Electric',
  'EQE Electric',
  'EQE SUV Electric',
  'EQS Electric',
  'EQS SUV Electric',
  'EQV Electric',
  'ES 300h Hybrid',
  'ES Electric',
  'eTruck Mate Electric Mini Truck',
  'EV490 Electric',
  'EV9 Electric',
  'Every Petrol',
  'eVito Electric',
  'EW4 Electric',
  'EX30 Electric',
  'EX40 Electric',
  'F Series Diesel',
  'F-PACE',
  'F-TYPE Coupe',
  'F8 Tributo',
  'Fairlady',
  'Fit 2017',
  'Fit Hybrid',
  'Fit Venture Cars Edition',
  'Fit',
  'Flying Spur Plug-in Hybrid',
  'Flying Spur',
  'Forester e-BOXER Mild Hybrid',
  'Forfour Electric',
  'Fortwo Cabrio Electric',
  'FR601 Electric',
  'Freed 2020',
  'Freed Hybrid 2020',
  'Freed Hybrid',
  'Freed',
  'Fuso Canter Diesel',
  'G-Class 1 Auto Cars Edition',
  'G-Class Diesel',
  'G-Class',
  'G6 Electric',
  'Ghibli Mild Hybrid',
  'Ghost 1 Auto Cars Edition',
  'Ghost Series II',
  'Ghost',
  'Giulia',
  'GLA-Class Mild Hybrid',
  'GLA-Class',
  'GLB-Class Mild Hybrid',
  'GLB-Class',
  'GLC-Class Coupe Mild Hybrid 2019',
  'GLC-Class Coupe Mild Hybrid',
  'GLC-Class Coupe Plug-in Hybrid',
  'GLC-Class Mild Hybrid',
  'GLC-Class Plug-in Hybrid',
  'GLE-Class Coupe Diesel',
  'GLE-Class Coupe Mild Hybrid',
  'GLE-Class Diesel',
  'GLE-Class Mild Hybrid 1 Auto Cars Edition',
  'GLE-Class Mild Hybrid',
  'GLS-Class Diesel',
  'GLS-Class Mild Hybrid',
  'Golf GTI',
  'Golf Mild Hybrid',
  'Golf R',
  'Good Cat Electric',
  'GR Supra',
  'GR Yaris',
  'GR86',
  'Granace Diesel',
  'GranCabrio',
  'Grand Cherokee L',
  'GranTurismo',
  'Grecale Mild Hybrid',
  'Grecale',
  'GT',
  'H5C',
  'H5F Electric',
  'H5F Standard Roof Electric',
  'H9E Electric',
  'Harrier Hybrid',
  'Hiace Diesel',
  'Hiace High Roof Diesel',
  'Hiace Standard Roof Diesel',
  'Hiace Standard Roof Petrol',
  'Highlander Hybrid',
  'Hilux Double Cab Diesel',
  'HR-V Hybrid',
  'HR-V',
  'Huayra',
  'I-PACE Electric',
  'i4 Gran Coupe Electric',
  'i4 M50 Gran Coupe Electric',
  'i5 Electric',
  'i5 M60 Electric',
  'i5 Touring Electric',
  'i7 Electric',
  'i7 M70 Electric',
  'Iblue T5 Electric Truck',
  'Iblue V6 Electric Commuter Bus',
  'Iblue V6 Electric Van',
  'ID. Buzz Cargo Electric',
  'ID. Buzz Electric',
  'ID.3 Electric',
  'ID.4 Electric',
  'ID.4 GTX Electric',
  'ID.5 Electric',
  'ID.5 GTX Electric',
  'Ioniq 5 Electric',
  'Ioniq 5 N Electric',
  'Ioniq 6 Electric',
  'IS 300h Hybrid',
  'iX Electric',
  'iX1 Electric',
  'iX2 Electric',
  'iX3 Electric',
  'J7 Plug-in Hybrid',
  'Jazz Crosstar Hybrid',
  'Jazz Hybrid',
  'Jimny 5-Door',
  'Jimny',
  'John Cooper Works Countryman',
  'John Cooper Works GP',
  'Kamiq',
  'Kangoo E-Tech Electric',
  'Kicks e-POWER Hybrid',
  'Kodiaq Mild Hybrid',
  'Kona Electric',
  'Kona Hybrid',
  'Korando Electric',
  'Land Cruiser 250',
  'Land Cruiser 300',
  'Land Cruiser Prado',
  'Landy Hybrid',
  'LBX Hybrid',
  'LC 500 Convertible',
  'Leaf Electric',
  'Levante',
  'LM Hybrid',
  'LS Hybrid',
  'LX 600',
  'M135',
  'M2 Coupe',
  'M235i Gran Coupe',
  'M240i Coupe',
  'M3 Sedan',
  'M3 Touring',
  'M340i',
  'M4 Convertible',
  'M4 Coupe',
  'M5 Sedan Plug-in Hybrid',
  'M6 Electric',
  'M8 Coupe',
  'M9 EV',
  'Macan Electric',
  'Macan',
  'Maybach EQS Electric',
  'Maybach GLS-Class 1 Auto Cars Edition',
  'Maybach GLS-Class Mild Hybrid',
  'Maybach GLS-Class',
  'Maybach S-Class Mild Hybrid',
  'Maybach S-Class',
  'MC20',
  'MIFA 7 Electric',
  'MIFA 9 Electric',
  'Model 3 Electric',
  'Model Y Electric',
  'Mokka-e Electric',
  'Mono R',
  'Mono',
  'MX-30 Electric',
  'MX-5 RF',
  'Myvi',
  'N Series Diesel',
  'N-Box',
  'N-Van Petrol',
  'Niro Electric',
  'Niro Hybrid',
  'Niro Plus Electric',
  'Noah Hybrid 2017',
  'Noah Hybrid Vin\'s Auto Edition',
  'Noah Hybrid',
  'Note e-POWER Hybrid',
  'NV200 Petrol',
  'NV350 Petrol',
  'NX 350h Hybrid',
  'NX 450h+ Plug-in Hybrid',
  'Octavia Combi Mild Hybrid',
  'Octavia Mild Hybrid',
  'Odyssey Hybrid',
  'Odyssey',
  'Palisade',
  'Panamera Plug-in Hybrid',
  'Panamera',
  'Phantom 1 Auto Cars Edition',
  'Phantom',
  'Plus Four',
  'Plus Six',
  'Prius Hybrid 2016',
  'Prius Hybrid',
  'Proace City Electric',
  'Proace Electric',
  'Purosangue',
  'Q2',
  'Q3 Mild Hybrid',
  'Q3 Sportback Mild Hybrid',
  'Q4 e-tron Electric',
  'Q4 Sportback e-tron Electric',
  'Q5 Mild Hybrid',
  'Q5 Sportback Mild Hybrid',
  'Q7 Mild Hybrid',
  'Q8 e-tron Electric',
  'Q8 Sportback e-tron Electric',
  'Quattroporte',
  'Raize Hybrid',
  'Raize',
  'Range Rover Evoque Mild Hybrid',
  'Range Rover Mild Hybrid',
  'Range Rover Plug-in Hybrid',
  'Range Rover Sport Mild Hybrid',
  'Range Rover Velar Mild Hybrid',
  'Range Rover Velar',
  'Ranger Raptor Diesel',
  'Ranger Raptor Petrol',
  'Ranger Wildtrak Diesel',
  'RAV4 Hybrid',
  'Revuelto Plug-in Hybrid',
  'Rock Star',
  'Roma 1 Auto Cars Edition',
  'Roma Spider',
  'Roma',
  'RS 3 Sedan',
  'RS 4 Avant',
  'RS 6 Avant Mild Hybrid',
  'RS 7 Sportback Mild Hybrid',
  'RS e-tron GT Electric',
  'RX 300',
  'RX 350h Hybrid',
  'RX 450h+ Plug-in Hybrid',
  'RX 500h Hybrid',
  'RZ Electric',
  'S-Class Diesel',
  'S-Class Mild Hybrid',
  'S8 Mild Hybrid',
  'S90 Mild Hybrid',
  'Santa Fe Turbo Hybrid',
  'Seal Electric',
  'Serena e-POWER Hybrid',
  'SF90 Stradale Plug-in Hybrid',
  'Sharan',
  'Shuttle Hybrid',
  'Shuttle',
  'Sienta Hybrid',
  'SL-Class Cabriolet',
  'Sorento Hybrid',
  'Space Star',
  'Spacia Base Petrol',
  'Spacia Mild Hybrid',
  'Spectre Electric',
  'SQ8',
  'Staria',
  'Stelvio',
  'Stepwagon Hybrid Vin\'s Auto Edition',
  'Stepwagon Hybrid',
  'SuperVan Electric',
  'Swift Mild Hybrid',
  'T-Cross',
  'T3 Electric',
  'T3EV Electric',
  'T90 Electric',
  'T90 EV Electric',
  'Taycan Cross Turismo Electric',
  'Taycan Electric',
  'Temerario Plug-in Hybrid',
  'Tiguan Mild Hybrid',
  'Tivoli Diesel',
  'Tonale Mild Hybrid',
  'Townace Petrol',
  'Transporter Diesel',
  'TT Coupe',
  'Tucson Hybrid',
  'Urus Plug-in Hybrid',
  'Urus',
  'UX 300h Hybrid',
  'V-Class Diesel',
  'V60 Mild Hybrid',
  'V7 Electric',
  'Vantage',
  'Vellfire 2018',
  'Vellfire Hybrid',
  'Vellfire',
  'Vezel Hybrid',
  'Vezel Vin\'s Auto Edition',
  'Vezel',
  'Viewt',
  'Vitara',
  'Vito Diesel',
  'Vito Tourer Diesel',
  'Vivaro-e Electric',
  'VN5 Plug-in Hybrid',
  'Voxy Hybrid',
  'Voxy',
  'WR-V Vin\'s Auto Edition',
  'WR-V',
  'Wraith 1 Auto Cars Edition',
  'Wraith',
  'Wrangler Rubicon 4-Door',
  'Wrangler Sahara 4-Door',
  'X Electric',
  'X-Trail e-POWER e-4ORCE Hybrid',
  'X-Trail e-POWER Hybrid',
  'X1 M35i',
  'X1',
  'X2 M35i',
  'X2',
  'X3 M50 Mild Hybrid',
  'X3 Mild Hybrid',
  'X4 Mild Hybrid',
  'X5 Mild Hybrid',
  'X6 M',
  'X6 Mild Hybrid',
  'X7 M60i Mild Hybrid',
  'X7',
  'XC40 Mild Hybrid',
  'XC60 Mild Hybrid',
  'XC60 Plug-in Hybrid',
  'XC90 Mild Hybrid',
  'XD3 Diesel',
  'XF',
  'XM Plug-in Hybrid',
  'XML5036 Minibus Electric',
  'XML6107 Diesel',
  'XML6112 Diesel',
  'XML6129 Diesel',
  'XML6957 Diesel',
  'Y Plus Electric',
  'Yaris Cross Hybrid',
  'Yaris Cross',
  'Z4 Roadster',
  'Zafira-e Life Electric',
  'ZK6117H',
  'ZR-V Hybrid',
  'ZS EV',
  '#1 electric Brabus 66 kWh (A)',
  '#1 electric Pro+ 66 kWh (A)',
  '#3 electric Brabus 66 kWh (A)',
  '#3 electric Pro+ 66 kWh (A)',
  '009 Electric Flagship 116 kWh (A)',
  '009 Electric Premium 116 kWh (A)',
  '12Cilindri 6.5 V12 (A)',
  '12Cilindri Spider 6.5 V12 (A)',
  '2 Electric Long Range Dual Motor Performance Pack 82 kWh (A)',
  '2 Electric Standard Range Single Motor 69 kWh (A)',
  '2 Electric Standard Range Single Motor Core Edition 69 kWh(A)',
  '2 Hatchback 1.5 Sports (A)',
  '2 Series Active Tourer 216i Inspiring (A)',
  '2 Series Active Tourer 216i M Sport (A)',
  '2 Series Coupe 220i M Sport (A)',
  '2 Series Gran Coupe 216i M Sport (A)',
  '200 Diesel 3.7 10FT [Euro VI] (A)',
  '296 GTB Plug-in Hybrid 3.0 V6 (A)',
  '296 GTS Plug-in Hybrid 3.0 V6 (A)',
  '3 Electric Long Range Dual Motor 111 kWh (A)',
  '3 Electric Long Range Dual Motor Performance Pack 111 kWh (A)',
  '3 Electric Premium 54 kWh (A)',
  '3 Hatchback Mild Hybrid 1.5 Astina (A)',
  '3 Sedan Mild Hybrid 1.5 Classic (A)',
  '3 Sedan Mild Hybrid 1.5 Elegance (A)',
  '3 Sedan Mild Hybrid 1.5 Luxury (A)',
  '3 Series Sedan 318i Inspiring (A)',
  '3 Series Sedan 318i M Sport (A)',
  '300 Diesel 4.0 XZU710R-HKMMV3 14FT [Euro VI] (M)',
  '35 Electric 61.8 kWh (A)',
  '4 Electric Long Range Dual Motor 100 kWh (A)',
  '4 Electric Long Range Single Motor 100 kWh (A)',
  '4 EV Trophy 99kW 64 kWh (A)',
  '4 Series Convertible 420i M Sport Pro',
  '4 Series Coupe 420i M Sport Pro',
  '4 Series Gran Coupe 420i M Sport (A)',
  '4 Series Gran Coupe 420i M Sport Pro (A)',
  '408 1.2 EAT8 Fastback Allure Premium (A)',
  '408 1.2 EAT8 Fastback GT (A)',
  '488 Pista 3.9 V8 (A)',
  '5 EV Excite 50.3 kWh (A)',
  '5 EV Excite SW 50.3 kWh (A)',
  '5 EV Exclusive SW 61.1 kWh (A)',
  '5 Series Sedan Mild Hybrid 520i (A)',
  '5 Series Sedan Mild Hybrid 520i M Sport (A)',
  '5 Series Sedan Plug-in Hybrid 550e xDrive M Sport Pro (A)',
  '500 Diesel 5.0 FD9JLNA-HAS LWB [Euro VI] (M)',
  '5008 1.2 PureTech EAT8 Allure Premium 7-Seater (A)',
  '6 Sedan 2.0 Executive (A)',
  '6 Sedan 2.0 Luxury (A)',
  '7 Series 740Li M Sport (A)',
  '7 Series Mild Hybrid 735i M Sport (A)',
  '7 Series Mild Hybrid 735i Pinnacle (A)',
  '718 Boxster 2.0 (A)',
  '718 Boxster GTS 4.0 (M)',
  '718 Boxster S 2.5 (A)',
  '718 Boxster Style Edition 2.0 (A)',
  '718 Cayman 2.0 (A)',
  '718 Cayman GT4 RS (A)',
  '718 Cayman GTS 4.0 (A)',
  '718 Cayman PDK 2.0 (A)',
  '718 Cayman S 2.5 (A)',
  '718 Cayman Style Edition 2.0 (A)',
  '750S Coupe 4.0 (A)',
  '750S Spider 4.0 (A)',
  '765LT 4.0 V8 (A)',
  '8 Series Coupe 840i M Sport (A)',
  '8 Series Gran Coupe 840i M Sport (A)',
  '911 Cabriolet Carrera 3.0 (A)',
  '911 Cabriolet Carrera 4 3.0 (A)',
  '911 Cabriolet Carrera 4 GTS 3.0 (A)',
  '911 Cabriolet Carrera 4S 3.0 (A)',
  '911 Cabriolet Carrera GTS 3.0 (A)',
  '911 Cabriolet Carrera GTS PDK 3.0 (A)',
  '911 Cabriolet Carrera PDK 3.0 (A)',
  '911 Cabriolet Carrera S 3.0 (A)',
  '911 Cabriolet Carrera S PDK 3.0 (A)',
  '911 Cabriolet Turbo 3.8 (A)',
  '911 Cabriolet Turbo S 3.8 (A)',
  '911 Cabriolet Turbo S PDK 3.8 (A)',
  '911 Carrera 3.0 (A)',
  '911 Carrera 4 3.0 (A)',
  '911 Carrera 4 GTS 3.0 (A)',
  '911 Carrera 4S 3.0 (A)',
  '911 Carrera 4S PDK 3.0 (A)',
  '911 Carrera GTS 3.0 (A)',
  '911 Carrera GTS PDK 3.0 (A)',
  '911 Carrera PDK 3.0 (A)',
  '911 Carrera S 3.0 (A)',
  '911 Carrera S PDK 3.0 (A)',
  '911 Carrera T 3.0 (A)',
  '911 GT3 4.0 (A)',
  '911 GT3 RS 4.0 (A)',
  '911 Targa 4 3.0 (A)',
  '911 Targa 4 GTS 3.0 (A)',
  '911 Targa 4 GTS PDK 3.0 (A)',
  '911 Targa 4 PDK 3.0 (A)',
  '911 Targa 4S 3.0 (A)',
  '911 Targa 4S PDK 3.0 (A)',
  '911 Targa 4S PDK 3.0 Heritage Design Edition (A)',
  '911 Turbo 3.8 (A)',
  '911 Turbo S 3.8 (A)',
  '911 Turbo S PDK 3.8 (A)',
  'A-Class Hatchback A180 Progressive (A)',
  'A-Class Hatchback A180 SE (A)',
  'A-Class Hatchback A35 AMG 4MATIC (A)',
  'A-Class Hatchback A35 AMG 4MATIC Premium Plus (A)',
  'A-Class Hatchback A45 S AMG 4MATIC+ (A)',
  'A-Class Hatchback A45 S AMG Premium Plus 4MATIC+ (A)',
  'A-Class Saloon A180 Sport (A)',
  'A-Class Saloon A35 AMG 4MATIC Premium Plus (A)',
  'A-Class Saloon Mild Hybrid A180 Progressive (A)',
  'A-Class Saloon Mild Hybrid A200 AMG Line (A)',
  'A-Class Saloon Mild Hybrid A35 AMG 4MATIC (A)',
  'A110 1.8 Plus (A)',
  'A110 1.8 S (A)',
  'A3 Sedan Mild Hybrid 1.0 TFSI S tronic (A)',
  'A5 Sportback Mild Hybrid 2.0 TFSI S tronic (A)',
  'A6 Sedan Mild Hybrid 2.0 TFSI S tronic (A)',
  'A6 Sedan Mild Hybrid 2.0 TFSI S tronic [204hp] (A)',
  'A6 Sedan Plug-in Hybrid 2.0 50 TFSI e qu S tronic Sport (A)',
  'A8L Mild Hybrid 3.0 TFSI qu Tip (A)',
  'A8L Mild Hybrid 4.0 TFSI qu Tip (A)',
  'ABS EV Electric Truck 50.23 kWh (A)',
  'ABS EV Electric Van 50.23 kWh (A)',
  'ABS EV Electric Van Fridge 50.23 kWh (A)',
  'Accord Hybrid 2.0 RS e:HEV (A)',
  'Aceman Electric E 42.5 kWh (A)',
  'Aceman Electric SE 54.2 kWh (A)',
  'Alphard 1 Auto Cars Edition 2.5 S C-Package 7-Seater (A)',
  'Alphard 1 Auto Cars Edition 2.5 X 8-Seater (A)',
  'Alphard 1 Auto Cars Edition 3.5 Executive Lounge S 7-Seater (A)',
  'Alphard 1 Auto Cars Edition 3.5 SC 7-Seater (A)',
  'Alphard 2.5 Z 2WD (A)',
  'Alphard 2018 2.5 S C-Package 7-Seater (A)',
  'Alphard 2018 2.5 X 8-Seater (A)',
  'Alphard 2018 3.5 Executive Lounge S 7-Seater (A)',
  'Alphard 2018 3.5 SC 7-Seater (A)',
  'Alphard Hybrid 2.5 Elegance (A)',
  'Alphard Hybrid 2.5 Executive Lounge (A)',
  'Alphard Hybrid 2.5 Z (A)',
  'Alphard Hybrid 2.5 Z Modellista (A)',
  'Alphard Hybrid 2020 2.5 SR C-Package 7-Seater (A)',
  'Alphard Hybrid 2020 2.5 X 7-Seater (A)',
  'AMG GT 4-Door Coupe 63 S 4MATIC+ (A)',
  'AMG GT 4-Door Coupe 63 S 4MATIC+ Edition 1 (A)',
  'AMG GT 4-Door Coupe Mild Hybrid 43 4MATIC+ (A)',
  'AMG GT Coupe GT63 4MATIC+ (A)',
  'AMG GT R (A)',
  'AMG GT R Pro (A)',
  'AMG GT Roadster C 4.0 (A)',
  'AMG GT S (A)',
  'Ariya Electric Dual-Tone 66 kWh (A)',
  'Ariya Electric Single-Tone 66 kWh (A)',
  'Arteon R 2.0 TSI DSG (A)',
  'Artura Plug-in Hybrid 3.0 V6 (A)',
  'Artura Spider Plug-in Hybrid 3.0 V6 (A)',
  'Aruz 1.5 X 7-Seater (A)',
  'Atto 3 Electric CarbonEdge [100kW] 60.5 kWh (A)',
  'Atto 3 Electric [100kW] 60.5 kWh (A)',
  'Aumark S Diesel 3.8 (M)',
  'Avante Hybrid 1.6 Elite (A)',
  'Avante Hybrid 1.6 S (A)',
  'Aventador 6.5 SVJ V12 (A)',
  'B-Class B180 Progressive (A)',
  'B5 Bi-Turbo Saloon 4.4 V8 (A)',
  'B5 Bi-Turbo Touring 4.4 V8 (A)',
  'B6 Bi-Turbo Convertible 4.4 V8 [Edition 50] (A)',
  'Bentayga 4.0 V8 (A)',
  'Bentayga 4.0 V8 Azure (A)',
  'Bentayga EWB 4.0 V8 Azure (A)',
  'Bentayga Hybrid 3.0 (A)',
  'Bentayga Hybrid 3.0 First Edition (A)',
  'Bezza 1.3 Premium X (A)',
  'Big Coaster Bus Diesel 30 Seater (A)',
  'Box 42.3 kWh (A)',
  'BRZ 2.4 EyeSight (A)',
  'BRZ 2.4 EyeSight (M)',
  'C-Class Saloon Mild Hybrid C180 AMG Line (A)',
  'C-Class Saloon Mild Hybrid C180 Avantgarde (A)',
  'C-Class Saloon Mild Hybrid C200 AMG Line (A)',
  'C-Class Saloon Mild Hybrid C200 AMG Line Premium (A)',
  'C-Class Saloon Mild Hybrid C200 AMG Line [HK] (A)',
  'C-Class Saloon Mild Hybrid C43 AMG 4MATIC (A)',
  'C-Class Saloon Plug-in Hybrid C63 AMG S E Performance (A)',
  'C11H Hybrid 45 Seater (A)',
  'C6 Electric 135 kWh (A)',
  'Caddy Diesel 2.0 TDI DSG Maxi Panel Van [Euro VI] (A)',
  'Caddy Diesel 2.0 TDI DSG Maxi Window Van [Euro VI] (A)',
  'Caddy Diesel 2.0 TDI DSG NWB Panel Van [Euro VI] (A)',
  'Caddy Diesel 2.0 TDI DSG NWB Window Van [Euro VI] (A)',
  'Camry Hybrid 2.5 Ascent Sport (A)',
  'Camry Hybrid 2.5 Elegance (A)',
  'Carnival Hybrid 1.6 7-Seater (A)',
  'Carnival Hybrid 1.6 8-Seater (A)',
  'Cayenne 3.0 (A)',
  'Cayenne Coupe 3.0 (A)',
  'Cayenne Coupe Plug-in Hybrid 3.0 (A)',
  'Cayenne Coupe Plug-in Hybrid S 3.0 (A)',
  'Cayenne Coupe Plug-in Hybrid Turbo 4.0 (A)',
  'Cayenne Coupe Plug-in Hybrid Turbo w/ GT Package (A)',
  'Cayenne Coupe S 4.0 (A)',
  'Cayenne Coupe Turbo 4.0 (A)',
  'Cayenne Platinum Edition 3.0 (A)',
  'Cayenne Plug-in Hybrid 3.0 (A)',
  'Cayenne Plug-in Hybrid Coupe 3.0 (A)',
  'Cayenne Plug-in Hybrid S 3.0 (A)',
  'Cayenne Plug-in Hybrid Turbo 4.0 (A)',
  'Cayenne S 2.9 (A)',
  'Cayenne S 4.0 (A)',
  'Century Hybrid 5.0 V8 (A)',
  'City 1.5 RS (A)',
  'City 1.5 SV (A)',
  'Civic 1.5 Turbo (A)',
  'Civic Hatchback 1.5 (M)',
  'Civic Hybrid 2.0 e:HEV (A)',
  'Civic Type-R 2.0 VTEC Turbo (M)',
  'CLA-Class Coupe CLA180 AMG Line (A)',
  'CLA-Class Coupe CLA180 AMG Line Premium Plus (A)',
  'CLA-Class Coupe CLA200 AMG Line (A)',
  'CLA-Class Coupe CLA200 AMG Line Premium Plus (A)',
  'CLA-Class Coupe CLA250 AMG Line Premium Plus (A)',
  'CLA-Class Coupe CLA45 S AMG 4MATIC+ (A)',
  'CLA-Class Coupe CLA45 S AMG 4MATIC+ Plus (A)',
  'CLA-Class Coupe Mild Hybrid CLA180 Progressive (A)',
  'CLA-Class Coupe Mild Hybrid CLA200 AMG Line (A)',
  'CLA-Class Coupe Mild Hybrid CLA35 AMG 4MATIC (A)',
  'CLE-Class Cabriolet Mild Hybrid CLE200 AMG Line (A)',
  'CLE-Class Coupe Mild Hybrid CLE200 AMG Line (A)',
  'CLE-Class Coupe Mild Hybrid CLE200 Avantgarde (A)',
  'CLE-Class Coupe Mild Hybrid CLE300 AMG Line (A)',
  'CLE-Class Coupe Mild Hybrid CLE53 AMG 4MATIC+',
  'Coaster Bus Diesel 24 Seater (A)',
  'Combo-e Electric 50 kWh (A)',
  'Combo-e Life Electric 50 kWh (A)',
  'Continental GT 1 Auto Cars Edition 4.0 V8 (A)',
  'Continental GT 4.0 V8 (A)',
  'Continental GT 4.0 V8 Azure (A)',
  'Continental GT Convertible 4.0 V8 (A)',
  'Continental GT Convertible 4.0 V8 Azure (A)',
  'Cooper 3-Door Electric E 40.7 kWh (A)',
  'Cooper 3-Door Electric SE 54.2 kWh (A)',
  'Cooper C 5-Door 1.5 (A)',
  'Cooper S 3-Door 2.0 (A)',
  'Corolla Altis 1.6 Elegance (A)',
  'Corolla Altis 1.6 Standard (A)',
  'Corolla Cross Hybrid 1.8 G (A)',
  'Corolla Cross Hybrid 2.0 Premium (A)',
  'Corolla Sedan Hybrid 1.8 Ascent Sport (A)',
  'Corolla Touring Hybrid 1.8 X (A)',
  'Corvette 6.2 C8 (A)',
  'Countryman C 1.5 (A)',
  'Countryman Electric E 66.5 kWh (A)',
  'Countryman Electric SE ALL4 66.5 kWh (A)',
  'Countryman S ALL4 2.0 (A)',
  'CR-V 1.5 Turbo 5-Seater (A)',
  'CR-V 1.5 Turbo 7-Seater (A)',
  'CR-V 2017 1.5 VTEC Turbo 5-Seater (A)',
  'Crosstrek e-BOXER Mild Hybrid 2.0i-S Eyesight (A)',
  'Crosstrek e-BOXER Mild Hybrid 2.0i-S EyeSight GT Edition (A)',
  'Crown Crossover Hybrid 2.5 G Advanced Leather Package (A)',
  'Crown Hybrid 2.5 Sport Z (A)',
  'Cullinan 1 Auto Cars Edition 6.75 V12 (A)',
  'Cullinan 6.75 V12 (A)',
  'Cullinan 6.75 V12 Black Badge (A)',
  'CX-30 2.0 Luxury (A)',
  'CX-5 Mild Hybrid 2.0 Luxury (A)',
  'CX-5 Mild Hybrid 2.0 Luxury Sports (A)',
  'CX-60 2.5 Luxury (A)',
  'Cyberster 77 kWh (A)',
  'Cyberster AWD 77 kWh (A)',
  'D9 Elite 103.36 kWh (A)',
  'D9 Grandeur 103.36 kWh (A)',
  'Dawn 1 Auto Cars Edition 6.6 V12 (A)',
  'Dawn 6.6 V12 (A)',
  'DB11 4.0 V8 (A)',
  'DB11 Volante 4.0 (A)',
  'DB12 4.0 V8 (A)',
  'DB12 Volante 4.0 V8 (A)',
  'DBX707 4.0 V8 (A)',
  'Defender 110 5.0 Carpathian Edition 5-Seater (A)',
  'Defender 110 5.0 V8 5-Seater (A)',
  'Defender 110 Mild Hybrid 2.0 X-DYNAMIC S P400E (A)',
  'Defender 110 Mild Hybrid Diesel 3.0 D250 Hard Top (A)',
  'Defender 110 Plug-in Hybrid 2.0 X-Dynamic HSE 5-Seater (A)',
  'Defender 110 Plug-in Hybrid 2.0 X-Dynamic SE 5-Seater (A)',
  'Defender 90 2.0 300PS 5-Seater (A)',
  'Defender 90 2.0 SE 5-Seater (A)',
  'Defender 90 Mild Hybrid 3.0 75th Limited Edition (A)',
  'Defender 90 Mild Hybrid Diesel 3.0 D250 Hard Top (A)',
  'Discovery Sport Mild Hybrid 2.0 S 7-Seater (A)',
  'Dolphin Electric 44.9 kWh (A)',
  'Dyna 150 Diesel 2.8 E Package [Euro VI] (A)',
  'Dyna 150 Diesel 2.8 [Euro VI] (M)',
  'Dyna 150 Diesel 3.0 [Euro VI] (M)',
  'E Electric Advance 35.5 kWh (A)',
  'E-2008 Electric GT 54 kWh (A)',
  'e-Berlingo Electric 50 kWh (A)',
  'e-C4 Electric 50 kWh (A)',
  'e-C4 X Sedan Electric Shine 54 kWh (A)',
  'e-C4 X Sedan Electric Shine Plus 54 kWh (A)',
  'E-Class Cabriolet Mild Hybrid E300 AMG Line Night Edition Premium Plus (A)',
  'E-Class Coupe Mild Hybrid E300 AMG Line Night Edition Premium Plus (A)',
  'E-Class Coupe Mild Hybrid E53 AMG 4MATIC+ Night Edition Premium Plus (A)',
  'E-Class Saloon Diesel 2020 E220d Sport (A)',
  'E-Class Saloon Mild Hybrid 2020 E200 AMG Line (A)',
  'E-Class Saloon Mild Hybrid 2020 E200 AMG Line [UK] (A)',
  'E-Class Saloon Mild Hybrid 2020 E200 Exclusive (A)',
  'E-Class Saloon Mild Hybrid 2020 E200 Sport (A)',
  'E-Class Saloon Mild Hybrid E200 AMG Line (A)',
  'E-Class Saloon Mild Hybrid E200 AMG Line Advanced (A)',
  'E-Class Saloon Mild Hybrid E200 AMG Line Premium (A)',
  'E-Class Saloon Mild Hybrid E200 Avantgarde (A)',
  'E-Class Saloon Mild Hybrid E200 Exclusive (A)',
  'E-Class Saloon Plug-in Hybrid E300e AMG Line Premium Plus (A)',
  'E-Class Saloon Plug-in Hybrid E300e Avantgarde (A)',
  'E-Class Saloon Plug-in Hybrid E53 AMG 4MATIC+ (A)',
  'e-Dispatch Electric 75 kWh (A)',
  'e-Expert Electric 75 kWh (A)',
  'e-Partner Electric 50 kWh (A)',
  'e-Reliance Electric 41.86 kWh (A)',
  'e-Response Electric 41.86 kWh (A)',
  'e-tron Electric 50 qu 71 kWh (A)',
  'e-tron Sportback Electric 50 qu Advanced 71 kWh (A)',
  'E5 Electric [150kW] 61 kWh (A)',
  'E5 Electric [99kW] 61 kWh (A)',
  'e6 Electric 80 kWh (A)',
  'EA5 Electric 13+1 Seater 86.1 kWh (A)',
  'EC31 Electric 38.6 kWh (A)',
  'EC31 Electric 38.7 kWh (A)',
  'EC31 Refrigerated Electric 38.7 kWh (A)',
  'EC35 Electric 38.6 kWh (A)',
  'EC35 Gen 2 Electric 38.7 kWh (A)',
  'EC35II Electric 38.6 kWh (A)',
  'EC40 Electric Ultra 70 kWh (A)',
  'eDeliver 3 Electric 52.5 kWh (A)',
  'eDeliver 5 Electric 64 kWh (A)',
  'eDeliver 7 Electric 77 kWh (A)',
  'eDeliver 9 Electric 72 kWh (A)',
  'Eletre 112 kWh (A)',
  'Eletre R 112 kWh (A)',
  'Eletre S 112 kWh (A)',
  'Emeya 102 kWh (A)',
  'Emeya R 102 kWh (A)',
  'Emeya S 102 kWh (A)',
  'Emira First Edition (A)',
  'Enyaq Coupe Electric RS 82 kWh (A)',
  'Enyaq Coupe Electric Sportline 82 kWh (A)',
  'Enyaq Electric 82 kWh (A)',
  'Enyaq Electric Sportline 82 kWh (A)',
  'EQA Electric EQA250 AMG Line 66.5 kWh (A)',
  'EQA Electric EQA250 AMG Line Premium 66.5 kWh (A)',
  'EQA Electric EQA250+ Electric Art 70.5 kWh (A)',
  'EQA Electric EQA250+ Progressive 70.5 kWh (A)',
  'EQB Electric EQB250+ AMG Line Premium 70.5 kWh(A)',
  'EQB Electric EQB250+ Electric Art 70.5 kWh (A)',
  'EQB Electric EQB250+ Progressive 70.5 kWh (A)',
  'EQB Electric EQB300 4MATIC AMG Line Premium 66.5 kWh(A)',
  'EQB Electric EQB350 4MATIC AMG Line Premium 66.5 kWh (A)',
  'EQC Electric EQC400 4MATIC AMG Line Premium Plus 80 kWh (A)',
  'EQE Electric EQE 300 Electric Art 89 kWh (A)',
  'EQE Electric EQE 350 AMG Line 90.5 kWh (A)',
  'EQE Electric EQE 43 AMG 4MATIC 90.6 kWh (A)',
  'EQE Electric EQE 53 AMG 4MATIC+ 90.6 kWh (A)',
  'EQE Electric EQE300 AMG Line Premium 89 kWh (A)',
  'EQE Electric EQE350 + AMG Line Premium 90.56 kWh (A)',
  'EQE Electric EQE350 + Exclusive Luxury 90.56 kWh (A)',
  'EQE SUV Electric EQE 300 Electric Art 89kWh (A)',
  'EQE SUV Electric EQE 53 AMG 4MATIC+ 90.6 kWh (A)',
  'EQS Electric EQS450 + Exclusive Luxury 107.8 kWh (A)',
  'EQS Electric EQS450 + Premium 107.8 kWh (A)',
  'EQS Electric EQS450+ AMG Line Premium Hyperscreen 107.8 kWh (A)',
  'EQS Electric EQS450+ Electric Art 107.8 kWh (A)',
  'EQS Electric EQS53 AMG 4MATIC+ 107.8 kWh (A)',
  'EQS SUV Electric EQS450 4MATIC Electric Art 108 kWh (A)',
  'EQV Electric EQV300 Avantgarde 7-seater 90 kWh (A)',
  'EQV Electric EQV300 Sport Premium 7-seater 90 kWh (A)',
  'EQV Electric EQV300 Sport Premium Plus 7-seater 90 kWh (A)',
  'ES 300h Hybrid 2.5 Executive (A)',
  'ES 300h Hybrid 2.5 Luxury (A)',
  'ES Electric 55.2 kWh (A)',
  'eTruck Mate Electric Mini Truck 38.64 kWh (A)',
  'EV490 Electric 490-20 350 kWh (A)',
  'EV490 Electric 490-30 350 kWh (A)',
  'EV9 Electric GT-Line 99.8 kWh (A)',
  'Every Petrol 660 (A)',
  'eVito Electric 112 Van Long 60 kWh (A)',
  'eVito Electric Progressive L3 66 kWh (A)',
  'EW4 Electric 12+1 Seater 86.1 kWh (A)',
  'EW4 Electric 86.1 kWh (A)',
  'EX30 Electric Ultra 69 kWh (A)',
  'EX40 Electric Plus 70 kWh (A)',
  'F Series Diesel FVR90 SUQD-C [Euro VI] (M)',
  'F-PACE 2.0 R-Dynamic S (A)',
  'F-PACE 5.0 V8 SVR Edition 1988 (A)',
  'F-TYPE Coupe 2.0 R-Dynamic (A)',
  'F8 Tributo 3.9 V8 (A)',
  'Fairlady 3.0 Z V6 (M)',
  'Fit 1.3 Honda Sensing (A)',
  'Fit 1.5 (A)',
  'Fit 1.5 Honda Sensing (A)',
  'Fit 2017 1.3 G F-Package (A)',
  'Fit Hybrid 1.5 e:HEV (A)',
  'Fit Venture Cars Edition 1.5 (A)',
  'Flying Spur 4.0 V8 (A)',
  'Flying Spur 4.0 V8 Azure (A)',
  'Flying Spur 4.0 V8 S (A)',
  'Flying Spur 6.0 W12 (A)',
  'Flying Spur Plug-in Hybrid 2.9 V6 (A)',
  'Forester e-BOXER Mild Hybrid 2.0i-S EyeSight (A)',
  'Forfour Electric Premium 17.2 kWh (A)',
  'Fortwo Cabrio Electric EQ Premium 17.2 kWh (A)',
  'FR601 Electric 84.48 kWh (A)',
  'Freed 1.5 AIR EX 7-Seater (A)',
  'Freed 1.5 E7 (A)',
  'Freed 1.5 S7 (A)',
  'Freed 2020 1.5 G Honda Sensing Power Doors 7-Seater (A)',
  'Freed 2020 1.5 G LED Honda Sensing Power Doors 7-Seater (A)',
  'Freed Hybrid 1.5 AIR e:HEV (A)',
  'Freed Hybrid 1.5 AIR EX e:HEV (A)',
  'Freed Hybrid 1.5 HE7 e:HEV (A)',
  'Freed Hybrid 1.5 HS7 e:HEV (A)',
  'Freed Hybrid 2020 1.5 G 7-Seater (A)',
  'Freed Hybrid 2020 1.5 G Honda Sensing Dual Power Doors 7-Seater (A)',
  'Fuso Canter Diesel 3.0 10FT [Euro VI] (M)',
  'Fuso Canter Diesel 3.0 14FT [Euro VI] (A)',
  'Fuso Canter Diesel 3.0 14FT [Euro VI] (M)',
  'G-Class 1 Auto Cars Edition G63 AMG (A)',
  'G-Class Diesel G400d AMG Line Premium (A)',
  'G-Class Diesel G400d AMG Line Premium Plus (A)',
  'G-Class Diesel G400d AMG Line Premium Plus Manufaktur Edition (A)',
  'G-Class Diesel G400d Edition (A)',
  'G-Class G63 AMG (A)',
  'G-Class G63 AMG Grand Edition (A)',
  'G6 Electric Long Range 87.5 kWh (A)',
  'G6 Electric Standard Range 66 kWh (A)',
  'Ghibli Mild Hybrid 2.0 GT (A)',
  'Ghost 1 Auto Cars Edition 6.75 V12 (A)',
  'Ghost 6.75 V12 (A)',
  'Ghost 6.75 V12 Black Badge (A)',
  'Ghost 6.75 V12 Extended (A)',
  'Ghost Series II 6.6 (A)',
  'Ghost Series II 6.6 LWB (A)',
  'Giulia 2.0 Veloce (A)',
  'Giulia 2.9 Quadrifoglio (A)',
  'GLA-Class GLA200 AMG Line (A)',
  'GLA-Class GLA200 AMG Line Executive (A)',
  'GLA-Class GLA200 AMG Line Premium Plus (A)',
  'GLA-Class GLA200 Sport (A)',
  'GLA-Class GLA200 Sport Executive (A)',
  'GLA-Class Mild Hybrid GLA180 Progressive (A)',
  'GLA-Class Mild Hybrid GLA200 AMG Line (A)',
  'GLA-Class Mild Hybrid GLA35 AMG 4MATIC (A)',
  'GLB-Class GLB200 AMG Line 7-Seater (A)',
  'GLB-Class GLB200 AMG Line Premium 7-Seater (A)',
  'GLB-Class GLB200 AMG Line Premium Plus 7-Seater (A)',
  'GLB-Class GLB200 Sport 7-Seater (A)',
  'GLB-Class Mild Hybrid GLB180 Progressive (A)',
  'GLB-Class Mild Hybrid GLB200 AMG Line (A)',
  'GLB-Class Mild Hybrid GLB35 AMG 4MATIC (A)',
  'GLC-Class Coupe Mild Hybrid 2019 GLC300 4MATIC AMG Line (A)',
  'GLC-Class Coupe Mild Hybrid 2019 GLC300 4MATIC AMG Line Premium Plus (A)',
  'GLC-Class Coupe Mild Hybrid GLC300 4MATIC (A)',
  'GLC-Class Coupe Mild Hybrid GLC300 4MATIC AMG Line (A)',
  'GLC-Class Coupe Mild Hybrid GLC300 4MATIC AMG Line Premium Plus (A)',
  'GLC-Class Coupe Mild Hybrid GLC43 AMG 4MATIC (A)',
  'GLC-Class Coupe Plug-in Hybrid GLC 63 AMG 4MATIC S E Performance (A)',
  'GLC-Class Coupe Plug-in Hybrid GLC300e 4MATIC AMG Line (A)',
  'GLC-Class Mild Hybrid GLC300 4MATIC AMG Line (A)',
  'GLC-Class Mild Hybrid GLC300 4MATIC AMG Line Premium (A)',
  'GLC-Class Mild Hybrid GLC300 4MATIC AMG Line Premium Plus (A)',
  'GLC-Class Mild Hybrid GLC300 4MATIC Avantgarde (A)',
  'GLC-Class Mild Hybrid GLC43 AMG 4MATIC (A)',
  'GLC-Class Plug-in Hybrid GLC 63 AMG 4MATIC S E Performance (A)',
  'GLC-Class Plug-in Hybrid GLC300e 4MATIC AMG Line (A)',
  'GLC-Class Plug-in Hybrid GLC300e 4MATIC Avantgarde (A)',
  'GLE-Class Coupe Diesel GLE400d 4MATIC AMG Line Premium Plus (A)',
  'GLE-Class Coupe Mild Hybrid GLE53 AMG 4MATIC+ (A)',
  'GLE-Class Coupe Mild Hybrid GLE53 AMG 4MATIC+ Premium Plus (A)',
  'GLE-Class Coupe Mild Hybrid GLE63 AMG 4MATIC+ (A)',
  'GLE-Class Diesel GLE300d 4MATIC AMG Line Premium Plus (A)',
  'GLE-Class Mild Hybrid 1 Auto Cars Edition GLE450 4MATIC AMG Line Premium Plus 7-Seater (A)', // @suppress longLineCheck
  'GLE-Class Mild Hybrid GLE450 4MATIC (A)',
  'GLE-Class Mild Hybrid GLE450 4MATIC AMG Line 7-Seater (A)',
  'GLE-Class Mild Hybrid GLE450 4MATIC AMG Line Premium 7-Seater (A)',
  'GLE-Class Mild Hybrid GLE450 4MATIC AMG Line Premium Plus 7-Seater (A)',
  'GLE-Class Mild Hybrid GLE450 4MATIC Sport Luxury (A)',
  'GLE-Class Mild Hybrid GLE53 AMG 4MATIC+ (A)',
  'GLS-Class Diesel GLS400d 4MATIC AMG Line Premium 7-Seater (A)',
  'GLS-Class Diesel GLS400d 4MATIC AMG Line Premium Plus 7-Seater (A)',
  'GLS-Class Mild Hybrid GLS450 4MATIC (A)',
  'GLS-Class Mild Hybrid GLS450 AMG 4MATIC (A)',
  'Golf GTI 2.0 TSI DSG (A)',
  'Golf Mild Hybrid 1.5 eTSI DSG Life Plus (A)',
  'Golf Mild Hybrid 1.5 eTSI DSG R-Line (A)',
  'Golf R 2.0 TSI DSG (A)',
  'Golf R 2.0 TSI DSG Performance Pack (A)',
  'Good Cat Electric 63 kWh (A)',
  'Good Cat Electric GT-Line 63 kWh (A)',
  'GR Supra 3.0 (A)',
  'GR Yaris 1.6 (M)',
  'GR Yaris 1.6 Convenience Pack (M)',
  'GR86 2.4 (A)',
  'GR86 2.4 (M)',
  'GR86 2.4 RC (M)',
  'Granace Diesel 2.8 G 8-Seater (A)',
  'GranCabrio 4.7 Sport (A)',
  'Grand Cherokee L 3.6 Limited 7-Seater (A)',
  'GranTurismo 3.0 Modena (A)',
  'Grecale 3.0 Trofeo (A)',
  'Grecale Mild Hybrid 2.0 GT (A)',
  'Grecale Mild Hybrid 2.0 Modena (A)',
  'GT 4.0 V8 (A)',
  'H5C 70.47 kWh (A)',
  'H5F Electric 50.23 kWh (A)',
  'H5F Standard Roof Electric 50.23 kWh (A)',
  'H9E Electric 14 Footer 106.95 kWh (A)',
  'H9E Electric 20 Footer 162.28 kWh (A)',
  'Harrier Hybrid 2.5 G (A)',
  'Harrier Hybrid 2.5 Premium (A)',
  'Harrier Hybrid 2.5 S (A)',
  'Hiace Diesel 2.8 Super GL Dark Prime [Euro VI] (A)',
  'Hiace High Roof Diesel 2.8 GL Commuter 14-Seater [Euro VI] (A)',
  'Hiace Standard Roof Diesel 2.8 DX Bus [Euro VI] (A)',
  'Hiace Standard Roof Diesel 2.8 DX Glass Door Van [Euro VI] (A)',
  'Hiace Standard Roof Diesel 2.8 DX Van [Euro VI] (A)',
  'Hiace Standard Roof Diesel 3.0 DX Van [Euro VI] (A)',
  'Hiace Standard Roof Diesel 3.0 DX Van [Euro VI] (M)',
  'Hiace Standard Roof Petrol 2.0 DX Glass Door Van (A)',
  'Highlander Hybrid 2.5 Excel Premium 7-Seater (A)',
  'Hilux Double Cab Diesel 2.4 Invincible X [Euro VI] (A)',
  'HR-V 1.5 DX (A)',
  'HR-V 1.5 DX+ (A)',
  'HR-V Hybrid 1.5 HX e:HEV (A)',
  'Huayra 6.0 (A)',
  'I-PACE Electric SE 90 kWh (A)',
  'i4 Gran Coupe Electric eDrive35 M Sport 67.1 kWh (A)',
  'i4 M50 Gran Coupe Electric xDrive 81.1 kWh (A)',
  'i5 Electric eDrive40 81.2 kWh (A)',
  'i5 Electric eDrive40 M Sport 81.2 kWh (A)',
  'i5 M60 Electric xDrive 81.2 kWh (A)',
  'i5 Touring Electric eDrive40 M Sport 81.2 kWh (A)',
  'i7 Electric eDrive50 M Sport 101.7 kWh (A)',
  'i7 Electric eDrive50 Pinnacle 101.7 kWh (A)',
  'i7 Electric xDrive60 M Sport Pro 101.7 kWh (A)',
  'i7 Electric xDrive60 Pinnacle 101.7 kWh (A)',
  'i7 Electric xDrive60 Pure Excellence 101.7 kWh (A)',
  'i7 M70 Electric xDrive 101.7 kWh (A)',
  'Iblue T5 Electric Truck 81.14 kWh (A)',
  'Iblue V6 Electric Commuter Bus 12-Seater 50.23 kWh (A)',
  'Iblue V6 Electric Van 50.23 kWh (A)',
  'ID. Buzz Cargo Electric 79 kWh (A)',
  'ID. Buzz Cargo Electric 82 kWh (A)',
  'ID. Buzz Electric Pro LWB 6-Seater 86 kWh (A)',
  'ID. Buzz Electric Pro LWB 7-Seater 86 kWh (A)',
  'ID. Buzz Electric Pro NWB 5-Seater 79 kWh (A)',
  'ID.3 Electric Life Pro Performance 58 kWh (A)',
  'ID.4 Electric 1st Edition 77 kWh (A)',
  'ID.4 Electric 82 kWh (A)',
  'ID.4 GTX Electric 82 kWh (A)',
  'ID.5 Electric 82 kWh (A)',
  'ID.5 GTX Electric 82 kWh (A)',
  'Ioniq 5 Electric Exclusive 58 kWh (A)',
  'Ioniq 5 Electric Inspiration 77 kWh (A)',
  'Ioniq 5 Electric Prestige 58 kWh (A)',
  'Ioniq 5 Electric Prestige 77 kWh (A)',
  'Ioniq 5 N Electric AWD 84 kWh (A)',
  'Ioniq 6 Electric Exclusive 53 kWh (A)',
  'Ioniq 6 Electric Inspiration 77 kWh (A)',
  'Ioniq 6 Electric Prestige 53 kWh (A)',
  'Ioniq 6 Electric Prestige 77 kWh (A)',
  'IS 300h Hybrid 2.5 Executive (A)',
  'iX Electric xDrive40 M Sport 76.6 kWh (A)',
  'iX Electric xDrive40 Sport 76.6 kWh (A)',
  'iX1 Electric eDrive20 xLine 64.8 kWh (A)',
  'iX2 Electric eDrive20 M Sport 64.8 kWh (A)',
  'iX3 Electric M Sport Impressive 73.9 kWh (A)',
  'iX3 Electric M Sport Inspiring 73.9 kWh (A)',
  'J7 Plug-in Hybrid 1.5 (A)',
  'Jazz Crosstar Hybrid 1.5 e:HEV [Monotone] (A)',
  'Jazz Crosstar Hybrid 1.5 X e:HEV [Dual Tone] (A)',
  'Jazz Hybrid 1.5 Luxe e:HEV (A)',
  'Jimny 1.5 Standard (A)',
  'Jimny 1.5 Standard Two-Tone (A)',
  'Jimny 5-Door AllGrip Pro Alpha 1.5 (A)',
  'John Cooper Works Countryman ALL4 2.0 (A)',
  'John Cooper Works GP 2.0 (A)',
  'Kamiq 1.0 TSI Selection',
  'Kangoo E-Tech Electric 46 kWh (A)',
  'Kicks e-POWER Hybrid Premium (A)',
  'Kicks e-POWER Hybrid Premium Plus (A)',
  'Kodiaq Mild Hybrid 1.5 TSI Selection 7-Seater (A)',
  'Kona Electric Long Range Sunroof 64.8 kWh (A)',
  'Kona Electric Standard Range 48.6 kWh (A)',
  'Kona Electric Standard Range Sunroof 48.6 kWh (A)',
  'Kona Hybrid 1.6 Elite (A)',
  'Kona Hybrid 1.6 GL (A)',
  'Korando Electric e-Motion 61.5 kWh (A)',
  'Land Cruiser 250 2.7 VX 7-Seater (A)',
  'Land Cruiser 250 2.7 VX First Edition 7-Seater (A)',
  'Land Cruiser 300 3.5 GR Sport 7-Seater (A)',
  'Land Cruiser 300 3.5 ZX 7-Seater (A)',
  'Land Cruiser Prado 2.7 TX 7-Seater (A)',
  'Land Cruiser Prado 2.7 TX L 7-Seater (A)',
  'Land Cruiser Prado 2.7 TX L Night Edition  7-Seater (A)',
  'Landy Hybrid 1.8 G (A)',
  'LBX Hybrid 1.5 Cool (A)',
  'LBX Hybrid 1.5 Elegant (A)',
  'LC 500 Convertible 5.0 V8 (A)',
  'Leaf Electric 40 kWh (A)',
  'Levante 3.0 S (A)',
  'LM Hybrid 2.4 Ultra Luxury 500h (A)',
  'LM Hybrid 2.5 350h (A)',
  'LM Hybrid 2.5 Luxury 350h (A)',
  'LS Hybrid 3.5 V6 500h Luxury (A)',
  'LX 600 3.5 V6 7-Seater (A)',
  'LX 600 3.5 V6 F-Sport 5-Seater (A)',
  'M135 2.0 xDrive (A)',
  'M2 Coupe 3.0 (A)',
  'M235i Gran Coupe 2.0 xDrive (A)',
  'M240i Coupe 3.0 xDrive (A)',
  'M3 Sedan 3.0 Competition Launch Edition (A)',
  'M3 Sedan 3.0 Competition M xDrive (A)',
  'M3 Touring 3.0 Competition M xDrive (A)',
  'M340i 3.0 xDrive (A)',
  'M4 Convertible 3.0 Competition M xDrive (A)',
  'M4 Coupe 3.0 Competition (A)',
  'M4 Coupe 3.0 Competition M xDrive (A)',
  'M4 Coupe 3.0 CS (A)',
  'M5 Sedan Plug-in Hybrid 4.4 (A)',
  'M6 Electric 7-Seater 71.8 kWh (A)',
  'M8 Coupe 4.4 xDrive Competition (A)',
  'M9 EV Grand Trophy 90kWh',
  'M9 EV Trophy 90kWh',
  'Macan 2.0 (A)',
  'Macan Electric Turbo 100kWh (A)',
  'Macan GTS 2.9 (A)',
  'Macan PDK 2.0 (A)',
  'Macan S 2.9 (A)',
  'Macan S PDK 3.0 (A)',
  'Macan T 2.0 (A)',
  'Maybach EQS Electric EQS 680 4MATIC 118 kWh (A)',
  'Maybach EQS Electric EQS 680 4MATIC Night Series 118 kWh (A)',
  'Maybach GLS-Class 1 Auto Cars Edition GLS600 4MATIC (A)',
  'Maybach GLS-Class GLS600 4MATIC (A)',
  'Maybach GLS-Class Mild Hybrid GLS600 4MATIC (A)',
  'Maybach S-Class Mild Hybrid S580 4MATIC (A)',
  'Maybach S-Class Mild Hybrid S680 4MATIC (A)',
  'Maybach S-Class S680 4MATIC First Class (A)',
  'MC20 3.0 V6 (A)',
  'MIFA 7 Electric Luxury 90 kWh (A)',
  'MIFA 7 Electric Premium 90 kWh (A)',
  'MIFA 9 Electric Luxury 90 kWh (A)',
  'MIFA 9 Electric Premium 90 kWh (A)',
  'Model 3 Electric Long Range AWD 78 kWh (A)',
  'Model 3 Electric Performance AWD 78 kWh (A)',
  'Model 3 Electric RWD 110 60 kWh (A)',
  'Model 3 Electric RWD 60 kWh (A)',
  'Model Y Electric Long Range AWD 78 kWh (A)',
  'Model Y Electric Performance AWD 78 kWh (A)',
  'Model Y Electric RWD 60 kWh (A)',
  'Mokka-e Electric 50 kWh (A)',
  'Mono 2.5 (A)',
  'Mono R 2.5 (A)',
  'MX-30 Electric 35.5 kWh (A)',
  'MX-30 Electric Exclusive Line [UK] 35.5 kWh (A)',
  'MX-30 Electric Sport Luxury 35.5 kWh (A)',
  'MX-5 RF 2.0 (A)',
  'Myvi 1.3 X (A)',
  'N Series Diesel NHR 85 10FT [Euro VI] (M)',
  'N Series Diesel NJR88 AUE4A 10FT [Euro VI] (A)',
  'N Series Diesel NNR 85 15FT [Euro VI] (M)',
  'N Series Diesel NPR 85 15FT [Euro VI] (M)',
  'N Series Diesel NPR75 UH5A 15FT [Euro VI] (A)',
  'N Series Diesel NPR75 UH5A 15FT [Euro VI] (M)',
  'N Series Diesel NPR85 UH5A 15 FT [Euro VI] (A)',
  'N Series Diesel NPR85 UH5A 15FT [Euro VI] (M)',
  'N-Box Custom L Turbo (A)',
  'N-Box Custom Turbo (A)',
  'N-Box L (A)',
  'N-Van Petrol 660 Turbo Style Fun Honda Sensing (A)',
  'Niro Electric 64.8 kWh (A)',
  'Niro Hybrid 1.6 EX (A)',
  'Niro Hybrid 1.6 EX Comfort Pack (A)',
  'Niro Hybrid 1.6 SX (A)',
  'Niro Plus Electric 64 kWh (A)',
  'Noah Hybrid 1.8 SG 7-Seater (A)',
  'Noah Hybrid 1.8 SZ 7-Seater (A)',
  'Noah Hybrid 1.8 X 7-Seater (A)',
  'Noah Hybrid 2017 1.8 X 7-Seater (A)',
  'Noah Hybrid Vin\'s Auto Edition 1.8 SZ 7-Seater (A)',
  'Noah Hybrid Vin\'s Auto Edition 1.8 X 7-Seater (A)',
  'Note e-POWER Hybrid Premium (A)',
  'NV200 Petrol 1.6 CVT (A)',
  'NV200 Petrol 1.6 Panel Van (A)',
  'NV350 Petrol 2.0 DX (A)',
  'NX 350h Hybrid 2.5 Executive (A)',
  'NX 350h Hybrid 2.5 Luxury (A)',
  'NX 450h+ Plug-in Hybrid 2.5 F Sport (A)',
  'Octavia Mild Hybrid 1.0 TSI e-TEC Ambition (A)',
  'Octavia Mild Hybrid 1.0 TSI e-TEC Style (A)',
  'Odyssey Hybrid 2.0 Absolute 7-Seater e:HEV (A)',
  'Odyssey Hybrid 2.0 Absolute EX 7-Seater e:HEV (A)',
  'Palisade 3.5 V6 7-seater Sunroof (A)',
  'Panamera 2.9 (A)',
  'Panamera PDK 2.9 (A)',
  'Panamera Plug-in Hybrid 4 2.9 (A)',
  'Panamera Plug-in Hybrid 4S 2.9 (A)',
  'Panamera Plug-in Hybrid Turbo 4.0 (A)',
  'Phantom 1 Auto Cars Edition 6.75 (A)',
  'Phantom 1 Auto Cars Edition 6.75 Extended Wheelbase (A)',
  'Phantom 6.75 (A)',
  'Phantom 6.75 Extended Wheelbase (A)',
  'Phantom 6.75 V12 Extended Series II (A)',
  'Phantom 6.75 V12 Series II (A)',
  'Plus Four 2.0 (A)',
  'Plus Four 2.0 (M)',
  'Plus Six 3.0 Bespoke (A)',
  'Prius Hybrid 1.8 (A)',
  'Prius Hybrid 1.8 X (A)',
  'Prius Hybrid 2016 1.8 E (A)',
  'Proace City Electric Long Panel Van 50 kWh (A)',
  'Proace Electric 75 kWh (A)',
  'Proace Electric Bus 75 kWh (A)',
  'Proace Electric Icon 75 kWh (A)',
  'Purosangue 6.5 V12 (A)',
  'Q2 1.5 TFSI S tronic (A)',
  'Q3 Mild Hybrid 1.5 TFSI S tronic (A)',
  'Q3 Sportback Mild Hybrid 1.5 TFSI S tronic (A)',
  'Q4 e-tron Electric 45 Advanced 82 kWh (A)',
  'Q4 e-tron Electric 45 Edition 1 82 kWh (A)',
  'Q4 Sportback e-tron Electric 45 Advanced 82 kWh (A)',
  'Q4 Sportback e-tron Electric 45 Edition 1 82 kWh (A)',
  'Q5 Mild Hybrid 2.0 TFSI qu S tronic S Line (A)',
  'Q5 Mild Hybrid 2.0 TFSI qu S tronic [204hp] (A)',
  'Q5 Sportback Mild Hybrid 2.0 TFSI qu S tronic Advanced [204hp] (A)',
  'Q7 Mild Hybrid 3.0 Sport 55 TFSI qu tip 7-Seater (A)',
  'Q8 e-tron Electric 50 qu Advanced 95 kWh (A)',
  'Q8 Sportback e-tron Electric 50 qu S Line 95 kWh (A)',
  'Quattroporte 3.0 S (A)',
  'Quattroporte 3.8 GTS (A)',
  'Raize 1.0 X (A)',
  'Raize 1.2 X (A)',
  'Raize Hybrid 1.2 G (A)',
  'Range Rover Evoque Mild Hybrid 2.0 S (A)',
  'Range Rover Mild Hybrid 3.0 Autobiography (A)',
  'Range Rover Mild Hybrid 4.4 Autobiography LWB 5-Seater (A)',
  'Range Rover Mild Hybrid 4.4 Autobiography LWB 7-Seater (A)',
  'Range Rover Plug-in Hybrid 3.0 Autobiography (A)',
  'Range Rover Sport Mild Hybrid 3.0 Dynamic HSE (A)',
  'Range Rover Sport Mild Hybrid 3.0 S (A)',
  'Range Rover Velar Mild Hybrid 3.0 S (A)',
  'Ranger Raptor Diesel 2.0 Double Cab (A)',
  'Ranger Raptor Petrol 3.0 Double Cab (A)',
  'Ranger Wildtrak Diesel 2.0 Double Cab (A)',
  'RAV4 Hybrid 2.5 Premium (A)',
  'RAV4 Hybrid 2.5 X (A)',
  'Revuelto Plug-in Hybrid 6.5 V12 (A)',
  'Rock Star 1.5 S (A)',
  'Roma 1 Auto Cars Edition 3.9 V8 (A)',
  'Roma 3.9 V8 (A)',
  'Roma Spider 3.9 V8 (A)',
  'RS 3 Sedan 2.5 TFSI qu S tronic (A)',
  'RS 4 Avant 2.9 TFSI qu Tip (A)',
  'RS 6 Avant Mild Hybrid 4.0 TFSI qu Tip (A)',
  'RS e-tron GT Electric qu 93 kWh (A)',
  'RX 350h Hybrid 2.5 Executive (A)',
  'RX 350h Hybrid 2.5 Luxury (A)',
  'RX 450h+ Plug-in Hybrid 2.5 Luxury (A)',
  'RX 500h Hybrid 2.4 F Sport (A)',
  'RZ Electric 450e Executive 71.4 kWh (A)',
  'RZ Electric 450e Luxury 71.4 kWh (A)',
  'S-Class Diesel S350d L AMG Line Premium (A)',
  'S-Class Diesel S350d L AMG Premium Executive (A)',
  'S-Class Diesel S350d L AMG Premium Plus Executive (A)',
  'S-Class Diesel S350d L Premium Plus (A)',
  'S-Class Mild Hybrid S450L 4MATIC (A)',
  'S-Class Mild Hybrid S500L 4MATIC AMG Line Premium (A)',
  'S-Class Mild Hybrid S500L 4MATIC AMG Line Premium Executive (A)',
  'S-Class Mild Hybrid S500L 4MATIC AMG Line Premium Plus (A)',
  'S-Class Mild Hybrid S500L 4MATIC AMG Line Premium Plus Executive (A)',
  'S8 Mild Hybrid 4.0 TFSI qu Tip (A)',
  'S90 Mild Hybrid B5 Ultimate (A)',
  'Santa Fe Turbo Hybrid 1.6 7-Seater (A)',
  'Santa Fe Turbo Hybrid 1.6 Calligraphy 6-Seater (A)',
  'Santa Fe Turbo Hybrid 1.6 Calligraphy 7-Seater (A)',
  'Seal Electric Dynamic [100kW] 61.4 kWh (A)',
  'Seal Electric Performance 82.6 kWh (A)',
  'Seal Electric Premium 82.6 kWh (A)',
  'Serena e-POWER Hybrid 1.4 Highway Star V 7-Seater (A)',
  'Serena e-POWER Hybrid 1.4 Highway Star V 8-Seater (A)',
  'Serena e-POWER Hybrid Highway Star Prestige 7-Seater [DualTone](A)',
  'Serena e-POWER Hybrid Highway Star Prestige 7-Seater [SingleTone](A)',
  'Serena e-POWER Hybrid Premium 8-seater (A)',
  'SF90 Stradale Plug-in Hybrid 4.0 V8 (A)',
  'SF90 Stradale Plug-in Hybrid 4.0 V8 Assetto Fiorano (A)',
  'Shuttle 1.5 G Keyless/Navi Honda Sensing (A)',
  'Shuttle 1.5 G LED Honda Sensing (A)',
  'Shuttle Hybrid 1.5 (A)',
  'Shuttle Hybrid 1.5 LED Honda Sensing (A)',
  'Sienta Hybrid 1.5 Elegance (A)',
  'Sienta Hybrid 1.5 G 7-Seater (A)',
  'Sienta Hybrid 1.5 X 7-Seater (A)',
  'Sienta Hybrid 1.5 Z 7-Seater (A)',
  'SL-Class Cabriolet SL43 AMG (A)',
  'SL-Class Cabriolet SL43 AMG Premium Plus (A)',
  'SL-Class Cabriolet SL43 AMG Touring Plus (A)',
  'SL-Class Cabriolet SL55 AMG 4MATIC + Premium Plus (A)',
  'SL-Class Cabriolet SL55 AMG 4MATIC+ (A)',
  'SL-Class Cabriolet SL63 AMG 4MATIC+ (A)',
  'Sorento Hybrid 1.6 SX 7-Seater (A)',
  'Sorento Hybrid 1.6 SX Tech Pack 7-Seater (A)',
  'Spacia Base Petrol 658 GFs (A)',
  'Spacia Base Petrol 658 XFs (A)',
  'Spacia Mild Hybrid 658 G Welcab (A)',
  'Spectre Electric 102 kWh (A)',
  'SQ8 4.0 TFSI qu Tip (A)',
  'Staria 3.5 V6 Sunroof (A)',
  'Stelvio 2.0 Veloce (A)',
  'Stelvio 2.9 Quadrifoglio (A)',
  'Stepwagon Hybrid 2.0 Spada 7-Seater Honda Sensing e:HEV (A)',
  'Stepwagon Hybrid 2.0 Spada 8-Seater Honda Sensing e:HEV (A)',
  'Stepwagon Hybrid 2.0 Spada Premium Line 7-Seater e:HEV (A)',
  'Stepwagon Hybrid Vin\'s Auto Edition 2.0 Spada 7-Seater Honda Sensing e:HEV (A)', // @suppress longLineCheck
  'SuperVan Electric 5.5HR 83 kWh (A)',
  'SuperVan Electric 5.5MR 83 kWh (A)',
  'SuperVan Electric 5FR 66 kWh (A)',
  'SuperVan Electric 5FR 83 kWh (A)',
  'SuperVan Electric 6HR 106 kWh (A)',
  'Swift Mild Hybrid 1.2 Standard (A)',
  'Swift Mild Hybrid 1.2 Standard Two-Tone (A)',
  'T-Cross 1.0 TSI DSG R-Line (A)',
  'T-Cross 1.0 TSI DSG Style (A)',
  'T3 Electric 44.9 kWh (A)',
  'T3 Electric 50.3 kWh (A)',
  'T3EV Electric 53.58 kWh (A)',
  'T90 Electric Double Cab 88.6 kWh (A)',
  'T90 EV Electric 88.5 kWh (A)',
  'Taycan Cross Turismo Electric 4 93.4 kWh (A)',
  'Taycan Cross Turismo Electric 4S 93.4 kWh (A)',
  'Taycan Cross Turismo Electric Turbo 93.4 kWh (A)',
  'Taycan Electric 4S 79.2 kWh (A)',
  'Taycan Electric 4S Performance Battery 79.2 kWh (A)',
  'Taycan Electric 79.2 kWh (A)',
  'Taycan Electric GTS 93.4 kWh (A)',
  'Taycan Electric Performance Battery 79.2 kWh (A)',
  'Taycan Electric Turbo 93.4 kWh (A)',
  'Taycan Electric Turbo S 93.4 kWh (A)',
  'Temerario Plug-in Hybrid 4.0 V8 (A)',
  'Tiguan Mild Hybrid 1.5 eTSI Life (A)',
  'Tiguan Mild Hybrid 1.5 eTSI Life Plus (A)',
  'Tivoli Diesel 1.6 Standard (A)',
  'Tonale Mild Hybrid 1.5 Veloce (A)',
  'Townace Petrol 1.5 GL (A)',
  'Transporter Diesel T30 Panel Van LED [Euro VI] (A)',
  'Transporter Diesel T30 Panel Van [Euro VI] (A)',
  'TT Coupe 2.0 TFSI S tronic (A)',
  'Urus 4.0 S V8 (A)',
  'Urus 4.0 V8 (A)',
  'Urus Performante 4.0 V8 (A)',
  'Urus Plug-in Hybrid SE 4.0 V8 (A)',
  'Urus S 4.0 V8 (A)',
  'UX 300h Hybrid 2.0 Luxury (A)',
  'V-Class Diesel V 250 CDI Extra Long [Euro VI] (A)',
  'V-Class Diesel V220d AMG Line Extra Long (A)',
  'V-Class Diesel V220d AMG Line Long (A)',
  'V-Class Diesel V220d Avantgarde Long (A)',
  'V-Class Diesel V300d AMG Line Extra Long (A)',
  'V60 Mild Hybrid B4 Plus (A)',
  'V7 Electric 50.23 kWh (A)',
  'Vantage 4.0 V8 (A)',
  'Vellfire 2.4 Turbo Z Premium (A)',
  'Vellfire 2018 2.5 Z G-Edition 7-Seater (A)',
  'Vellfire Hybrid 2.5 Elegance (A)',
  'Vellfire Hybrid 2.5 Executive Lounge (A)',
  'Vellfire Hybrid 2.5 Z Premium (A)',
  'Vezel 1.5 G Honda Sensing (A)',
  'Vezel Hybrid 1.5 X Honda Sensing e:HEV (A)',
  'Vezel Vin\'s Auto Edition 1.5 G Honda Sensing (A)',
  'Viewt 1.2 ST (A)',
  'Vito Diesel 114 CDI Eco Panel Van \'Long\' [Euro VI] (A)',
  'Vito Diesel 114 CDI Pro Panel Van \'Long\' 5-Door [Euro VI] (A)',
  'Vito Diesel 114 CDI Pro Panel Van \'Long\' 6-Door [Euro VI] (A)',
  'Vito Tourer Diesel 116 CDI Blue Tec Extra Long [Euro VI] (A)',
  'Vivaro-e Electric 75 kWh (A)',
  'Vivaro-e Electric Crew Seating Configuration 75 kWh (A)',
  'VN5 Plug-in Hybrid 1.5 (A)',
  'Voxy 2.0 X Wheelchair slope type Welcab (A)',
  'Voxy Hybrid 1.8 SG 7-Seater (A)',
  'Voxy Hybrid 1.8 SZ 7-Seater (A)',
  'WR-V 1.5 X (A)',
  'WR-V 1.5 Z (A)',
  'WR-V 1.5 Z + (A)',
  'WR-V Vin\'s Auto Edition 1.5 X (A)',
  'WR-V Vin\'s Auto Edition 1.5 Z (A)',
  'Wraith 1 Auto Cars Edition 6.6 V12 (A)',
  'Wraith 6.6 V12 (A)',
  'Wrangler Rubicon 4-Door 2.0 Turbo (A)',
  'Wrangler Sahara 4-Door 2.0 Turbo (A)',
  'X Electric Flagship AWD 66 kWh (A)',
  'X Electric Standard RWD 66 kWh (A)',
  'X-Trail e-POWER e-4ORCE Hybrid Prestige [Dual-Tone] (A)',
  'X-Trail e-POWER e-4ORCE Hybrid Prestige [Single-Tone] (A)',
  'X-Trail e-POWER Hybrid 1.5 X (A)',
  'X1 M35i xDrive M Sport Pro (A)',
  'X1 sDrive16i Inspiring (A)',
  'X1 sDrive16i M Sport (A)',
  'X2 M35i 2.0 xDrive (A)',
  'X2 sDrive16i M Sport (A)',
  'X3 M50 Mild Hybrid 3.0 xDrive (A)',
  'X3 Mild Hybrid xDrive 20 (A)',
  'X3 Mild Hybrid xDrive 20 M Sport (A)',
  'X4 Mild Hybrid xDrive20i M Sport (A)',
  'X4 Mild Hybrid xDrive30i M Sport (A)',
  'X5 Mild Hybrid xDrive40i 7-Seater (A)',
  'X6 Mild Hybrid xDrive40i M Sport Pro (A)',
  'X7 M60i Mild Hybrid 4.4 xDrive 6-seater (A)',
  'X7 xDrive40i 7-Seater (A)',
  'X7 xDrive40i M Sport 7-Seater (A)',
  'XC40 Mild Hybrid B4 Plus (A)',
  'XC60 Mild Hybrid B5 Plus (A)',
  'XC60 Plug-in Hybrid T8 Plus (A)',
  'XC90 Mild Hybrid B5 Ultra 7-seater (A)',
  'XD3 Diesel 3.0 (A)',
  'XF 2.0 R-Dynamic S (A)',
  'XM Plug-in Hybrid 4.4 (A)',
  'XML5036 Minibus Electric 11-Seater 50.23 kWh (A)',
  'XML6107 Diesel 45+1 Seater 1-door [Euro VI] (M)',
  'XML6107 Diesel 45+1 Seater 2-door [Euro VI] (M)',
  'XML6112 Diesel 6.7 [Euro VI] (A)',
  'XML6129 Diesel 49-Seater 2-door [Euro VI] (A)',
  'XML6129 Diesel 53-Seater 1-door [Euro VI] (A)',
  'XML6957 Diesel 43+1 Seater 1-door [Euro VI] (M)',
  'Y Plus Electric 63.2 kWh (A)',
  'Y Plus Electric Premium 63.2 kWh (A)',
  'Yaris Cross 1.5 X (A)',
  'Yaris Cross 1.5 XB (A)',
  'Yaris Cross Hybrid 1.5 Active (A)',
  'Yaris Cross Hybrid 1.5 X (A)',
  'Yaris Cross Hybrid 1.5 Z (A)',
  'Z4 Roadster sDrive20i M Sport (A)',
  'Zafira-e Life Electric 50 kWh (A)',
  'ZK6117H 49 Seater (A)',
  'ZR-V Hybrid 2.0 X Honda Sensing e:HEV (A)',
  'ZR-V Hybrid 2.0 Z Honda Sensing e:HEV (A)',
  'ZS EV Trophy 51 kWh (A)',
];

export const searchPastCarsAutoCompleteList = [
  'Aion ES Electric',
  'Aion V Electric',
  'Aion Y Plus Electric',
  'Alfa Romeo 147',
  'Alfa Romeo 156 Sportwagon',
  'Alfa Romeo 156',
  'Alfa Romeo 159 Sportwagon',
  'Alfa Romeo 159',
  'Alfa Romeo 166',
  'Alfa Romeo 4C',
  'Alfa Romeo Brera',
  'Alfa Romeo GT',
  'Alfa Romeo Giulia',
  'Alfa Romeo Giulietta',
  'Alfa Romeo MiTo',
  'Alfa Romeo Spider',
  'Alfa Romeo Stelvio',
  'Alfa Romeo Tonale Mild Hybrid',
  'Alpine A110',
  'Aston Martin DB11 Volante',
  'Aston Martin DB11',
  'Aston Martin DB12 Volante',
  'Aston Martin DB12',
  'Aston Martin DB9 Volante',
  'Aston Martin DB9',
  'Aston Martin DBS Volante',
  'Aston Martin DBS',
  'Aston Martin DBX',
  'Aston Martin DBX707',
  'Aston Martin Rapide S',
  'Aston Martin Rapide',
  'Aston Martin V12 DBS',
  'Aston Martin V12 Vantage S',
  'Aston Martin V12 Vantage',
  'Aston Martin V8 Vantage Roadster',
  'Aston Martin V8 Vantage S Roadster',
  'Aston Martin V8 Vantage S',
  'Aston Martin V8 Vantage',
  'Aston Martin Vanquish Volante',
  'Aston Martin Vanquish',
  'Aston Martin Vantage',
  'Aston Martin Virage Volante',
  'Aston Martin Virage',
  'Audi A1 Sportback',
  'Audi A1',
  'Audi A3 Cabriolet',
  'Audi A3 Sedan Mild Hybrid',
  'Audi A3 Sedan',
  'Audi A3 Sportback Mild Hybrid',
  'Audi A3 Sportback',
  'Audi A4 Allroad',
  'Audi A4 Avant Mild Hybrid',
  'Audi A4 Avant',
  'Audi A4 Cabriolet',
  'Audi A4 Sedan Mild Hybrid',
  'Audi A4 Sedan',
  'Audi A4',
  'Audi A5 Cabriolet 2013',
  'Audi A5 Cabriolet Mild Hybrid',
  'Audi A5 Cabriolet',
  'Audi A5 Coupe Diesel',
  'Audi A5 Coupe Mild Hybrid',
  'Audi A5 Coupe',
  'Audi A5 Sportback Mild Hybrid',
  'Audi A5 Sportback',
  'Audi A6 Avant Diesel',
  'Audi A6 Avant Mild Hybrid',
  'Audi A6 Avant',
  'Audi A6 Hybrid',
  'Audi A6 Sedan Mild Hybrid',
  'Audi A6 Sedan Plug-in Hybrid',
  'Audi A6',
  'Audi A7 Sportback 2015',
  'Audi A7 Sportback Diesel',
  'Audi A7 Sportback Mild Hybrid',
  'Audi A7 Sportback',
  'Audi A8 Diesel',
  'Audi A8 Mild Hybrid',
  'Audi A8',
  'Audi A8L Mild Hybrid',
  'Audi A8L Plug-in Hybrid',
  'Audi A8L',
  'Audi Q2',
  'Audi Q3 2016',
  'Audi Q3 Mild Hybrid',
  'Audi Q3 Sportback Mild Hybrid',
  'Audi Q3 Sportback',
  'Audi Q3',
  'Audi Q4 Sportback e-tron Electric',
  'Audi Q4 e-tron Electric',
  'Audi Q5 Mild Hybrid',
  'Audi Q5 Sportback Mild Hybrid',
  'Audi Q5',
  'Audi Q7 Diesel',
  'Audi Q7 Hybrid',
  'Audi Q7 Mild Hybrid',
  'Audi Q7',
  'Audi Q8 Diesel Mild Hybrid',
  'Audi Q8 Mild Hybrid',
  'Audi Q8 Sportback e-tron Electric',
  'Audi Q8 e-tron Electric',
  'Audi R8 Coupe',
  'Audi R8 GT Coupe',
  'Audi R8 GT Spyder',
  'Audi R8 Spyder',
  'Audi R8',
  'Audi RS 3 Sedan',
  'Audi RS 3 Sportback',
  'Audi RS 4 Avant',
  'Audi RS 4 Cabriolet',
  'Audi RS 4',
  'Audi RS 5 Coupe',
  'Audi RS 5 Sportback',
  'Audi RS 6 Avant Mild Hybrid',
  'Audi RS 6 Avant',
  'Audi RS 6 Sedan',
  'Audi RS 7 Sportback Mild Hybrid',
  'Audi RS Q3 Sportback',
  'Audi RS Q3',
  'Audi RS Q8 Mild Hybrid',
  'Audi RS e-tron GT Electric',
  'Audi S3 Sedan',
  'Audi S3 Sportback',
  'Audi S3',
  'Audi S4 Avant',
  'Audi S4 Sedan',
  'Audi S4',
  'Audi S5 Cabriolet',
  'Audi S5 Coupe',
  'Audi S5 Sportback',
  'Audi S5',
  'Audi S6',
  'Audi S7 Sportback',
  'Audi S8 Mild Hybrid',
  'Audi S8',
  'Audi SQ5 Sportback',
  'Audi SQ5',
  'Audi SQ7',
  'Audi SQ8 e-tron Electric',
  'Audi SQ8',
  'Audi TT Coupe',
  'Audi TT RS Coupe',
  'Audi TT RS Roadster',
  'Audi TT Roadster',
  'Audi TTS Coupe',
  'Audi TTS Roadster',
  'Audi e-tron Electric',
  'Audi e-tron GT Electric',
  'Audi e-tron S Sportback Electric',
  'Audi e-tron Sportback Electric',
  'BAC Mono R',
  'BAC Mono',
  'BMW 1 Series Convertible',
  'BMW 1 Series Coupe',
  'BMW 1 Series Hatchback Diesel',
  'BMW 1 Series Hatchback',
  'BMW 1M Coupe',
  'BMW 2 Series Active Tourer Diesel',
  'BMW 2 Series Active Tourer Plug-in Hybrid',
  'BMW 2 Series Active Tourer',
  'BMW 2 Series Convertible',
  'BMW 2 Series Coupe',
  'BMW 2 Series Gran Coupe',
  'BMW 2 Series Gran Tourer Diesel',
  'BMW 2 Series Gran Tourer',
  'BMW 3 Series Cabriolet',
  'BMW 3 Series Convertible',
  'BMW 3 Series Coupe',
  'BMW 3 Series Gran Turismo',
  'BMW 3 Series Plug-in Hybrid',
  'BMW 3 Series Sedan Diesel',
  'BMW 3 Series Sedan Hybrid',
  'BMW 3 Series Sedan',
  'BMW 3 Series Touring',
  'BMW 4 Series Convertible',
  'BMW 4 Series Coupe',
  'BMW 4 Series Gran Coupe',
  'BMW 5 Series Gran Turismo Diesel',
  'BMW 5 Series Gran Turismo',
  'BMW 5 Series Mild Hybrid CarVault Edition',
  'BMW 5 Series Plug-in Hybrid',
  'BMW 5 Series Sedan Diesel',
  'BMW 5 Series Sedan F1 Auto Cars Edition',
  'BMW 5 Series Sedan Hybrid',
  'BMW 5 Series Sedan Mild Hybrid',
  'BMW 5 Series Sedan Plug-in Hybrid',
  'BMW 5 Series Sedan TTS Edition',
  'BMW 5 Series Sedan',
  'BMW 5 Series Touring Diesel',
  'BMW 5 Series Touring Mild Hybrid',
  'BMW 5 Series Touring',
  'BMW 6 Series Convertible',
  'BMW 6 Series Coupe',
  'BMW 6 Series Gran Coupe',
  'BMW 6 Series Gran Turismo Mild Hybrid',
  'BMW 6 Series Gran Turismo',
  'BMW 7 Series Diesel',
  'BMW 7 Series Hybrid',
  'BMW 7 Series Mild Hybrid',
  'BMW 7 Series Plug-in Hybrid',
  'BMW 7 Series',
  'BMW 8 Series Convertible',
  'BMW 8 Series Coupe',
  'BMW 8 Series Gran Coupe',
  'BMW ALPINA B3 Bi-Turbo Saloon',
  'BMW ALPINA B3 Bi-Turbo Touring',
  'BMW ALPINA B3 GT3 Coupe',
  'BMW ALPINA B3 S Bi-Turbo Saloon',
  'BMW ALPINA B4 Bi-Turbo Convertible',
  'BMW ALPINA B4 Bi-Turbo Coupe',
  'BMW ALPINA B4 S Bi-Turbo Coupe',
  'BMW ALPINA B5 Bi-Turbo Saloon Edition 50',
  'BMW ALPINA B5 Bi-Turbo Saloon',
  'BMW ALPINA B5 Bi-Turbo Touring Edition 50',
  'BMW ALPINA B5 Bi-Turbo Touring',
  'BMW ALPINA B6 Bi-Turbo Convertible',
  'BMW ALPINA B6 Bi-Turbo Coupe Edition 50',
  'BMW ALPINA B6 Bi-Turbo Coupe',
  'BMW ALPINA B6 Bi-Turbo Gran Coupe',
  'BMW ALPINA B7 Bi-Turbo Saloon',
  'BMW ALPINA B7 Bi-Turbo',
  'BMW ALPINA D3 Bi-Turbo Saloon',
  'BMW ALPINA D3 Bi-Turbo Touring',
  'BMW ALPINA D4 Bi-Turbo Coupe Diesel',
  'BMW ALPINA D5 Bi-Turbo Saloon',
  'BMW ALPINA D5 Bi-Turbo Touring',
  'BMW ALPINA D5 S Bi-Turbo Saloon Diesel',
  'BMW ALPINA XD3 Bi-Turbo',
  'BMW ALPINA XD3 Diesel',
  'BMW M135',
  'BMW M135i',
  'BMW M140i',
  'BMW M2 Coupe',
  'BMW M235 Gran Coupe',
  'BMW M235i Convertible',
  'BMW M235i Coupe',
  'BMW M240i Convertible',
  'BMW M240i Coupe',
  'BMW M3 Convertible',
  'BMW M3 Coupe',
  'BMW M3 Sedan',
  'BMW M3 Touring',
  'BMW M340i',
  'BMW M4 Convertible',
  'BMW M4 Coupe',
  'BMW M440i Gran Coupe Mild Hybrid',
  'BMW M5 Sedan Plug-in Hybrid',
  'BMW M5 Sedan',
  'BMW M550i',
  'BMW M6 Convertible',
  'BMW M6 Coupe',
  'BMW M6 Gran Coupe',
  'BMW M760Li',
  'BMW M8 Coupe',
  'BMW M8 Gran Coupe',
  'BMW M850i Convertible',
  'BMW M850i Coupe',
  'BMW M850i Gran Coupe',
  'BMW X1 Diesel',
  'BMW X1 M35i',
  'BMW X1',
  'BMW X2 M35i',
  'BMW X2',
  'BMW X3 2011',
  'BMW X3 Diesel',
  'BMW X3 M',
  'BMW X3 M40i Mild Hybrid',
  'BMW X3 M40i',
  'BMW X3 M50 Mild Hybrid',
  'BMW X3 Mild Hybrid',
  'BMW X3 Plug-in Hybrid',
  'BMW X3',
  'BMW X4 M',
  'BMW X4 M40i Mild Hybrid',
  'BMW X4 M40i',
  'BMW X4 Mild Hybrid',
  'BMW X4',
  'BMW X5 Diesel',
  'BMW X5 M',
  'BMW X5 M50d',
  'BMW X5 M50i',
  'BMW X5 Mild Hybrid',
  'BMW X5 Plug-in Hybrid',
  'BMW X5',
  'BMW X6 M',
  'BMW X6 M50d',
  'BMW X6 M50i',
  'BMW X6 Mild Hybrid',
  'BMW X6',
  'BMW X7 M50i',
  'BMW X7 M60i Mild Hybrid',
  'BMW X7',
  'BMW XM Plug-in Hybrid',
  'BMW Z4 Coupe',
  'BMW Z4 Roadster',
  'BMW Z4',
  'BMW i3 Electric',
  'BMW i3s Electric',
  'BMW i4 Gran Coupe Electric',
  'BMW i4 M50 Gran Coupe Electric',
  'BMW i5 Electric',
  'BMW i5 M60 Electric',
  'BMW i5 Touring Electric',
  'BMW i7 Electric',
  'BMW i7 M70 Electric',
  'BMW i8 Coupe',
  'BMW i8 Roadster',
  'BMW iX Electric',
  'BMW iX1 Electric',
  'BMW iX2 Electric',
  'BMW iX3 Electric',
  'BYD Atto 3 Electric',
  'BYD C6 Electric',
  'BYD C8 Electric',
  'BYD C9 Electric',
  'BYD Dolphin Electric',
  'BYD M3e Electric',
  'BYD M6 Electric',
  'BYD Seal Electric',
  'BYD Sealion 7 Electric',
  'BYD T3 Electric',
  'BYD T9R Electric',
  'BYD e6 Electric',
  'Bentley Arnage',
  'Bentley Azure',
  'Bentley Bentayga EWB',
  'Bentley Bentayga Hybrid F1 Auto Edition',
  'Bentley Bentayga Hybrid',
  'Bentley Bentayga',
  'Bentley Brooklands',
  'Bentley Continental Flying Spur',
  'Bentley Continental GT 1 Auto Cars Edition',
  'Bentley Continental GT Convertible 2011',
  'Bentley Continental GT Convertible',
  'Bentley Continental GT Plug-in Hybrid',
  'Bentley Continental GT',
  'Bentley Continental Supersports Convertible',
  'Bentley Continental Supersports',
  'Bentley Flying Spur F1 Auto Cars Edition',
  'Bentley Flying Spur Plug-in Hybrid',
  'Bentley Flying Spur',
  'Bentley Mulsanne',
  'Brabus C-Class Saloon',
  'Brabus E-Class Saloon',
  'Brabus GLA-Class',
  'Brabus GLC-Class Coupe',
  'CUPRA Ateca',
  'CUPRA Formentor',
  'CUPRA Leon Sportstourer',
  'CUPRA Leon',
  'Cenntro Logistar 200 Electric',
  'Cenntro N50 Electric',
  'Chana Benni',
  'Chery A168',
  'Chery Fulwin 2 Hatchback',
  'Chery Fulwin 2 Sedan',
  'Chery H5 Bus',
  'Chery H5',
  'Chery J1',
  'Chery J3 Hatchback',
  'Chery J3 S-Coupe',
  'Chery J3 Sedan',
  'Chery J5',
  'Chery QQ',
  'Chery T11',
  'Chery V5',
  'Chevrolet Aveo Hatchback',
  'Chevrolet Aveo Sedan',
  'Chevrolet Aveo5',
  'Chevrolet Captiva',
  'Chevrolet Colorado',
  'Chevrolet Corvette',
  'Chevrolet Cruze Station Wagon',
  'Chevrolet Cruze Wagon Diesel',
  'Chevrolet Cruze',
  'Chevrolet Cruze5 Sportback',
  'Chevrolet Epica',
  'Chevrolet Malibu',
  'Chevrolet Optra Hatchback',
  'Chevrolet Optra Magnum Estate',
  'Chevrolet Optra Magnum Sedan',
  'Chevrolet Orlando',
  'Chevrolet Sonic Hatchback',
  'Chevrolet Sonic Sedan',
  'Chevrolet Spark',
  'Chevrolet Volt',
  'Chrysler 300C Diesel',
  'Chrysler 300C Touring',
  'Chrysler 300C',
  'Chrysler Crossfire',
  'Chrysler Grand Voyager Diesel',
  'Chrysler Grand Voyager',
  'Chrysler PT Cruiser Convertible',
  'Chrysler PT Cruiser Touring',
  'Chrysler Sebring Convertible',
  'Chrysler Sebring',
  'Citroen Berlingo Diesel',
  'Citroen Berlingo',
  'Citroen C1',
  'Citroen C3 Aircross',
  'Citroen C3',
  'Citroen C4 Cactus',
  'Citroen C4 Coupe',
  'Citroen C4 Diesel',
  'Citroen C4 Grand Picasso',
  'Citroen C4 Picasso Diesel',
  'Citroen C4 Picasso',
  'Citroen C4',
  'Citroen C5 Aircross',
  'Citroen C5 Break',
  'Citroen C5 Diesel',
  'Citroen C5',
  'Citroen C6',
  'Citroen DS3',
  'Citroen DS4 Diesel',
  'Citroen DS4',
  'Citroen DS5 Diesel',
  'Citroen DS5 Hybrid',
  'Citroen DS5',
  'Citroen Dispatch',
  'Citroen Grand C4 Picasso Diesel',
  'Citroen Grand C4 Picasso',
  'Citroen Grand C4 SpaceTourer',
  'Citroen Nemo',
  'Citroen Relay',
  'Citroen e-Berlingo Electric',
  'Citroen e-C4 Electric',
  'Citroen e-C4 X Sedan Electric',
  'Citroen e-Dispatch Electric',
  'DENZA D9',
  'DFSK EC31 Electric',
  'DFSK EC31 Refrigerated Electric',
  'DFSK EC35 Electric',
  'DFSK EC35 Gen 2 Electric',
  'DS 3 Cabriolet',
  'DS 4 Crossback Diesel',
  'DS 5 Diesel',
  'DS 5',
  'DS 7 Crossback',
  'Daihatsu Copen GR Sport',
  'Daihatsu Copen',
  'Daihatsu Hijet',
  'Daihatsu Materia',
  'Daihatsu Mira Cocoa',
  'Daihatsu Sirion',
  'Daihatsu Terios 7-Seater',
  'Daihatsu Terios',
  'Dodge Caliber',
  'Dodge Journey',
  'Dongfeng Box',
  'Dongfeng Star MPV',
  'Dongfeng Star Van',
  'Farizon H9E Electric',
  'Farizon SuperVan Electric',
  'Ferrari 12Cilindri Spider',
  'Ferrari 12Cilindri',
  'Ferrari 296 GTB Plug-in Hybrid',
  'Ferrari 296 GTS Plug-in Hybrid',
  'Ferrari 360 Challenge Stradale',
  'Ferrari 458 Italia',
  'Ferrari 458 Speciale',
  'Ferrari 458 Spider',
  'Ferrari 488 GTB',
  'Ferrari 488 Pista F1 Auto Edition',
  'Ferrari 488 Pista',
  'Ferrari 488 Spider',
  'Ferrari 575M Maranello',
  'Ferrari 599 GTB Fiorano',
  'Ferrari 612 Scaglietti',
  'Ferrari 812 GTS',
  'Ferrari 812 Superfast',
  'Ferrari California H30',
  'Ferrari California T',
  'Ferrari California',
  'Ferrari F12berlinetta',
  'Ferrari F430 Spider',
  'Ferrari F430',
  'Ferrari F8 Spider',
  'Ferrari F8 Tributo F1 Auto Edition',
  'Ferrari F8 Tributo',
  'Ferrari GTC4Lusso T',
  'Ferrari GTC4Lusso',
  'Ferrari Portofino',
  'Ferrari Purosangue',
  'Ferrari Roma 1 Auto Cars Edition',
  'Ferrari Roma Spider',
  'Ferrari Roma',
  'Ferrari SF90 Spider Plug-in Hybrid',
  'Ferrari SF90 Stradale Plug-in Hybrid F1 Auto Edition',
  'Ferrari SF90 Stradale Plug-in Hybrid',
  'Fiat 500 Coupe',
  'Fiat 500 Gucci Luxury Convertible',
  'Fiat 500 Gucci Luxury',
  'Fiat 500e Electric',
  'Fiat Abarth',
  'Fiat Bravo',
  'Fiat Cinquecento 500 Convertible',
  'Fiat Cinquecento 500',
  'Fiat Croma',
  'Fiat Doblo',
  'Fiat Fiorino',
  'Fiat Grande Punto',
  'Fiat Idea',
  'Fiat Panda',
  'Fiat Panorama',
  'Fiat Professional Doblo Cargo Diesel',
  'Fiat Professional Fiorino Cargo Diesel',
  'Fiat Professional Fiorino Cargo',
  'Fiat Punto Evo',
  'Fiat Qubo',
  'Fiat Stilo',
  'Fiat Ulysse',
  'Ford Escape',
  'Ford Fiesta',
  'Ford Focus Hatchback',
  'Ford Focus RS',
  'Ford Focus ST',
  'Ford Focus Sedan',
  'Ford Focus Wagon',
  'Ford GT',
  'Ford Galaxy Diesel',
  'Ford Galaxy',
  'Ford Grand C-Max',
  'Ford Ka',
  'Ford Kuga',
  'Ford Mondeo Station Wagon',
  'Ford Mondeo Wagon',
  'Ford Mondeo',
  'Ford Mustang Convertible',
  'Ford Mustang Mach-E',
  'Ford Mustang',
  'Ford Ranger Diesel',
  'Ford Ranger Raptor Diesel',
  'Ford Ranger Raptor Petrol',
  'Ford Ranger Wildtrak Diesel',
  'Ford Ranger',
  'Ford S-Max Diesel',
  'Ford S-Max',
  'Ford Transit Connect',
  'Foton Aumark S Diesel',
  'Foton Iblue T5 Electric Truck',
  'Foton Iblue V6 Electric Commuter Bus',
  'Foton Iblue V6 Electric Van',
  'Foton Iblue V6 Electric',
  'Foton MP-X',
  'Foton Midi',
  'Foton eTruck Mate Electric Mini Truck',
  'Geely CK',
  'Geely MK',
  'Genesis G80',
  'Genesis GV60',
  'Golden Dragon ABS EV Electric',
  'Golden Dragon Big Coaster Bus Diesel',
  'Golden Dragon XML 6113',
  'Golden Dragon XML5036 Minibus Electric',
  'Golden Dragon XML6107 Diesel',
  'Golden Dragon XML6112 Diesel',
  'Golden Dragon XML6118',
  'Golden Dragon XML6126',
  'Golden Dragon XML6129 Diesel',
  'Golden Dragon XML6701',
  'Golden Dragon XML6957 Diesel',
  'Golden Dragon XML6957',
  'HSV Clubsport R8 Tourer',
  'HSV Clubsport R8',
  'HSV GTS',
  'HSV Grange',
  'HSV Maloo',
  'HSV Senator',
  'Hafei Lobo',
  'Hafei M8',
  'Hafei MinZ MPV',
  'Hafei MinZ Pick Up',
  'Hafei MinZ Van',
  'Higer H5C',
  'Higer H5F Electric',
  'Higer H5F Standard Roof Electric',
  'Hino 200 Diesel',
  'Hino 300 Diesel',
  'Hino 500 Diesel',
  'Hino 700',
  'Honda Accord Euro R',
  'Honda Accord Hybrid',
  'Honda Accord Wagon',
  'Honda Accord',
  'Honda Acty',
  'Honda Airwave',
  'Honda CR-V 2017',
  'Honda CR-V Hybrid',
  'Honda CR-V',
  'Honda CR-Z Hybrid',
  'Honda City',
  'Honda Civic Hatchback 2017',
  'Honda Civic Hatchback',
  'Honda Civic Hybrid',
  'Honda Civic Mugen RR',
  'Honda Civic Type-R 2017',
  'Honda Civic Type-R',
  'Honda Civic',
  'Honda Crossroad',
  'Honda E Electric',
  'Honda Edix',
  'Honda Elysion',
  'Honda Fit 2017',
  'Honda Fit Hybrid 2017',
  'Honda Fit Hybrid Cars & Coffee Edition',
  'Honda Fit Hybrid Trust Motoring Edition',
  'Honda Fit Hybrid',
  'Honda Fit Shuttle Hybrid',
  'Honda Fit Shuttle',
  'Honda Fit Speedo Motoring Edition',
  'Honda Fit Venture Cars Edition',
  'Honda Fit Vincar Edition',
  'Honda Fit',
  'Honda Freed 2020',
  'Honda Freed Hybrid 2020',
  'Honda Freed Hybrid Speedo Motoring Edition',
  'Honda Freed Hybrid Trust Motoring Edition',
  'Honda Freed Hybrid Vin\\\'s Auto Edition',
  'Honda Freed Hybrid',
  'Honda Freed Spike',
  'Honda Freed',
  'Honda Grace Hybrid Speedo Motoring Edition',
  'Honda Grace Hybrid',
  'Honda Grace',
  'Honda HR-V Hybrid',
  'Honda HR-V',
  'Honda Insight Hybrid',
  'Honda Inspire',
  'Honda Integra',
  'Honda Jade Hybrid',
  'Honda Jade',
  'Honda Jazz Crosstar Hybrid',
  'Honda Jazz Hybrid',
  'Honda Jazz',
  'Honda Legend Hybrid',
  'Honda Legend',
  'Honda Life',
  'Honda Mobilio',
  'Honda N-Box',
  'Honda N-Van Petrol',
  'Honda NSX Hybrid',
  'Honda Odyssey Hybrid 2016',
  'Honda Odyssey Hybrid Global Carz Edition',
  'Honda Odyssey Hybrid Speedo Motoring Edition',
  'Honda Odyssey Hybrid',
  'Honda Odyssey Leco Edition',
  'Honda Odyssey',
  'Honda S2000',
  'Honda S660',
  'Honda Shuttle Hybrid Speedo Motoring Edition',
  'Honda Shuttle Hybrid Vin\\\'s Auto Edition',
  'Honda Shuttle Hybrid',
  'Honda Shuttle Speedo Motoring Edition',
  'Honda Shuttle Vin\\\'s Auto Edition',
  'Honda Shuttle',
  'Honda Stepwagon 2015',
  'Honda Stepwagon Global Carz Edition',
  'Honda Stepwagon Hybrid 2018',
  'Honda Stepwagon Hybrid',
  'Honda Stepwagon',
  'Honda Stream',
  'Honda Vezel 2014',
  'Honda Vezel Hybrid 2021 Speedo Motoring Edition',
  'Honda Vezel Hybrid Auto Midas Edition',
  'Honda Vezel Hybrid',
  'Honda Vezel Trust Motoring Edition',
  'Honda Vezel Vin\\\'s Auto Edition',
  'Honda Vezel',
  'Honda WR-V',
  'Honda ZR-V Hybrid',
  'Hummer H3',
  'Hyundai Accent 5D',
  'Hyundai Accent',
  'Hyundai Avante Hybrid',
  'Hyundai Avante',
  'Hyundai Azera',
  'Hyundai Elantra',
  'Hyundai Genesis',
  'Hyundai Getz',
  'Hyundai Ioniq 5 Electric',
  'Hyundai Ioniq 5 N Electric',
  'Hyundai Ioniq 6 Electric',
  'Hyundai Ioniq Electric',
  'Hyundai Ioniq Hybrid',
  'Hyundai Kona Electric',
  'Hyundai Kona Hybrid',
  'Hyundai Kona',
  'Hyundai Matrix',
  'Hyundai Palisade',
  'Hyundai Santa Fe Diesel',
  'Hyundai Santa Fe Hybrid',
  'Hyundai Santa Fe Turbo Hybrid',
  'Hyundai Santa Fe',
  'Hyundai Sonata VIII',
  'Hyundai Sonata',
  'Hyundai Starex Bus',
  'Hyundai Starex Van',
  'Hyundai Starex',
  'Hyundai Staria',
  'Hyundai Terracan',
  'Hyundai Trajet',
  'Hyundai Tucson Diesel',
  'Hyundai Tucson Hybrid',
  'Hyundai Tucson',
  'Hyundai Tuscani',
  'Hyundai Veloster',
  'Hyundai Venue',
  'Hyundai Verna',
  'Hyundai i30 Fastback',
  'Hyundai i30 Hatchback',
  'Hyundai i30 N',
  'Hyundai i30 Wagon',
  'Hyundai i30',
  'Hyundai i40 Wagon',
  'Hyundai i45',
  'Infiniti Q30 Diesel',
  'Infiniti Q30',
  'Infiniti Q50',
  'Infiniti Q60 Convertible',
  'Infiniti Q60',
  'Infiniti Q70 Hybrid',
  'Infiniti Q70',
  'Infiniti QX30',
  'Infiniti QX50',
  'Infiniti QX70',
  'Infiniti QX80',
  'Isuzu D-Max',
  'Isuzu F Series Diesel',
  'Isuzu N Series Diesel',
  'JAC N Series',
  'Jac Motors N75EV Electric',
  'Jac Motors N90EV Electric',
  'Jaecoo J6 Electric',
  'Jaecoo J7 Plug-in Hybrid',
  'Jaguar E-PACE Mild Hybrid',
  'Jaguar E-PACE',
  'Jaguar F-PACE Diesel',
  'Jaguar F-PACE',
  'Jaguar F-TYPE Coupe',
  'Jaguar F-TYPE',
  'Jaguar F-Type',
  'Jaguar I-PACE Electric',
  'Jaguar S-Type',
  'Jaguar X-Type',
  'Jaguar XE Diesel',
  'Jaguar XE',
  'Jaguar XF Diesel',
  'Jaguar XF',
  'Jaguar XJ Diesel',
  'Jaguar XJ',
  'Jaguar XK',
  'Jeep Cherokee',
  'Jeep Commander',
  'Jeep Compass',
  'Jeep Gladiator Overland Petrol',
  'Jeep Gladiator Rubicon Petrol',
  'Jeep Grand Cherokee Diesel',
  'Jeep Grand Cherokee L',
  'Jeep Grand Cherokee SRT8',
  'Jeep Grand Cherokee',
  'Jeep Patriot Limited',
  'Jeep Renegade Diesel',
  'Jeep Renegade',
  'Jeep Wrangler Rubicon 2-Door',
  'Jeep Wrangler Rubicon 4-Door',
  'Jeep Wrangler Rubicon',
  'Jeep Wrangler Sahara 2-Door',
  'Jeep Wrangler Sahara 4-Door Diesel',
  'Jeep Wrangler Sahara 4-Door',
  'Jeep Wrangler Sahara Diesel',
  'Jeep Wrangler Unlimited Rubicon',
  'Jeep Wrangler Unlimited Sahara Diesel',
  'Jeep Wrangler Unlimited',
  'Jeep Wrangler',
  'Joylong EA5 Electric',
  'Joylong EW4 Electric',
  'Joylong Mini-Bus',
  'KYC V7 Electric',
  'Kia Carens Diesel',
  'Kia Carens',
  'Kia Carnival Diesel',
  'Kia Carnival Hybrid',
  'Kia Carnival',
  'Kia Cerato Forte Koup',
  'Kia Cerato Forte',
  'Kia Cerato K3',
  'Kia Cerato Koup',
  'Kia Cerato Smartstream',
  'Kia Cerato Sports',
  'Kia Cerato Variant 2',
  'Kia Cerato',
  'Kia EV9 Electric',
  'Kia Forte Hatchback',
  'Kia K2500 Diesel',
  'Kia K2900',
  'Kia Magentis',
  'Kia Niro Electric',
  'Kia Niro Hybrid',
  'Kia Niro Plus Electric',
  'Kia Optima K5',
  'Kia Optima',
  'Kia Picanto',
  'Kia Rio Hatchback',
  'Kia Rio Sedan',
  'Kia Rio',
  'Kia Seltos',
  'Kia Sonet',
  'Kia Sorento Diesel',
  'Kia Sorento Hybrid',
  'Kia Sorento',
  'Kia Soul',
  'Kia Sportage Diesel',
  'Kia Sportage',
  'Kia Stinger',
  'Kia Stonic Mild Hybrid',
  'Kia Stonic',
  'King Long Bus',
  'Koenigsegg Agera S',
  'LEVC VN5 Plug-in Hybrid',
  'Lamborghini Aventador F1 Auto Edition',
  'Lamborghini Aventador Roadster',
  'Lamborghini Aventador S Coupe',
  'Lamborghini Aventador',
  'Lamborghini Gallardo Spyder',
  'Lamborghini Gallardo',
  'Lamborghini Huracan STO',
  'Lamborghini Huracan Spyder',
  'Lamborghini Huracan',
  'Lamborghini Murcielago',
  'Lamborghini Revuelto Plug-in Hybrid',
  'Lamborghini Temerario Plug-in Hybrid',
  'Lamborghini Urus Plug-in Hybrid',
  'Lamborghini Urus',
  'Land Rover Defender 110 Diesel',
  'Land Rover Defender 110 Mild Hybrid Diesel',
  'Land Rover Defender 110 Mild Hybrid',
  'Land Rover Defender 110 Plug-in Hybrid',
  'Land Rover Defender 110',
  'Land Rover Defender 130 Mild Hybrid',
  'Land Rover Defender 130',
  'Land Rover Defender 90 Diesel',
  'Land Rover Defender 90 Mild Hybrid Diesel',
  'Land Rover Defender 90 Mild Hybrid',
  'Land Rover Defender 90',
  'Land Rover Defender TD5',
  'Land Rover Discovery 3',
  'Land Rover Discovery 4 Diesel',
  'Land Rover Discovery Diesel',
  'Land Rover Discovery Sport Diesel',
  'Land Rover Discovery Sport Mild Hybrid',
  'Land Rover Discovery Sport',
  'Land Rover Discovery',
  'Land Rover Freelander 2',
  'Land Rover Freelander',
  'Land Rover Range Rover Diesel',
  'Land Rover Range Rover Evoque Convertible',
  'Land Rover Range Rover Evoque Diesel',
  'Land Rover Range Rover Evoque Mild Hybrid',
  'Land Rover Range Rover Evoque',
  'Land Rover Range Rover Mild Hybrid',
  'Land Rover Range Rover Plug-in Hybrid',
  'Land Rover Range Rover Sport Diesel',
  'Land Rover Range Rover Sport Mild Hybrid',
  'Land Rover Range Rover Sport Plug-in Hybrid',
  'Land Rover Range Rover Sport',
  'Land Rover Range Rover Velar Mild Hybrid',
  'Land Rover Range Rover Velar',
  'Land Rover Range Rover Vogue',
  'Land Rover Range Rover',
  'Lexus 3-Row RX 350L',
  'Lexus CT Hybrid',
  'Lexus CT200h',
  'Lexus ES 250',
  'Lexus ES 300h Hybrid',
  'Lexus ES300',
  'Lexus GS 300',
  'Lexus GS 350',
  'Lexus GS 450h',
  'Lexus GS F',
  'Lexus GS',
  'Lexus GS300',
  'Lexus GS450h Hybrid',
  'Lexus IS 300',
  'Lexus IS 300h Hybrid',
  'Lexus IS 350',
  'Lexus IS F',
  'Lexus IS250',
  'Lexus IS250C',
  'Lexus LBX Hybrid',
  'Lexus LC 500 Convertible',
  'Lexus LC 500',
  'Lexus LC 500h',
  'Lexus LFA',
  'Lexus LM Hybrid',
  'Lexus LS Hybrid',
  'Lexus LS',
  'Lexus LS460',
  'Lexus LS600hL Hybrid',
  'Lexus NX 300',
  'Lexus NX 300h Hybrid',
  'Lexus NX 350',
  'Lexus NX 350h Hybrid',
  'Lexus NX 450h+ Plug-in Hybrid',
  'Lexus NX Hybrid',
  'Lexus NX',
  'Lexus RC 300',
  'Lexus RC F',
  'Lexus RC',
  'Lexus RX 300',
  'Lexus RX 350',
  'Lexus RX 350h Hybrid',
  'Lexus RX 450h Hybrid',
  'Lexus RX 450h+ Plug-in Hybrid',
  'Lexus RX 500h Hybrid',
  'Lexus RX Turbo',
  'Lexus RX270',
  'Lexus RX350',
  'Lexus RX400h Hybrid',
  'Lexus RX450h Hybrid',
  'Lexus RZ Electric',
  'Lexus SC430',
  'Lexus UX 200',
  'Lexus UX 250h Hybrid',
  'Lexus UX 300e Electric',
  'Lexus UX 300h Hybrid',
  'Lorinser C-Class Saloon',
  'Lorinser CLA-Class',
  'Lorinser E-Class Cabriolet',
  'Lorinser E-Class Coupe',
  'Lorinser E-Class Saloon',
  'Lorinser G-Class Diesel',
  'Lorinser G-Class',
  'Lorinser GL-Class',
  'Lorinser GLA-Class',
  'Lorinser M-Class',
  'Lorinser S-Class Hybrid',
  'Lorinser S-Class',
  'Lorinser SL-Class',
  'Lorinser SLK-Class',
  'Lotus Eletre',
  'Lotus Elise',
  'Lotus Emeya',
  'Lotus Emira',
  'Lotus Exige',
  'MG 4 EV',
  'MG 5 EV',
  'MG Cyberster',
  'MG HS Plug-in Hybrid',
  'MG HS',
  'MG M9 EV',
  'MG ZS EV',
  'MINI Aceman Electric',
  'MINI Cooper 3-Door Electric',
  'MINI Cooper 3-Door',
  'MINI Cooper 5-Door Diesel',
  'MINI Cooper 5-Door',
  'MINI Cooper C 5-Door',
  'MINI Cooper Cabriolet',
  'MINI Cooper Clubman',
  'MINI Cooper Convertible',
  'MINI Cooper Countryman',
  'MINI Cooper Coupe',
  'MINI Cooper D 5-Door',
  'MINI Cooper D',
  'MINI Cooper Paceman',
  'MINI Cooper Roadster',
  'MINI Cooper S 3-Door',
  'MINI Cooper S 5-Door',
  'MINI Cooper S Cabriolet',
  'MINI Cooper S Clubman',
  'MINI Cooper S Convertible',
  'MINI Cooper S Countryman',
  'MINI Cooper S Coupe',
  'MINI Cooper S Paceman',
  'MINI Cooper S Roadster',
  'MINI Cooper S',
  'MINI Cooper',
  'MINI Countryman C',
  'MINI Countryman Electric',
  'MINI Countryman S',
  'MINI Crossover',
  'MINI Electric',
  'MINI John Cooper Works 3-Door',
  'MINI John Cooper Works Cabriolet',
  'MINI John Cooper Works Clubman',
  'MINI John Cooper Works Convertible',
  'MINI John Cooper Works Countryman',
  'MINI John Cooper Works Coupe',
  'MINI John Cooper Works GP',
  'MINI John Cooper Works Paceman',
  'MINI John Cooper Works Roadster',
  'MINI John Cooper Works',
  'MINI Monte Carlo',
  'MINI One 3-Door',
  'MINI One 5-Door',
  'MINI One Brick Lane',
  'MINI One Clubman',
  'MINI One Stratford',
  'MINI One',
  'Maserati Coupe',
  'Maserati Ghibli Diesel',
  'Maserati Ghibli Mild Hybrid',
  'Maserati Ghibli',
  'Maserati GranCabrio',
  'Maserati GranTurismo',
  'Maserati Grecale Mild Hybrid',
  'Maserati Grecale',
  'Maserati Levante Diesel',
  'Maserati Levante',
  'Maserati MC20',
  'Maserati Quattroporte Diesel',
  'Maserati Quattroporte Sport GT',
  'Maserati Quattroporte',
  'Maserati Spyder',
  'Maxus G10 Executive MPV',
  'Maxus G10 Petrol',
  'Maxus MIFA 7 Electric',
  'Maxus MIFA 9 Electric',
  'Maxus T90 EV Electric',
  'Maxus T90 Electric',
  'Maxus V80 Commuter',
  'Maxus V80',
  'Maxus eDeliver 3 Electric',
  'Maxus eDeliver 5 Electric',
  'Maxus eDeliver 7 Electric',
  'Maxus eDeliver 9 Electric',
  'Mazda 2 Demio',
  'Mazda 2 Hatchback',
  'Mazda 2 SP',
  'Mazda 2 Sedan',
  'Mazda 3 Hatchback Mild Hybrid',
  'Mazda 3 Hatchback',
  'Mazda 3 Sedan Mild Hybrid',
  'Mazda 3 Sedan',
  'Mazda 5',
  'Mazda 6 Hatchback',
  'Mazda 6 MPS',
  'Mazda 6 SP',
  'Mazda 6 Sedan',
  'Mazda 6 Wagon',
  'Mazda 8',
  'Mazda Axela Diesel',
  'Mazda Axela Hatchback',
  'Mazda Axela Sedan',
  'Mazda Biante',
  'Mazda CX-3 Diesel',
  'Mazda CX-3',
  'Mazda CX-30 Mild Hybrid',
  'Mazda CX-30',
  'Mazda CX-5 Diesel',
  'Mazda CX-5 Mild Hybrid',
  'Mazda CX-5',
  'Mazda CX-60',
  'Mazda CX-7',
  'Mazda CX-8',
  'Mazda CX-80 Plug-in Hybrid',
  'Mazda CX-9',
  'Mazda E2000i',
  'Mazda MX-30 Electric',
  'Mazda MX-5 RF',
  'Mazda MX-5',
  'Mazda Premacy',
  'Mazda RX-8',
  'Mazda RX8',
  'McLaren 12C Spider',
  'McLaren 12C',
  'McLaren 540C',
  'McLaren 570 GT',
  'McLaren 570S Spider',
  'McLaren 570S',
  'McLaren 600LT Coupe',
  'McLaren 650S Spider',
  'McLaren 650S',
  'McLaren 720S Coupe',
  'McLaren 720S Spider',
  'McLaren 750S Coupe',
  'McLaren 750S Spider',
  'McLaren 765LT Spider',
  'McLaren 765LT',
  'McLaren Artura Plug-in Hybrid',
  'McLaren Artura Spider Plug-in Hybrid',
  'McLaren GT',
  'Mercedes Benz GLC-Class Diesel',
  'Mercedes-Benz 2022 C-Class Saloon Mild Hybrid TTS Edition',
  'Mercedes-Benz A-Class 2018 TTS Edition',
  'Mercedes-Benz A-Class Diesel',
  'Mercedes-Benz A-Class F1 Auto Cars Edition',
  'Mercedes-Benz A-Class Hatchback F1 Auto Cars Edition',
  'Mercedes-Benz A-Class Hatchback HVS Edition',
  'Mercedes-Benz A-Class Hatchback',
  'Mercedes-Benz A-Class Saloon Cars & Coffee Edition',
  'Mercedes-Benz A-Class Saloon F1 Auto Cars Edition',
  'Mercedes-Benz A-Class Saloon Mild Hybrid',
  'Mercedes-Benz A-Class Saloon Plug-in Hybrid',
  'Mercedes-Benz A-Class Saloon',
  'Mercedes-Benz A-Class',
  'Mercedes-Benz AMG GT 4-Door Coupe Mild Hybrid',
  'Mercedes-Benz AMG GT 4-Door Coupe',
  'Mercedes-Benz AMG GT Coupe',
  'Mercedes-Benz AMG GT Roadster',
  'Mercedes-Benz AMG GT',
  'Mercedes-Benz B-Class 2016',
  'Mercedes-Benz B-Class Electric Drive 2016',
  'Mercedes-Benz B-Class',
  'Mercedes-Benz C-Class 2011',
  'Mercedes-Benz C-Class Cabriolet Mild Hybrid',
  'Mercedes-Benz C-Class Cabriolet',
  'Mercedes-Benz C-Class Coupe 2017',
  'Mercedes-Benz C-Class Coupe Mild Hybrid',
  'Mercedes-Benz C-Class Coupe',
  'Mercedes-Benz C-Class Estate Plug-in Hybrid',
  'Mercedes-Benz C-Class Estate',
  'Mercedes-Benz C-Class Saloon Diesel',
  'Mercedes-Benz C-Class Saloon F1 Auto Cars Edition',
  'Mercedes-Benz C-Class Saloon Mild Hybrid 2018',
  'Mercedes-Benz C-Class Saloon Mild Hybrid',
  'Mercedes-Benz C-Class Saloon Plug-in Hybrid',
  'Mercedes-Benz C-Class Saloon',
  'Mercedes-Benz C-Class Sports Coupe',
  'Mercedes-Benz CL-Class',
  'Mercedes-Benz CLA-Class 2013',
  'Mercedes-Benz CLA-Class Coupe Emperor Motors Edition',
  'Mercedes-Benz CLA-Class Coupe Mild Hybrid',
  'Mercedes-Benz CLA-Class Coupe',
  'Mercedes-Benz CLA-Class Diesel',
  'Mercedes-Benz CLA-Class F1 Auto Cars Edition',
  'Mercedes-Benz CLA-Class Shooting Brake',
  'Mercedes-Benz CLA-Class TTS Edition',
  'Mercedes-Benz CLA-Class',
  'Mercedes-Benz CLC-Class',
  'Mercedes-Benz CLE-Class Cabriolet Mild Hybrid',
  'Mercedes-Benz CLE-Class Coupe Mild Hybrid',
  'Mercedes-Benz CLK-Class Cabriolet',
  'Mercedes-Benz CLK-Class Coupe',
  'Mercedes-Benz CLK-Class',
  'Mercedes-Benz CLS-Class Diesel',
  'Mercedes-Benz CLS-Class Mild Hybrid',
  'Mercedes-Benz CLS-Class Shooting Brake Diesel',
  'Mercedes-Benz CLS-Class Shooting Brake',
  'Mercedes-Benz CLS-Class',
  'Mercedes-Benz Citan',
  'Mercedes-Benz E-Class Cabriolet 2013',
  'Mercedes-Benz E-Class Cabriolet 2017',
  'Mercedes-Benz E-Class Cabriolet Mild Hybrid 2019',
  'Mercedes-Benz E-Class Cabriolet Mild Hybrid',
  'Mercedes-Benz E-Class Cabriolet',
  'Mercedes-Benz E-Class Coupe 2017',
  'Mercedes-Benz E-Class Coupe Diesel',
  'Mercedes-Benz E-Class Coupe Mild Hybrid 2018',
  'Mercedes-Benz E-Class Coupe Mild Hybrid 2019',
  'Mercedes-Benz E-Class Coupe Mild Hybrid',
  'Mercedes-Benz E-Class Coupe',
  'Mercedes-Benz E-Class Estate Diesel',
  'Mercedes-Benz E-Class Estate',
  'Mercedes-Benz E-Class Limousine',
  'Mercedes-Benz E-Class Saloon 2016',
  'Mercedes-Benz E-Class Saloon Diesel 2016',
  'Mercedes-Benz E-Class Saloon Diesel 2020',
  'Mercedes-Benz E-Class Saloon Diesel',
  'Mercedes-Benz E-Class Saloon Hybrid',
  'Mercedes-Benz E-Class Saloon Mild Hybrid 2018',
  'Mercedes-Benz E-Class Saloon Mild Hybrid 2019',
  'Mercedes-Benz E-Class Saloon Mild Hybrid 2020',
  'Mercedes-Benz E-Class Saloon Mild Hybrid Vin\\\'s Auto Edition',
  'Mercedes-Benz E-Class Saloon Mild Hybrid',
  'Mercedes-Benz E-Class Saloon Plug-in Hybrid 2017',
  'Mercedes-Benz E-Class Saloon Plug-in Hybrid',
  'Mercedes-Benz E-Class Saloon',
  'Mercedes-Benz E-Class',
  'Mercedes-Benz EQA Electric',
  'Mercedes-Benz EQB Electric',
  'Mercedes-Benz EQC Electric',
  'Mercedes-Benz EQE Electric',
  'Mercedes-Benz EQE SUV Electric',
  'Mercedes-Benz EQS Electric',
  'Mercedes-Benz EQS SUV Electric',
  'Mercedes-Benz EQV Electric',
  'Mercedes-Benz G-Class 1 Auto Cars Edition',
  'Mercedes-Benz G-Class 2013',
  'Mercedes-Benz G-Class Diesel',
  'Mercedes-Benz G-Class',
  'Mercedes-Benz GL-Class Diesel',
  'Mercedes-Benz GL-Class',
  'Mercedes-Benz GLA-Class 2014',
  'Mercedes-Benz GLA-Class Diesel',
  'Mercedes-Benz GLA-Class Mild Hybrid',
  'Mercedes-Benz GLA-Class Zion Auto Edition',
  'Mercedes-Benz GLA-Class',
  'Mercedes-Benz GLB-Class Car Empire Edition',
  'Mercedes-Benz GLB-Class CarVault Edition',
  'Mercedes-Benz GLB-Class Diesel',
  'Mercedes-Benz GLB-Class F1 Auto Cars Edition',
  'Mercedes-Benz GLB-Class Mild Hybrid',
  'Mercedes-Benz GLB-Class Vincar Edition',
  'Mercedes-Benz GLB-Class',
  'Mercedes-Benz GLC-Class Coupe Diesel',
  'Mercedes-Benz GLC-Class Coupe F1 Auto Cars Edition',
  'Mercedes-Benz GLC-Class Coupe Mild Hybrid 2019',
  'Mercedes-Benz GLC-Class Coupe Mild Hybrid F1 Auto Edition',
  'Mercedes-Benz GLC-Class Coupe Mild Hybrid',
  'Mercedes-Benz GLC-Class Coupe Plug-in Hybrid',
  'Mercedes-Benz GLC-Class Coupe TTS Edition',
  'Mercedes-Benz GLC-Class Coupe',
  'Mercedes-Benz GLC-Class Diesel',
  'Mercedes-Benz GLC-Class F1 Auto Cars Edition',
  'Mercedes-Benz GLC-Class Mild Hybrid F1 Auto Edition',
  'Mercedes-Benz GLC-Class Mild Hybrid',
  'Mercedes-Benz GLC-Class Plug-in Hybrid',
  'Mercedes-Benz GLC-Class Quantum Armour Edition',
  'Mercedes-Benz GLC-Class',
  'Mercedes-Benz GLE-Class 2016',
  'Mercedes-Benz GLE-Class Coupe Diesel',
  'Mercedes-Benz GLE-Class Coupe Mild Hybrid',
  'Mercedes-Benz GLE-Class Coupe',
  'Mercedes-Benz GLE-Class Diesel',
  'Mercedes-Benz GLE-Class Mild Hybrid 1 Auto Cars Edition',
  'Mercedes-Benz GLE-Class Mild Hybrid',
  'Mercedes-Benz GLE-Class',
  'Mercedes-Benz GLS-Class Diesel',
  'Mercedes-Benz GLS-Class Mild Hybrid',
  'Mercedes-Benz GLS-Class',
  'Mercedes-Benz M-Class Diesel',
  'Mercedes-Benz M-Class',
  'Mercedes-Benz Maybach EQS Electric',
  'Mercedes-Benz Maybach GLS-Class 1 Auto Cars Edition',
  'Mercedes-Benz Maybach GLS-Class Mild Hybrid',
  'Mercedes-Benz Maybach GLS-Class',
  'Mercedes-Benz Maybach S-Class Mild Hybrid',
  'Mercedes-Benz Maybach S-Class',
  'Mercedes-Benz R-Class',
  'Mercedes-Benz S-Class Cabriolet',
  'Mercedes-Benz S-Class Coupe',
  'Mercedes-Benz S-Class Diesel',
  'Mercedes-Benz S-Class Hybrid',
  'Mercedes-Benz S-Class Mild Hybrid',
  'Mercedes-Benz S-Class Plug-in Hybrid',
  'Mercedes-Benz S-Class',
  'Mercedes-Benz SL-Class Cabriolet',
  'Mercedes-Benz SL-Class',
  'Mercedes-Benz SLC-Class',
  'Mercedes-Benz SLK-Class',
  'Mercedes-Benz SLS AMG GT',
  'Mercedes-Benz SLS AMG Roadster',
  'Mercedes-Benz SLS AMG',
  'Mercedes-Benz V-Class Diesel',
  'Mercedes-Benz V-Class',
  'Mercedes-Benz Viano',
  'Mercedes-Benz Vito Diesel',
  'Mercedes-Benz Vito Tourer Diesel',
  'Mercedes-Benz Vito',
  'Mercedes-Benz X-Class Diesel',
  'Mercedes-Benz eActros Electric',
  'Mercedes-Benz eVito Electric',
  'Mitsubishi ASX',
  'Mitsubishi Attrage',
  'Mitsubishi Colt CZC',
  'Mitsubishi Colt Plus',
  'Mitsubishi Colt Ralliart Version-R',
  'Mitsubishi Colt Version-R',
  'Mitsubishi Colt',
  'Mitsubishi Delica D:5',
  'Mitsubishi Eclipse Cross',
  'Mitsubishi Fuso Canter Diesel',
  'Mitsubishi Fuso Canter',
  'Mitsubishi Fuso Fighter',
  'Mitsubishi Fuso Rosa',
  'Mitsubishi Galant',
  'Mitsubishi Grandis',
  'Mitsubishi L200 Triton Diesel',
  'Mitsubishi Lancer EX Ralliart',
  'Mitsubishi Lancer EX',
  'Mitsubishi Lancer Evolution IX',
  'Mitsubishi Lancer Evolution X',
  'Mitsubishi Lancer Evolution',
  'Mitsubishi Lancer MR',
  'Mitsubishi Lancer',
  'Mitsubishi Outlander Plug-in Hybrid',
  'Mitsubishi Outlander',
  'Mitsubishi Pajero',
  'Mitsubishi Space Star',
  'Mitsubishi Triton L200',
  'Mitsubishi i',
  'Mitsuoka Galue 2-04',
  'Mitsuoka Galue III',
  'Mitsuoka Galue',
  'Mitsuoka Himiko',
  'Mitsuoka Nouera 6-02',
  'Mitsuoka Nouera',
  'Mitsuoka Orochi',
  'Mitsuoka Rock Star',
  'Mitsuoka Viewt',
  'Morgan 4\\/4 Sport',
  'Morgan Plus Four',
  'Morgan Plus Six',
  'NETA AYA Electric',
  'NETA X Electric',
  'Nissan 370Z',
  'Nissan Almera',
  'Nissan Ariya Electric',
  'Nissan Atlas',
  'Nissan Cabstar',
  'Nissan Caravan',
  'Nissan Cefiro',
  'Nissan Clipper',
  'Nissan Cube',
  'Nissan Dualis',
  'Nissan Elgrand',
  'Nissan Fairlady 350Z',
  'Nissan Fairlady 370Z Roadster',
  'Nissan Fairlady 370Z',
  'Nissan Fairlady',
  'Nissan Fuga',
  'Nissan GT-R Car Empire Edition',
  'Nissan GT-R',
  'Nissan GTR',
  'Nissan Juke',
  'Nissan Kicks e-POWER Hybrid',
  'Nissan Lafesta',
  'Nissan Latio Sedan',
  'Nissan Latio Sport',
  'Nissan Leaf Electric',
  'Nissan March',
  'Nissan Murano',
  'Nissan NV100 High Roof Petrol',
  'Nissan NV100 Petrol',
  'Nissan NV100DX',
  'Nissan NV200 Diesel',
  'Nissan NV200 Petrol',
  'Nissan NV200',
  'Nissan NV250 Diesel',
  'Nissan NV350 Caravan',
  'Nissan NV350 Diesel',
  'Nissan NV350 High Roof',
  'Nissan NV350 Microbus',
  'Nissan NV350 Petrol',
  'Nissan NV350',
  'Nissan Navara',
  'Nissan Note e-POWER Hybrid',
  'Nissan Note',
  'Nissan Presage',
  'Nissan Pulsar',
  'Nissan Qashqai +2',
  'Nissan Qashqai Mild Hybrid',
  'Nissan Qashqai',
  'Nissan Serena e-POWER Hybrid Venture Cars Edition',
  'Nissan Serena e-POWER Hybrid',
  'Nissan Serena',
  'Nissan Skyline',
  'Nissan Sunny',
  'Nissan Sylphy',
  'Nissan Teana',
  'Nissan Urvan',
  'Nissan X-Trail e-POWER Hybrid',
  'Nissan X-Trail e-POWER e-4ORCE Hybrid',
  'Nissan X-Trail',
  'OHM 35 Electric',
  'ORA 07 Electric',
  'ORA Good Cat Electric',
  'Omoda E5 Electric',
  'Opel Adam',
  'Opel Astra Convertible',
  'Opel Astra GTC',
  'Opel Astra H',
  'Opel Astra OPC',
  'Opel Astra Sport Wagon',
  'Opel Astra Sports Tourer Diesel',
  'Opel Astra Sports Tourer',
  'Opel Astra',
  'Opel Cascada',
  'Opel Combo Diesel',
  'Opel Combo',
  'Opel Combo-e Electric',
  'Opel Combo-e Life Electric',
  'Opel Corsa',
  'Opel Crossland',
  'Opel Grandland',
  'Opel Insignia Diesel',
  'Opel Insignia Grand Sport Diesel',
  'Opel Insignia Grand Sport',
  'Opel Insignia Sport Tourer',
  'Opel Insignia',
  'Opel Meriva',
  'Opel Mokka X Diesel',
  'Opel Mokka',
  'Opel Mokka-e Electric',
  'Opel Tigra',
  'Opel Vectra',
  'Opel Vivaro',
  'Opel Vivaro-e Electric',
  'Opel Zafira Grand Tourer',
  'Opel Zafira',
  'Opel Zafira-e Life Electric',
  'Pagani Huayra',
  'Perodua Aruz',
  'Perodua Axia',
  'Perodua Bezza',
  'Perodua Kelisa',
  'Perodua Kembara',
  'Perodua Kenari',
  'Perodua Myvi',
  'Perodua Viva',
  'Peugeot 1007',
  'Peugeot 107',
  'Peugeot 2008 Diesel',
  'Peugeot 2008',
  'Peugeot 206',
  'Peugeot 206CC',
  'Peugeot 207',
  'Peugeot 207CC',
  'Peugeot 208 Diesel',
  'Peugeot 208',
  'Peugeot 3008 Diesel',
  'Peugeot 3008',
  'Peugeot 307 CC',
  'Peugeot 307 SW',
  'Peugeot 307',
  'Peugeot 308 Diesel',
  'Peugeot 308 SW',
  'Peugeot 308',
  'Peugeot 308CC',
  'Peugeot 407 Coupe',
  'Peugeot 407 SW',
  'Peugeot 407',
  'Peugeot 408',
  'Peugeot 5008 Diesel',
  'Peugeot 5008',
  'Peugeot 508 Diesel',
  'Peugeot 508 Fastback',
  'Peugeot 508 RXH Hybrid',
  'Peugeot 508 SW Diesel',
  'Peugeot 508 SW',
  'Peugeot 508',
  'Peugeot E-2008 Electric',
  'Peugeot Expert',
  'Peugeot Partner Diesel',
  'Peugeot Partner',
  'Peugeot RCZ',
  'Peugeot e-Expert Electric',
  'Peugeot e-Partner Electric',
  'Polestar 2 Electric',
  'Polestar 3 Electric',
  'Polestar 4 Electric',
  'Porsche 718 Boxster',
  'Porsche 718 Cayman GTS',
  'Porsche 718 Cayman',
  'Porsche 911 Cabriolet',
  'Porsche 911 GT2',
  'Porsche 911 GT3',
  'Porsche 911 GTS',
  'Porsche 911 R',
  'Porsche 911 Speedster',
  'Porsche 911 Targa',
  'Porsche 911',
  'Porsche Boxster Spyder',
  'Porsche Boxster',
  'Porsche Cayenne 2014',
  'Porsche Cayenne Coupe Plug-in Hybrid',
  'Porsche Cayenne Coupe',
  'Porsche Cayenne Diesel',
  'Porsche Cayenne F1 Auto Cars Edition',
  'Porsche Cayenne Hybrid',
  'Porsche Cayenne Plug-in Hybrid Coupe',
  'Porsche Cayenne Plug-in Hybrid',
  'Porsche Cayenne S E-Hybrid',
  'Porsche Cayenne S Hybrid',
  'Porsche Cayenne Special Import',
  'Porsche Cayenne',
  'Porsche Cayman',
  'Porsche Macan 2014',
  'Porsche Macan Diesel',
  'Porsche Macan Electric',
  'Porsche Macan',
  'Porsche Panamera Diesel',
  'Porsche Panamera E-Hybrid',
  'Porsche Panamera Plug-in Hybrid',
  'Porsche Panamera S E-Hybrid',
  'Porsche Panamera S Hybrid',
  'Porsche Panamera Sport Turismo Diesel',
  'Porsche Panamera Sport Turismo E-Hybrid',
  'Porsche Panamera Sport Turismo',
  'Porsche Panamera',
  'Porsche Taycan Cross Turismo Electric',
  'Porsche Taycan Electric',
  'Porsche Taycan Sport Turismo Electric',
  'Proton Exora',
  'Proton Gen.2',
  'Proton Persona',
  'Proton Preve',
  'Proton Saga',
  'Proton Satria Neo',
  'Proton Savvy',
  'Proton Waja',
  'Proton Wira',
  'RUF 3800S',
  'RUF CTR3',
  'RUF RGT',
  'RUF RTR',
  'RUF SCR',
  'RUF Turbo Florio',
  'RUF Ultimate',
  'Renault Arkana Fastback E-Tech Hybrid',
  'Renault Captur Diesel',
  'Renault Captur Flamme Edition',
  'Renault Captur',
  'Renault Clio Campus',
  'Renault Clio Diesel',
  'Renault Clio F1 Team R27',
  'Renault Clio R.S.',
  'Renault Clio',
  'Renault Fluence Diesel',
  'Renault Fluence Z.E',
  'Renault Fluence',
  'Renault Grand Espace',
  'Renault Grand Scenic Diesel',
  'Renault Grand Scenic',
  'Renault Kadjar Diesel',
  'Renault Kadjar',
  'Renault Kangoo Diesel',
  'Renault Kangoo E-Tech Electric',
  'Renault Kangoo WAV',
  'Renault Kangoo',
  'Renault Koleos',
  'Renault Laguna Coupe',
  'Renault Laguna',
  'Renault Latitude',
  'Renault Master',
  'Renault Megane Coupe-Cabriolet',
  'Renault Megane F1 Team R26',
  'Renault Megane GT',
  'Renault Megane GT-Line Diesel',
  'Renault Megane Hatch Diesel',
  'Renault Megane Hatch',
  'Renault Megane Hatchback',
  'Renault Megane RS',
  'Renault Megane Sedan Diesel',
  'Renault Megane Sedan',
  'Renault Megane Sport Tourer',
  'Renault Modus',
  'Renault Scenic Diesel',
  'Renault Scenic',
  'Renault Trafic',
  'Renault Zoe Electric',
  'Rolls-Royce Cullinan 1 Auto Cars Edition',
  'Rolls-Royce Cullinan',
  'Rolls-Royce Dawn 1 Auto Cars Edition',
  'Rolls-Royce Dawn',
  'Rolls-Royce Ghost 1 Auto Cars Edition',
  'Rolls-Royce Ghost Series II F1 Auto Edition',
  'Rolls-Royce Ghost Series II',
  'Rolls-Royce Ghost',
  'Rolls-Royce Phantom 1 Auto Cars Edition',
  'Rolls-Royce Phantom Coupe',
  'Rolls-Royce Phantom Drophead Coupe',
  'Rolls-Royce Phantom Series II Coupe',
  'Rolls-Royce Phantom Series II Drophead Coupe',
  'Rolls-Royce Phantom Series II',
  'Rolls-Royce Phantom',
  'Rolls-Royce Spectre Electric',
  'Rolls-Royce Wraith 1 Auto Cars Edition',
  'Rolls-Royce Wraith',
  'SANY EV490 Electric',
  'SANY FR601 Electric',
  'SEAT Alhambra Diesel',
  'SEAT Alhambra',
  'SEAT Arona',
  'SEAT Ateca',
  'SEAT Ibiza',
  'SEAT Leon Mild Hybrid',
  'SEAT Leon Sport Coupe',
  'SEAT Leon Sport Tourer',
  'SEAT Leon Sportstourer Mild Hybrid',
  'SEAT Leon',
  'SEAT Tarraco',
  'SEAT Toledo Diesel',
  'SEAT Toledo',
  'SOKON EC31 Electric',
  'SOKON EC35II Electric',
  'SRM T3EV Electric',
  'Saab 9-3 Convertible',
  'Saab 9-3',
  'Saab 9-5 SportCombi',
  'Saab 9-5',
  'Seres 3 Electric',
  'Shineray X30LEV Electric',
  'Skoda Enyaq Coupe Electric',
  'Skoda Enyaq Electric',
  'Skoda Fabia Combi',
  'Skoda Fabia Hatchback',
  'Skoda Fabia RS',
  'Skoda Fabia Sedan',
  'Skoda Fabia',
  'Skoda Kamiq',
  'Skoda Karoq',
  'Skoda Kodiaq Diesel',
  'Skoda Kodiaq Mild Hybrid',
  'Skoda Kodiaq RS',
  'Skoda Kodiaq',
  'Skoda Octavia Combi Mild Hybrid',
  'Skoda Octavia Combi RS',
  'Skoda Octavia Combi',
  'Skoda Octavia Estate',
  'Skoda Octavia Mild Hybrid',
  'Skoda Octavia RS',
  'Skoda Octavia Scout Diesel',
  'Skoda Octavia',
  'Skoda Rapid Spaceback',
  'Skoda Roomster',
  'Skoda Scala',
  'Skoda Superb Combi',
  'Skoda Superb TDI',
  'Skoda Superb',
  'Skoda Yeti',
  'Skywell D07 Electric',
  'Skyworth K Electric',
  'SsangYong Actyon Diesel',
  'SsangYong Actyon Sports Diesel',
  'SsangYong Actyon Sports',
  'SsangYong Actyon',
  'SsangYong Chairman',
  'SsangYong Korando Diesel',
  'SsangYong Korando Electric',
  'SsangYong Korando',
  'SsangYong Kyron',
  'SsangYong Musso Grand Diesel',
  'SsangYong Rexton W Diesel',
  'SsangYong Rexton',
  'SsangYong Stavic Diesel',
  'SsangYong Stavic',
  'SsangYong Tivoli Compact Diesel',
  'SsangYong Tivoli Compact',
  'SsangYong Tivoli Diesel',
  'SsangYong Tivoli XLV Diesel',
  'SsangYong Tivoli XLV',
  'SsangYong Tivoli',
  'Subaru BRZ',
  'Subaru Crosstrek e-BOXER Mild Hybrid',
  'Subaru Exiga',
  'Subaru Forester e-BOXER Mild Hybrid',
  'Subaru Forester',
  'Subaru Impreza 4D',
  'Subaru Impreza 5D',
  'Subaru Impreza STI 4D',
  'Subaru Impreza Sedan',
  'Subaru Impreza WRX 4D',
  'Subaru Impreza WRX 5D',
  'Subaru Impreza WRX',
  'Subaru Impreza Wagon',
  'Subaru Legacy Wagon',
  'Subaru Legacy',
  'Subaru Levorg',
  'Subaru Outback',
  'Subaru R1',
  'Subaru R2',
  'Subaru Tribeca',
  'Subaru WRX STI',
  'Subaru WRX Wagon',
  'Subaru WRX',
  'Subaru XV',
  'Suzuki APV',
  'Suzuki Alto',
  'Suzuki Baleno',
  'Suzuki Carry',
  'Suzuki Cervo',
  'Suzuki Ciaz',
  'Suzuki Escudo',
  'Suzuki Every Petrol',
  'Suzuki Every',
  'Suzuki Grand Vitara',
  'Suzuki Hustler',
  'Suzuki Ignis Mild Hybrid',
  'Suzuki Jimny',
  'Suzuki Kizashi',
  'Suzuki Landy Hybrid',
  'Suzuki Lapin SS',
  'Suzuki Lapin',
  'Suzuki Liana Hatchback',
  'Suzuki Liana Sedan',
  'Suzuki S-Cross Mild Hybrid',
  'Suzuki S-Cross',
  'Suzuki SOLIO',
  'Suzuki SX4 Hatchback',
  'Suzuki SX4 Sedan',
  'Suzuki SX4',
  'Suzuki Spacia Base Petrol',
  'Suzuki Spacia Mild Hybrid',
  'Suzuki Splash',
  'Suzuki Stingray',
  'Suzuki Swift Mild Hybrid 2017',
  'Suzuki Swift Mild Hybrid',
  'Suzuki Swift Sport Mild Hybrid',
  'Suzuki Swift Sport',
  'Suzuki Swift',
  'Suzuki Vitara',
  'Suzuki Xbee Hybrid',
  'Tesla Model 3 Electric',
  'Tesla Model S Electric',
  'Tesla Model X Electric',
  'Tesla Model Y Electric',
  'Tesla Roadster Electric',
  'Tesla Roadster',
  'Toyota 86',
  'Toyota Allion',
  'Toyota Alphard 1 Auto Cars Edition',
  'Toyota Alphard 2018',
  'Toyota Alphard Hybrid 2020',
  'Toyota Alphard Hybrid Speedo Motoring Edition',
  'Toyota Alphard Hybrid',
  'Toyota Alphard',
  'Toyota Aqua Hybrid',
  'Toyota Auris',
  'Toyota Avanza',
  'Toyota Aygo',
  'Toyota Belta',
  'Toyota Blade',
  'Toyota C-HR Hybrid',
  'Toyota C-HR',
  'Toyota Camry Hybrid Cars & Coffee Edition',
  'Toyota Camry Hybrid Speedo Motoring Edition',
  'Toyota Camry Hybrid Trust Motoring Edition',
  'Toyota Camry Hybrid Vincar Edition',
  'Toyota Camry Hybrid',
  'Toyota Camry',
  'Toyota Century Hybrid',
  'Toyota Coaster Bus Diesel',
  'Toyota Corolla Altis Hybrid',
  'Toyota Corolla Altis',
  'Toyota Corolla Axio Hybrid',
  'Toyota Corolla Axio',
  'Toyota Corolla Cross Hybrid',
  'Toyota Corolla Fielder Hybrid',
  'Toyota Corolla Fielder',
  'Toyota Corolla Hatchback Hybrid',
  'Toyota Corolla Rumion',
  'Toyota Corolla Sedan Hybrid',
  'Toyota Corolla Touring Hybrid',
  'Toyota Crown Athlete Hybrid',
  'Toyota Crown Athlete',
  'Toyota Crown Crossover Hybrid',
  'Toyota Crown Hybrid',
  'Toyota Crown Majesta',
  'Toyota Crown',
  'Toyota Dyna 150 Diesel',
  'Toyota Dyna 150',
  'Toyota Esquire Hybrid',
  'Toyota Esquire',
  'Toyota Estima 2016',
  'Toyota Estima Hybrid',
  'Toyota Estima',
  'Toyota FJ Cruiser',
  'Toyota Fortuner',
  'Toyota GR Supra',
  'Toyota GR Yaris',
  'Toyota GR86',
  'Toyota Granace Diesel',
  'Toyota Harrier Hybrid Vin\\\'s Auto Edition',
  'Toyota Harrier Hybrid',
  'Toyota Harrier Vincar Edition',
  'Toyota Harrier',
  'Toyota Hiace 2019 Diesel',
  'Toyota Hiace Bus',
  'Toyota Hiace Diesel',
  'Toyota Hiace High Roof Diesel',
  'Toyota Hiace Mid Roof Diesel',
  'Toyota Hiace Standard Roof Diesel',
  'Toyota Hiace Standard Roof Petrol',
  'Toyota Hiace Van',
  'Toyota Highlander Hybrid',
  'Toyota Hilux Double Cab Diesel',
  'Toyota Hilux',
  'Toyota Isis',
  'Toyota Ist',
  'Toyota Kluger Hybrid',
  'Toyota Land Cruiser 250',
  'Toyota Land Cruiser 300',
  'Toyota Land Cruiser Prado Diesel',
  'Toyota Land Cruiser Prado',
  'Toyota Land Cruiser Utility Commercial',
  'Toyota Land Cruiser',
  'Toyota Liteace Petrol',
  'Toyota Liteace',
  'Toyota MR-S',
  'Toyota Mark X Zio',
  'Toyota Mark X',
  'Toyota Noah 2014',
  'Toyota Noah Hybrid 2014',
  'Toyota Noah Hybrid 2017',
  'Toyota Noah Hybrid Quantum Armour Edition',
  'Toyota Noah Hybrid Venture Cars Edition',
  'Toyota Noah Hybrid Vin\\\'s Auto Edition',
  'Toyota Noah Hybrid',
  'Toyota Noah',
  'Toyota Passo Sette',
  'Toyota Picnic',
  'Toyota Prado',
  'Toyota Premio',
  'Toyota Previa',
  'Toyota Prius Alpha 7-Seater Hybrid',
  'Toyota Prius Alpha Hybrid',
  'Toyota Prius C Hybrid',
  'Toyota Prius Hybrid 2009',
  'Toyota Prius Hybrid 2016',
  'Toyota Prius Hybrid',
  'Toyota Prius Plug-In Hybrid',
  'Toyota Prius+ Hybrid',
  'Toyota ProAce Diesel',
  'Toyota Proace City Electric',
  'Toyota Proace Electric',
  'Toyota RAV4 Hybrid',
  'Toyota RAV4',
  'Toyota Ractis',
  'Toyota Raize Cars & Coffee Edition',
  'Toyota Raize Hybrid',
  'Toyota Raize Venture Cars Edition',
  'Toyota Raize Vin\\\'s Auto Edition',
  'Toyota Raize',
  'Toyota Rav4',
  'Toyota RegiusAce Diesel',
  'Toyota RegiusAce Super GL',
  'Toyota Royal Crown',
  'Toyota Rush',
  'Toyota Sai Hybrid',
  'Toyota Sienta Dice',
  'Toyota Sienta Hybrid 2015',
  'Toyota Sienta Hybrid Speedo Motoring Edition',
  'Toyota Sienta Hybrid Trust Motoring Edition',
  'Toyota Sienta Hybrid',
  'Toyota Sienta Venture Cars Edition',
  'Toyota Sienta',
  'Toyota Tank',
  'Toyota Townace Petrol',
  'Toyota Toyoace',
  'Toyota Vanguard',
  'Toyota Vellfire 2018',
  'Toyota Vellfire Hybrid',
  'Toyota Vellfire',
  'Toyota Vios',
  'Toyota Vitz Hybrid',
  'Toyota Vitz',
  'Toyota Voxy Hybrid 2014',
  'Toyota Voxy Hybrid',
  'Toyota Voxy',
  'Toyota Wish',
  'Toyota Yaris Cross Hybrid',
  'Toyota Yaris Cross Speedo Motoring Edition',
  'Toyota Yaris Cross',
  'Toyota Yaris',
  'Toyota bB',
  'Toyota iQ',
  'Victory e-Reliance Electric',
  'Victory e-Response Electric',
  'Volkswagen Amarok',
  'Volkswagen Arteon R',
  'Volkswagen Arteon',
  'Volkswagen Beetle Cabriolet',
  'Volkswagen Beetle Diesel',
  'Volkswagen Beetle Dune',
  'Volkswagen Beetle',
  'Volkswagen CC',
  'Volkswagen Caddy Diesel',
  'Volkswagen Caddy MPC Petrol',
  'Volkswagen Crafter 35 Diesel',
  'Volkswagen Crafter 50 Diesel',
  'Volkswagen CrossPolo',
  'Volkswagen Eos',
  'Volkswagen Golf Cabriolet Diesel',
  'Volkswagen Golf Cabriolet',
  'Volkswagen Golf GT Sport',
  'Volkswagen Golf GTD',
  'Volkswagen Golf GTI Cabriolet',
  'Volkswagen Golf GTI',
  'Volkswagen Golf Mild Hybrid',
  'Volkswagen Golf R',
  'Volkswagen Golf R32',
  'Volkswagen Golf SV',
  'Volkswagen Golf Variant',
  'Volkswagen Golf',
  'Volkswagen ID. Buzz Cargo Electric',
  'Volkswagen ID. Buzz Electric',
  'Volkswagen ID.3 Electric',
  'Volkswagen ID.4 Electric',
  'Volkswagen ID.4 GTX Electric',
  'Volkswagen ID.5 Electric',
  'Volkswagen ID.5 GTX Electric',
  'Volkswagen Jetta Diesel',
  'Volkswagen Jetta',
  'Volkswagen Multivan',
  'Volkswagen New Beetle Cabriolet',
  'Volkswagen New Beetle',
  'Volkswagen Passat CC',
  'Volkswagen Passat Diesel',
  'Volkswagen Passat R36',
  'Volkswagen Passat Variant',
  'Volkswagen Passat',
  'Volkswagen Phaeton',
  'Volkswagen Polo BlueMotion',
  'Volkswagen Polo Diesel',
  'Volkswagen Polo GTI',
  'Volkswagen Polo',
  'Volkswagen Scirocco Diesel',
  'Volkswagen Scirocco R',
  'Volkswagen Scirocco',
  'Volkswagen Sharan Diesel',
  'Volkswagen Sharan',
  'Volkswagen T-Cross',
  'Volkswagen Tiguan Diesel',
  'Volkswagen Tiguan Mild Hybrid',
  'Volkswagen Tiguan',
  'Volkswagen Touareg Diesel',
  'Volkswagen Touareg Hybrid',
  'Volkswagen Touareg R50',
  'Volkswagen Touareg TDI',
  'Volkswagen Touareg',
  'Volkswagen Touran Diesel',
  'Volkswagen Touran Sport',
  'Volkswagen Touran',
  'Volkswagen Transporter Diesel',
  'Volkswagen Transporter',
  'Volvo C30',
  'Volvo C70',
  'Volvo EC40 Electric',
  'Volvo EX30 Electric',
  'Volvo EX40 Electric',
  'Volvo S40',
  'Volvo S60 Cross Country',
  'Volvo S60 Diesel',
  'Volvo S60 Mild Hybrid',
  'Volvo S60 Recharge Plug-in Hybrid',
  'Volvo S60',
  'Volvo S80 Diesel',
  'Volvo S80',
  'Volvo S90 Diesel',
  'Volvo S90 Mild Hybrid',
  'Volvo S90',
  'Volvo V40 Cross Country Diesel',
  'Volvo V40 Cross Country',
  'Volvo V40 Diesel',
  'Volvo V40',
  'Volvo V50',
  'Volvo V60 Cross Country Mild Hybrid',
  'Volvo V60 Cross Country',
  'Volvo V60 Diesel',
  'Volvo V60 Mild Hybrid',
  'Volvo V60',
  'Volvo V70',
  'Volvo V90 Cross Country Mild Hybrid',
  'Volvo V90 Cross Country',
  'Volvo V90',
  'Volvo XC40 Electric',
  'Volvo XC40 Mild Hybrid',
  'Volvo XC40 Recharge Plug-in Hybrid',
  'Volvo XC40',
  'Volvo XC60 Mild Hybrid',
  'Volvo XC60 Plug-in Hybrid',
  'Volvo XC60 Recharge Plug-in Hybrid',
  'Volvo XC60',
  'Volvo XC70',
  'Volvo XC90 Diesel',
  'Volvo XC90 Mild Hybrid',
  'Volvo XC90',
  'Wiesmann GT',
  'XPENG G6 Electric',
  'XPENG X9 Electric',
  'Yutong C11H Hybrid',
  'Yutong ZK6117H',
  'ZEEKR 009 Electric',
  'ZEEKR X Electric',
  'smart #1 electric',
  'smart #3 electric',
  'smart Forfour Electric',
  'smart Fortwo Cabrio Electric',
  'smart Fortwo',
  '#1 electric',
  '#3 electric',
  '009 Electric',
  '07 Electric',
  '1 Series Convertible',
  '1 Series Coupe',
  '1 Series Hatchback Diesel',
  '1 Series Hatchback',
  '1007',
  '107',
  '12C Spider',
  '12C',
  '12Cilindri Spider',
  '12Cilindri',
  '147',
  '156 Sportwagon',
  '156',
  '159 Sportwagon',
  '159',
  '166',
  '1M Coupe',
  '2 Demio',
  '2 Electric',
  '2 Hatchback',
  '2 SP',
  '2 Sedan',
  '2 Series Active Tourer Diesel',
  '2 Series Active Tourer Plug-in Hybrid',
  '2 Series Active Tourer',
  '2 Series Convertible',
  '2 Series Coupe',
  '2 Series Gran Coupe',
  '2 Series Gran Tourer Diesel',
  '2 Series Gran Tourer',
  '200 Diesel',
  '2008 Diesel',
  '2008',
  '2022 C-Class Saloon Mild Hybrid TTS Edition',
  '206',
  '206CC',
  '207',
  '207CC',
  '208 Diesel',
  '208',
  '296 GTB Plug-in Hybrid',
  '296 GTS Plug-in Hybrid',
  '3 Cabriolet',
  '3 Electric',
  '3 Hatchback Mild Hybrid',
  '3 Hatchback',
  '3 Sedan Mild Hybrid',
  '3 Sedan',
  '3 Series Cabriolet',
  '3 Series Convertible',
  '3 Series Coupe',
  '3 Series Gran Turismo',
  '3 Series Plug-in Hybrid',
  '3 Series Sedan Diesel',
  '3 Series Sedan Hybrid',
  '3 Series Sedan',
  '3 Series Touring',
  '3-Row RX 350L',
  '300 Diesel',
  '3008 Diesel',
  '3008',
  '300C Diesel',
  '300C Touring',
  '300C',
  '307 CC',
  '307 SW',
  '307',
  '308 Diesel',
  '308 SW',
  '308',
  '308CC',
  '35 Electric',
  '360 Challenge Stradale',
  '370Z',
  '3800S',
  '4 Crossback Diesel',
  '4 EV',
  '4 Electric',
  '4 Series Convertible',
  '4 Series Coupe',
  '4 Series Gran Coupe',
  '4\\/4 Sport',
  '407 Coupe',
  '407 SW',
  '407',
  '408',
  '458 Italia',
  '458 Speciale',
  '458 Spider',
  '488 GTB',
  '488 Pista F1 Auto Edition',
  '488 Pista',
  '488 Spider',
  '4C',
  '5 Diesel',
  '5 EV',
  '5 Series Gran Turismo Diesel',
  '5 Series Gran Turismo',
  '5 Series Mild Hybrid CarVault Edition',
  '5 Series Plug-in Hybrid',
  '5 Series Sedan Diesel',
  '5 Series Sedan F1 Auto Cars Edition',
  '5 Series Sedan Hybrid',
  '5 Series Sedan Mild Hybrid',
  '5 Series Sedan Plug-in Hybrid',
  '5 Series Sedan TTS Edition',
  '5 Series Sedan',
  '5 Series Touring Diesel',
  '5 Series Touring Mild Hybrid',
  '5 Series Touring',
  '5',
  '500 Coupe',
  '500 Diesel',
  '500 Gucci Luxury Convertible',
  '500 Gucci Luxury',
  '5008 Diesel',
  '5008',
  '500e Electric',
  '508 Diesel',
  '508 Fastback',
  '508 RXH Hybrid',
  '508 SW Diesel',
  '508 SW',
  '508',
  '540C',
  '570 GT',
  '570S Spider',
  '570S',
  '575M Maranello',
  '599 GTB Fiorano',
  '6 Hatchback',
  '6 MPS',
  '6 SP',
  '6 Sedan',
  '6 Series Convertible',
  '6 Series Coupe',
  '6 Series Gran Coupe',
  '6 Series Gran Turismo Mild Hybrid',
  '6 Series Gran Turismo',
  '6 Wagon',
  '600LT Coupe',
  '612 Scaglietti',
  '650S Spider',
  '650S',
  '7 Crossback',
  '7 Series Diesel',
  '7 Series Hybrid',
  '7 Series Mild Hybrid',
  '7 Series Plug-in Hybrid',
  '7 Series',
  '700',
  '718 Boxster',
  '718 Cayman GTS',
  '718 Cayman',
  '720S Coupe',
  '720S Spider',
  '750S Coupe',
  '750S Spider',
  '765LT Spider',
  '765LT',
  '8 Series Convertible',
  '8 Series Coupe',
  '8 Series Gran Coupe',
  '8',
  '812 GTS',
  '812 Superfast',
  '86',
  '9-3 Convertible',
  '9-3',
  '9-5 SportCombi',
  '9-5',
  '911 Cabriolet',
  '911 GT2',
  '911 GT3',
  '911 GTS',
  '911 R',
  '911 Speedster',
  '911 Targa',
  '911',
  'A-Class 2018 TTS Edition',
  'A-Class Diesel',
  'A-Class F1 Auto Cars Edition',
  'A-Class Hatchback F1 Auto Cars Edition',
  'A-Class Hatchback HVS Edition',
  'A-Class Hatchback',
  'A-Class Saloon Cars & Coffee Edition',
  'A-Class Saloon F1 Auto Cars Edition',
  'A-Class Saloon Mild Hybrid',
  'A-Class Saloon Plug-in Hybrid',
  'A-Class Saloon',
  'A-Class',
  'A1 Sportback',
  'A1',
  'A110',
  'A168',
  'A3 Cabriolet',
  'A3 Sedan Mild Hybrid',
  'A3 Sedan',
  'A3 Sportback Mild Hybrid',
  'A3 Sportback',
  'A4 Allroad',
  'A4 Avant Mild Hybrid',
  'A4 Avant',
  'A4 Cabriolet',
  'A4 Sedan Mild Hybrid',
  'A4 Sedan',
  'A4',
  'A5 Cabriolet 2013',
  'A5 Cabriolet Mild Hybrid',
  'A5 Cabriolet',
  'A5 Coupe Diesel',
  'A5 Coupe Mild Hybrid',
  'A5 Coupe',
  'A5 Sportback Mild Hybrid',
  'A5 Sportback',
  'A6 Avant Diesel',
  'A6 Avant Mild Hybrid',
  'A6 Avant',
  'A6 Hybrid',
  'A6 Sedan Mild Hybrid',
  'A6 Sedan Plug-in Hybrid',
  'A6',
  'A7 Sportback 2015',
  'A7 Sportback Diesel',
  'A7 Sportback Mild Hybrid',
  'A7 Sportback',
  'A8 Diesel',
  'A8 Mild Hybrid',
  'A8',
  'A8L Mild Hybrid',
  'A8L Plug-in Hybrid',
  'A8L',
  'ABS EV Electric',
  'AMG GT 4-Door Coupe Mild Hybrid',
  'AMG GT 4-Door Coupe',
  'AMG GT Coupe',
  'AMG GT Roadster',
  'AMG GT',
  'APV',
  'ASX',
  'AYA Electric',
  'Abarth',
  'Accent 5D',
  'Accent',
  'Accord Euro R',
  'Accord Hybrid',
  'Accord Wagon',
  'Accord',
  'Aceman Electric',
  'Acty',
  'Actyon Diesel',
  'Actyon Sports Diesel',
  'Actyon Sports',
  'Actyon',
  'Adam',
  'Agera S',
  'Airwave',
  'Alhambra Diesel',
  'Alhambra',
  'Allion',
  'Almera',
  'Alphard 1 Auto Cars Edition',
  'Alphard 2018',
  'Alphard Hybrid 2020',
  'Alphard Hybrid Speedo Motoring Edition',
  'Alphard Hybrid',
  'Alphard',
  'Alto',
  'Amarok',
  'Aqua Hybrid',
  'Ariya Electric',
  'Arkana Fastback E-Tech Hybrid',
  'Arnage',
  'Arona',
  'Arteon R',
  'Arteon',
  'Artura Plug-in Hybrid',
  'Artura Spider Plug-in Hybrid',
  'Aruz',
  'Astra Convertible',
  'Astra GTC',
  'Astra H',
  'Astra OPC',
  'Astra Sport Wagon',
  'Astra Sports Tourer Diesel',
  'Astra Sports Tourer',
  'Astra',
  'Ateca',
  'Atlas',
  'Atto 3 Electric',
  'Attrage',
  'Aumark S Diesel',
  'Auris',
  'Avante Hybrid',
  'Avante',
  'Avanza',
  'Aventador F1 Auto Edition',
  'Aventador Roadster',
  'Aventador S Coupe',
  'Aventador',
  'Aveo Hatchback',
  'Aveo Sedan',
  'Aveo5',
  'Axela Diesel',
  'Axela Hatchback',
  'Axela Sedan',
  'Axia',
  'Aygo',
  'Azera',
  'Azure',
  'B-Class 2016',
  'B-Class Electric Drive 2016',
  'B-Class',
  'B3 Bi-Turbo Saloon',
  'B3 Bi-Turbo Touring',
  'B3 GT3 Coupe',
  'B3 S Bi-Turbo Saloon',
  'B4 Bi-Turbo Convertible',
  'B4 Bi-Turbo Coupe',
  'B4 S Bi-Turbo Coupe',
  'B5 Bi-Turbo Saloon Edition 50',
  'B5 Bi-Turbo Saloon',
  'B5 Bi-Turbo Touring Edition 50',
  'B5 Bi-Turbo Touring',
  'B6 Bi-Turbo Convertible',
  'B6 Bi-Turbo Coupe Edition 50',
  'B6 Bi-Turbo Coupe',
  'B6 Bi-Turbo Gran Coupe',
  'B7 Bi-Turbo Saloon',
  'B7 Bi-Turbo',
  'BRZ',
  'Baleno',
  'Beetle Cabriolet',
  'Beetle Diesel',
  'Beetle Dune',
  'Beetle',
  'Belta',
  'Benni',
  'Bentayga EWB',
  'Bentayga Hybrid F1 Auto Edition',
  'Bentayga Hybrid',
  'Bentayga',
  'Berlingo Diesel',
  'Berlingo',
  'Bezza',
  'Biante',
  'Big Coaster Bus Diesel',
  'Blade',
  'Box',
  'Boxster Spyder',
  'Boxster',
  'Bravo',
  'Brera',
  'Brooklands',
  'Bus',
  'C-Class 2011',
  'C-Class Cabriolet Mild Hybrid',
  'C-Class Cabriolet',
  'C-Class Coupe 2017',
  'C-Class Coupe Mild Hybrid',
  'C-Class Coupe',
  'C-Class Estate Plug-in Hybrid',
  'C-Class Estate',
  'C-Class Saloon Diesel',
  'C-Class Saloon F1 Auto Cars Edition',
  'C-Class Saloon Mild Hybrid 2018',
  'C-Class Saloon Mild Hybrid',
  'C-Class Saloon Plug-in Hybrid',
  'C-Class Saloon',
  'C-Class Sports Coupe',
  'C-HR Hybrid',
  'C-HR',
  'C1',
  'C11H Hybrid',
  'C3 Aircross',
  'C3',
  'C30',
  'C4 Cactus',
  'C4 Coupe',
  'C4 Diesel',
  'C4 Grand Picasso',
  'C4 Picasso Diesel',
  'C4 Picasso',
  'C4',
  'C5 Aircross',
  'C5 Break',
  'C5 Diesel',
  'C5',
  'C6 Electric',
  'C6',
  'C70',
  'C8 Electric',
  'C9 Electric',
  'CC',
  'CK',
  'CL-Class',
  'CLA-Class 2013',
  'CLA-Class Coupe Emperor Motors Edition',
  'CLA-Class Coupe Mild Hybrid',
  'CLA-Class Coupe',
  'CLA-Class Diesel',
  'CLA-Class F1 Auto Cars Edition',
  'CLA-Class Shooting Brake',
  'CLA-Class TTS Edition',
  'CLA-Class',
  'CLC-Class',
  'CLE-Class Cabriolet Mild Hybrid',
  'CLE-Class Coupe Mild Hybrid',
  'CLK-Class Cabriolet',
  'CLK-Class Coupe',
  'CLK-Class',
  'CLS-Class Diesel',
  'CLS-Class Mild Hybrid',
  'CLS-Class Shooting Brake Diesel',
  'CLS-Class Shooting Brake',
  'CLS-Class',
  'CR-V 2017',
  'CR-V Hybrid',
  'CR-V',
  'CR-Z Hybrid',
  'CT Hybrid',
  'CT200h',
  'CTR3',
  'CX-3 Diesel',
  'CX-3',
  'CX-30 Mild Hybrid',
  'CX-30',
  'CX-5 Diesel',
  'CX-5 Mild Hybrid',
  'CX-5',
  'CX-60',
  'CX-7',
  'CX-8',
  'CX-80 Plug-in Hybrid',
  'CX-9',
  'Cabstar',
  'Caddy Diesel',
  'Caddy MPC Petrol',
  'Caliber',
  'California H30',
  'California T',
  'California',
  'Camry Hybrid Cars & Coffee Edition',
  'Camry Hybrid Speedo Motoring Edition',
  'Camry Hybrid Trust Motoring Edition',
  'Camry Hybrid Vincar Edition',
  'Camry Hybrid',
  'Camry',
  'Captiva',
  'Captur Diesel',
  'Captur Flamme Edition',
  'Captur',
  'Caravan',
  'Carens Diesel',
  'Carens',
  'Carnival Diesel',
  'Carnival Hybrid',
  'Carnival',
  'Carry',
  'Cascada',
  'Cayenne 2014',
  'Cayenne Coupe Plug-in Hybrid',
  'Cayenne Coupe',
  'Cayenne Diesel',
  'Cayenne F1 Auto Cars Edition',
  'Cayenne Hybrid',
  'Cayenne Plug-in Hybrid Coupe',
  'Cayenne Plug-in Hybrid',
  'Cayenne S E-Hybrid',
  'Cayenne S Hybrid',
  'Cayenne Special Import',
  'Cayenne',
  'Cayman',
  'Cefiro',
  'Century Hybrid',
  'Cerato Forte Koup',
  'Cerato Forte',
  'Cerato K3',
  'Cerato Koup',
  'Cerato Smartstream',
  'Cerato Sports',
  'Cerato Variant 2',
  'Cerato',
  'Cervo',
  'Chairman',
  'Cherokee',
  'Ciaz',
  'Cinquecento 500 Convertible',
  'Cinquecento 500',
  'Citan',
  'City',
  'Civic Hatchback 2017',
  'Civic Hatchback',
  'Civic Hybrid',
  'Civic Mugen RR',
  'Civic Type-R 2017',
  'Civic Type-R',
  'Civic',
  'Clio Campus',
  'Clio Diesel',
  'Clio F1 Team R27',
  'Clio R.S.',
  'Clio',
  'Clipper',
  'Clubsport R8 Tourer',
  'Clubsport R8',
  'Coaster Bus Diesel',
  'Colorado',
  'Colt CZC',
  'Colt Plus',
  'Colt Ralliart Version-R',
  'Colt Version-R',
  'Colt',
  'Combo Diesel',
  'Combo',
  'Combo-e Electric',
  'Combo-e Life Electric',
  'Commander',
  'Compass',
  'Continental Flying Spur',
  'Continental GT 1 Auto Cars Edition',
  'Continental GT Convertible 2011',
  'Continental GT Convertible',
  'Continental GT Plug-in Hybrid',
  'Continental GT',
  'Continental Supersports Convertible',
  'Continental Supersports',
  'Cooper 3-Door Electric',
  'Cooper 3-Door',
  'Cooper 5-Door Diesel',
  'Cooper 5-Door',
  'Cooper C 5-Door',
  'Cooper Cabriolet',
  'Cooper Clubman',
  'Cooper Convertible',
  'Cooper Countryman',
  'Cooper Coupe',
  'Cooper D 5-Door',
  'Cooper D',
  'Cooper Paceman',
  'Cooper Roadster',
  'Cooper S 3-Door',
  'Cooper S 5-Door',
  'Cooper S Cabriolet',
  'Cooper S Clubman',
  'Cooper S Convertible',
  'Cooper S Countryman',
  'Cooper S Coupe',
  'Cooper S Paceman',
  'Cooper S Roadster',
  'Cooper S',
  'Cooper',
  'Copen GR Sport',
  'Copen',
  'Corolla Altis Hybrid',
  'Corolla Altis',
  'Corolla Axio Hybrid',
  'Corolla Axio',
  'Corolla Cross Hybrid',
  'Corolla Fielder Hybrid',
  'Corolla Fielder',
  'Corolla Hatchback Hybrid',
  'Corolla Rumion',
  'Corolla Sedan Hybrid',
  'Corolla Touring Hybrid',
  'Corsa',
  'Corvette',
  'Countryman C',
  'Countryman Electric',
  'Countryman S',
  'Coupe',
  'Crafter 35 Diesel',
  'Crafter 50 Diesel',
  'Croma',
  'CrossPolo',
  'Crossfire',
  'Crossland',
  'Crossover',
  'Crossroad',
  'Crosstrek e-BOXER Mild Hybrid',
  'Crown Athlete Hybrid',
  'Crown Athlete',
  'Crown Crossover Hybrid',
  'Crown Hybrid',
  'Crown Majesta',
  'Crown',
  'Cruze Station Wagon',
  'Cruze Wagon Diesel',
  'Cruze',
  'Cruze5 Sportback',
  'Cube',
  'Cullinan 1 Auto Cars Edition',
  'Cullinan',
  'Cyberster',
  'D-Max',
  'D07 Electric',
  'D3 Bi-Turbo Saloon',
  'D3 Bi-Turbo Touring',
  'D4 Bi-Turbo Coupe Diesel',
  'D5 Bi-Turbo Saloon',
  'D5 Bi-Turbo Touring',
  'D5 S Bi-Turbo Saloon Diesel',
  'D9',
  'DB11 Volante',
  'DB11',
  'DB12 Volante',
  'DB12',
  'DB9 Volante',
  'DB9',
  'DBS Volante',
  'DBS',
  'DBX',
  'DBX707',
  'DS3',
  'DS4 Diesel',
  'DS4',
  'DS5 Diesel',
  'DS5 Hybrid',
  'DS5',
  'Dawn 1 Auto Cars Edition',
  'Dawn',
  'Defender 110 Diesel',
  'Defender 110 Mild Hybrid Diesel',
  'Defender 110 Mild Hybrid',
  'Defender 110 Plug-in Hybrid',
  'Defender 110',
  'Defender 130 Mild Hybrid',
  'Defender 130',
  'Defender 90 Diesel',
  'Defender 90 Mild Hybrid Diesel',
  'Defender 90 Mild Hybrid',
  'Defender 90',
  'Defender TD5',
  'Delica D:5',
  'Discovery 3',
  'Discovery 4 Diesel',
  'Discovery Diesel',
  'Discovery Sport Diesel',
  'Discovery Sport Mild Hybrid',
  'Discovery Sport',
  'Discovery',
  'Dispatch',
  'Doblo Cargo Diesel',
  'Doblo',
  'Dolphin Electric',
  'Dualis',
  'Dyna 150 Diesel',
  'Dyna 150',
  'E Electric',
  'E-2008 Electric',
  'E-Class Cabriolet 2013',
  'E-Class Cabriolet 2017',
  'E-Class Cabriolet Mild Hybrid 2019',
  'E-Class Cabriolet Mild Hybrid',
  'E-Class Cabriolet',
  'E-Class Coupe 2017',
  'E-Class Coupe Diesel',
  'E-Class Coupe Mild Hybrid 2018',
  'E-Class Coupe Mild Hybrid 2019',
  'E-Class Coupe Mild Hybrid',
  'E-Class Coupe',
  'E-Class Estate Diesel',
  'E-Class Estate',
  'E-Class Limousine',
  'E-Class Saloon 2016',
  'E-Class Saloon Diesel 2016',
  'E-Class Saloon Diesel 2020',
  'E-Class Saloon Diesel',
  'E-Class Saloon Hybrid',
  'E-Class Saloon Mild Hybrid 2018',
  'E-Class Saloon Mild Hybrid 2019',
  'E-Class Saloon Mild Hybrid 2020',
  'E-Class Saloon Mild Hybrid Vin\\\'s Auto Edition',
  'E-Class Saloon Mild Hybrid',
  'E-Class Saloon Plug-in Hybrid 2017',
  'E-Class Saloon Plug-in Hybrid',
  'E-Class Saloon',
  'E-Class',
  'E-PACE Mild Hybrid',
  'E-PACE',
  'E2000i',
  'E5 Electric',
  'EA5 Electric',
  'EC31 Electric',
  'EC31 Refrigerated Electric',
  'EC35 Electric',
  'EC35 Gen 2 Electric',
  'EC35II Electric',
  'EC40 Electric',
  'EQA Electric',
  'EQB Electric',
  'EQC Electric',
  'EQE Electric',
  'EQE SUV Electric',
  'EQS Electric',
  'EQS SUV Electric',
  'EQV Electric',
  'ES 250',
  'ES 300h Hybrid',
  'ES Electric',
  'ES300',
  'EV490 Electric',
  'EV9 Electric',
  'EW4 Electric',
  'EX30 Electric',
  'EX40 Electric',
  'Eclipse Cross',
  'Edix',
  'Elantra',
  'Electric',
  'Eletre',
  'Elgrand',
  'Elise',
  'Elysion',
  'Emeya',
  'Emira',
  'Enyaq Coupe Electric',
  'Enyaq Electric',
  'Eos',
  'Epica',
  'Escape',
  'Escudo',
  'Esquire Hybrid',
  'Esquire',
  'Estima 2016',
  'Estima Hybrid',
  'Estima',
  'Every Petrol',
  'Every',
  'Exiga',
  'Exige',
  'Exora',
  'Expert',
  'F Series Diesel',
  'F-PACE Diesel',
  'F-PACE',
  'F-TYPE Coupe',
  'F-TYPE',
  'F-Type',
  'F12berlinetta',
  'F430 Spider',
  'F430',
  'F8 Spider',
  'F8 Tributo F1 Auto Edition',
  'F8 Tributo',
  'FJ Cruiser',
  'FR601 Electric',
  'Fabia Combi',
  'Fabia Hatchback',
  'Fabia RS',
  'Fabia Sedan',
  'Fabia',
  'Fairlady 350Z',
  'Fairlady 370Z Roadster',
  'Fairlady 370Z',
  'Fairlady',
  'Fiesta',
  'Fiorino Cargo Diesel',
  'Fiorino Cargo',
  'Fiorino',
  'Fit 2017',
  'Fit Hybrid 2017',
  'Fit Hybrid Cars & Coffee Edition',
  'Fit Hybrid Trust Motoring Edition',
  'Fit Hybrid',
  'Fit Shuttle Hybrid',
  'Fit Shuttle',
  'Fit Speedo Motoring Edition',
  'Fit Venture Cars Edition',
  'Fit Vincar Edition',
  'Fit',
  'Fluence Diesel',
  'Fluence Z.E',
  'Fluence',
  'Flying Spur F1 Auto Cars Edition',
  'Flying Spur Plug-in Hybrid',
  'Flying Spur',
  'Focus Hatchback',
  'Focus RS',
  'Focus ST',
  'Focus Sedan',
  'Focus Wagon',
  'Forester e-BOXER Mild Hybrid',
  'Forester',
  'Forfour Electric',
  'Formentor',
  'Forte Hatchback',
  'Fortuner',
  'Fortwo Cabrio Electric',
  'Fortwo',
  'Freed 2020',
  'Freed Hybrid 2020',
  'Freed Hybrid Speedo Motoring Edition',
  'Freed Hybrid Trust Motoring Edition',
  'Freed Hybrid Vin\\\'s Auto Edition',
  'Freed Hybrid',
  'Freed Spike',
  'Freed',
  'Freelander 2',
  'Freelander',
  'Fuga',
  'Fulwin 2 Hatchback',
  'Fulwin 2 Sedan',
  'Fuso Canter Diesel',
  'Fuso Canter',
  'Fuso Fighter',
  'Fuso Rosa',
  'G-Class 1 Auto Cars Edition',
  'G-Class 2013',
  'G-Class Diesel',
  'G-Class',
  'G10 Executive MPV',
  'G10 Petrol',
  'G6 Electric',
  'G80',
  'GL-Class Diesel',
  'GL-Class',
  'GLA-Class 2014',
  'GLA-Class Diesel',
  'GLA-Class Mild Hybrid',
  'GLA-Class Zion Auto Edition',
  'GLA-Class',
  'GLB-Class Car Empire Edition',
  'GLB-Class CarVault Edition',
  'GLB-Class Diesel',
  'GLB-Class F1 Auto Cars Edition',
  'GLB-Class Mild Hybrid',
  'GLB-Class Vincar Edition',
  'GLB-Class',
  'GLC-Class Coupe Diesel',
  'GLC-Class Coupe F1 Auto Cars Edition',
  'GLC-Class Coupe Mild Hybrid 2019',
  'GLC-Class Coupe Mild Hybrid F1 Auto Edition',
  'GLC-Class Coupe Mild Hybrid',
  'GLC-Class Coupe Plug-in Hybrid',
  'GLC-Class Coupe TTS Edition',
  'GLC-Class Coupe',
  'GLC-Class Diesel',
  'GLC-Class F1 Auto Cars Edition',
  'GLC-Class Mild Hybrid F1 Auto Edition',
  'GLC-Class Mild Hybrid',
  'GLC-Class Plug-in Hybrid',
  'GLC-Class Quantum Armour Edition',
  'GLC-Class',
  'GLE-Class 2016',
  'GLE-Class Coupe Diesel',
  'GLE-Class Coupe Mild Hybrid',
  'GLE-Class Coupe',
  'GLE-Class Diesel',
  'GLE-Class Mild Hybrid 1 Auto Cars Edition',
  'GLE-Class Mild Hybrid',
  'GLE-Class',
  'GLS-Class Diesel',
  'GLS-Class Mild Hybrid',
  'GLS-Class',
  'GR Supra',
  'GR Yaris',
  'GR86',
  'GS 300',
  'GS 350',
  'GS 450h',
  'GS F',
  'GS',
  'GS300',
  'GS450h Hybrid',
  'GT',
  'GT-R Car Empire Edition',
  'GT-R',
  'GTC4Lusso T',
  'GTC4Lusso',
  'GTR',
  'GTS',
  'GV60',
  'Galant',
  'Galaxy Diesel',
  'Galaxy',
  'Gallardo Spyder',
  'Gallardo',
  'Galue 2-04',
  'Galue III',
  'Galue',
  'Gen.2',
  'Genesis',
  'Getz',
  'Ghibli Diesel',
  'Ghibli Mild Hybrid',
  'Ghibli',
  'Ghost 1 Auto Cars Edition',
  'Ghost Series II F1 Auto Edition',
  'Ghost Series II',
  'Ghost',
  'Giulia',
  'Giulietta',
  'Gladiator Overland Petrol',
  'Gladiator Rubicon Petrol',
  'Golf Cabriolet Diesel',
  'Golf Cabriolet',
  'Golf GT Sport',
  'Golf GTD',
  'Golf GTI Cabriolet',
  'Golf GTI',
  'Golf Mild Hybrid',
  'Golf R',
  'Golf R32',
  'Golf SV',
  'Golf Variant',
  'Golf',
  'Good Cat Electric',
  'Grace Hybrid Speedo Motoring Edition',
  'Grace Hybrid',
  'Grace',
  'GranCabrio',
  'GranTurismo',
  'Granace Diesel',
  'Grand C-Max',
  'Grand C4 Picasso Diesel',
  'Grand C4 Picasso',
  'Grand C4 SpaceTourer',
  'Grand Cherokee Diesel',
  'Grand Cherokee L',
  'Grand Cherokee SRT8',
  'Grand Cherokee',
  'Grand Espace',
  'Grand Scenic Diesel',
  'Grand Scenic',
  'Grand Vitara',
  'Grand Voyager Diesel',
  'Grand Voyager',
  'Grande Punto',
  'Grandis',
  'Grandland',
  'Grange',
  'Grecale Mild Hybrid',
  'Grecale',
  'H3',
  'H5 Bus',
  'H5',
  'H5C',
  'H5F Electric',
  'H5F Standard Roof Electric',
  'H9E Electric',
  'HR-V Hybrid',
  'HR-V',
  'HS Plug-in Hybrid',
  'HS',
  'Harrier Hybrid Vin\\\'s Auto Edition',
  'Harrier Hybrid',
  'Harrier Vincar Edition',
  'Harrier',
  'Hiace 2019 Diesel',
  'Hiace Bus',
  'Hiace Diesel',
  'Hiace High Roof Diesel',
  'Hiace Mid Roof Diesel',
  'Hiace Standard Roof Diesel',
  'Hiace Standard Roof Petrol',
  'Hiace Van',
  'Highlander Hybrid',
  'Hijet',
  'Hilux Double Cab Diesel',
  'Hilux',
  'Himiko',
  'Huayra',
  'Huracan STO',
  'Huracan Spyder',
  'Huracan',
  'Hustler',
  'I-PACE Electric',
  'ID. Buzz Cargo Electric',
  'ID. Buzz Electric',
  'ID.3 Electric',
  'ID.4 Electric',
  'ID.4 GTX Electric',
  'ID.5 Electric',
  'ID.5 GTX Electric',
  'IS 300',
  'IS 300h Hybrid',
  'IS 350',
  'IS F',
  'IS250',
  'IS250C',
  'Ibiza',
  'Iblue T5 Electric Truck',
  'Iblue V6 Electric Commuter Bus',
  'Iblue V6 Electric Van',
  'Iblue V6 Electric',
  'Idea',
  'Ignis Mild Hybrid',
  'Impreza 4D',
  'Impreza 5D',
  'Impreza STI 4D',
  'Impreza Sedan',
  'Impreza WRX 4D',
  'Impreza WRX 5D',
  'Impreza WRX',
  'Impreza Wagon',
  'Insight Hybrid',
  'Insignia Diesel',
  'Insignia Grand Sport Diesel',
  'Insignia Grand Sport',
  'Insignia Sport Tourer',
  'Insignia',
  'Inspire',
  'Integra',
  'Ioniq 5 Electric',
  'Ioniq 5 N Electric',
  'Ioniq 6 Electric',
  'Ioniq Electric',
  'Ioniq Hybrid',
  'Isis',
  'Ist',
  'J1',
  'J3 Hatchback',
  'J3 S-Coupe',
  'J3 Sedan',
  'J5',
  'J6 Electric',
  'J7 Plug-in Hybrid',
  'Jade Hybrid',
  'Jade',
  'Jazz Crosstar Hybrid',
  'Jazz Hybrid',
  'Jazz',
  'Jetta Diesel',
  'Jetta',
  'Jimny',
  'John Cooper Works 3-Door',
  'John Cooper Works Cabriolet',
  'John Cooper Works Clubman',
  'John Cooper Works Convertible',
  'John Cooper Works Countryman',
  'John Cooper Works Coupe',
  'John Cooper Works GP',
  'John Cooper Works Paceman',
  'John Cooper Works Roadster',
  'John Cooper Works',
  'Journey',
  'Juke',
  'K Electric',
  'K2500 Diesel',
  'K2900',
  'Ka',
  'Kadjar Diesel',
  'Kadjar',
  'Kamiq',
  'Kangoo Diesel',
  'Kangoo E-Tech Electric',
  'Kangoo WAV',
  'Kangoo',
  'Karoq',
  'Kelisa',
  'Kembara',
  'Kenari',
  'Kicks e-POWER Hybrid',
  'Kizashi',
  'Kluger Hybrid',
  'Kodiaq Diesel',
  'Kodiaq Mild Hybrid',
  'Kodiaq RS',
  'Kodiaq',
  'Koleos',
  'Kona Electric',
  'Kona Hybrid',
  'Kona',
  'Korando Diesel',
  'Korando Electric',
  'Korando',
  'Kuga',
  'Kyron',
  'L200 Triton Diesel',
  'LBX Hybrid',
  'LC 500 Convertible',
  'LC 500',
  'LC 500h',
  'LFA',
  'LM Hybrid',
  'LS Hybrid',
  'LS',
  'LS460',
  'LS600hL Hybrid',
  'Lafesta',
  'Laguna Coupe',
  'Laguna',
  'Lancer EX Ralliart',
  'Lancer EX',
  'Lancer Evolution IX',
  'Lancer Evolution X',
  'Lancer Evolution',
  'Lancer MR',
  'Lancer',
  'Land Cruiser 250',
  'Land Cruiser 300',
  'Land Cruiser Prado Diesel',
  'Land Cruiser Prado',
  'Land Cruiser Utility Commercial',
  'Land Cruiser',
  'Landy Hybrid',
  'Lapin SS',
  'Lapin',
  'Latio Sedan',
  'Latio Sport',
  'Latitude',
  'Leaf Electric',
  'Legacy Wagon',
  'Legacy',
  'Legend Hybrid',
  'Legend',
  'Leon Mild Hybrid',
  'Leon Sport Coupe',
  'Leon Sport Tourer',
  'Leon Sportstourer Mild Hybrid',
  'Leon Sportstourer',
  'Leon',
  'Levante Diesel',
  'Levante',
  'Levorg',
  'Liana Hatchback',
  'Liana Sedan',
  'Life',
  'Liteace Petrol',
  'Liteace',
  'Lobo',
  'Logistar 200 Electric',
  'M-Class Diesel',
  'M-Class',
  'M135',
  'M135i',
  'M140i',
  'M2 Coupe',
  'M235 Gran Coupe',
  'M235i Convertible',
  'M235i Coupe',
  'M240i Convertible',
  'M240i Coupe',
  'M3 Convertible',
  'M3 Coupe',
  'M3 Sedan',
  'M3 Touring',
  'M340i',
  'M3e Electric',
  'M4 Convertible',
  'M4 Coupe',
  'M440i Gran Coupe Mild Hybrid',
  'M5 Sedan Plug-in Hybrid',
  'M5 Sedan',
  'M550i',
  'M6 Convertible',
  'M6 Coupe',
  'M6 Electric',
  'M6 Gran Coupe',
  'M760Li',
  'M8 Coupe',
  'M8 Gran Coupe',
  'M8',
  'M850i Convertible',
  'M850i Coupe',
  'M850i Gran Coupe',
  'M9 EV',
  'MC20',
  'MIFA 7 Electric',
  'MIFA 9 Electric',
  'MK',
  'MP-X',
  'MR-S',
  'MX-30 Electric',
  'MX-5 RF',
  'MX-5',
  'Macan 2014',
  'Macan Diesel',
  'Macan Electric',
  'Macan',
  'Magentis',
  'Malibu',
  'Maloo',
  'March',
  'Mark X Zio',
  'Mark X',
  'Master',
  'Materia',
  'Matrix',
  'Maybach EQS Electric',
  'Maybach GLS-Class 1 Auto Cars Edition',
  'Maybach GLS-Class Mild Hybrid',
  'Maybach GLS-Class',
  'Maybach S-Class Mild Hybrid',
  'Maybach S-Class',
  'Megane Coupe-Cabriolet',
  'Megane F1 Team R26',
  'Megane GT',
  'Megane GT-Line Diesel',
  'Megane Hatch Diesel',
  'Megane Hatch',
  'Megane Hatchback',
  'Megane RS',
  'Megane Sedan Diesel',
  'Megane Sedan',
  'Megane Sport Tourer',
  'Meriva',
  'MiTo',
  'Midi',
  'MinZ MPV',
  'MinZ Pick Up',
  'MinZ Van',
  'Mini-Bus',
  'Mira Cocoa',
  'Mobilio',
  'Model 3 Electric',
  'Model S Electric',
  'Model X Electric',
  'Model Y Electric',
  'Modus',
  'Mokka X Diesel',
  'Mokka',
  'Mokka-e Electric',
  'Mondeo Station Wagon',
  'Mondeo Wagon',
  'Mondeo',
  'Mono R',
  'Mono',
  'Monte Carlo',
  'Mulsanne',
  'Multivan',
  'Murano',
  'Murcielago',
  'Musso Grand Diesel',
  'Mustang Convertible',
  'Mustang Mach-E',
  'Mustang',
  'Myvi',
  'N Series Diesel',
  'N Series',
  'N-Box',
  'N-Van Petrol',
  'N50 Electric',
  'N75EV Electric',
  'N90EV Electric',
  'NSX Hybrid',
  'NV100 High Roof Petrol',
  'NV100 Petrol',
  'NV100DX',
  'NV200 Diesel',
  'NV200 Petrol',
  'NV200',
  'NV250 Diesel',
  'NV350 Caravan',
  'NV350 Diesel',
  'NV350 High Roof',
  'NV350 Microbus',
  'NV350 Petrol',
  'NV350',
  'NX 300',
  'NX 300h Hybrid',
  'NX 350',
  'NX 350h Hybrid',
  'NX 450h+ Plug-in Hybrid',
  'NX Hybrid',
  'NX',
  'Navara',
  'Nemo',
  'New Beetle Cabriolet',
  'New Beetle',
  'Niro Electric',
  'Niro Hybrid',
  'Niro Plus Electric',
  'Noah 2014',
  'Noah Hybrid 2014',
  'Noah Hybrid 2017',
  'Noah Hybrid Quantum Armour Edition',
  'Noah Hybrid Venture Cars Edition',
  'Noah Hybrid Vin\\\'s Auto Edition',
  'Noah Hybrid',
  'Noah',
  'Note e-POWER Hybrid',
  'Note',
  'Nouera 6-02',
  'Nouera',
  'Octavia Combi Mild Hybrid',
  'Octavia Combi RS',
  'Octavia Combi',
  'Octavia Estate',
  'Octavia Mild Hybrid',
  'Octavia RS',
  'Octavia Scout Diesel',
  'Octavia',
  'Odyssey Hybrid 2016',
  'Odyssey Hybrid Global Carz Edition',
  'Odyssey Hybrid Speedo Motoring Edition',
  'Odyssey Hybrid',
  'Odyssey Leco Edition',
  'Odyssey',
  'One 3-Door',
  'One 5-Door',
  'One Brick Lane',
  'One Clubman',
  'One Stratford',
  'One',
  'Optima K5',
  'Optima',
  'Optra Hatchback',
  'Optra Magnum Estate',
  'Optra Magnum Sedan',
  'Orlando',
  'Orochi',
  'Outback',
  'Outlander Plug-in Hybrid',
  'Outlander',
  'PT Cruiser Convertible',
  'PT Cruiser Touring',
  'Pajero',
  'Palisade',
  'Panamera Diesel',
  'Panamera E-Hybrid',
  'Panamera Plug-in Hybrid',
  'Panamera S E-Hybrid',
  'Panamera S Hybrid',
  'Panamera Sport Turismo Diesel',
  'Panamera Sport Turismo E-Hybrid',
  'Panamera Sport Turismo',
  'Panamera',
  'Panda',
  'Panorama',
  'Partner Diesel',
  'Partner',
  'Passat CC',
  'Passat Diesel',
  'Passat R36',
  'Passat Variant',
  'Passat',
  'Passo Sette',
  'Patriot Limited',
  'Persona',
  'Phaeton',
  'Phantom 1 Auto Cars Edition',
  'Phantom Coupe',
  'Phantom Drophead Coupe',
  'Phantom Series II Coupe',
  'Phantom Series II Drophead Coupe',
  'Phantom Series II',
  'Phantom',
  'Picanto',
  'Picnic',
  'Plus Four',
  'Plus Six',
  'Polo BlueMotion',
  'Polo Diesel',
  'Polo GTI',
  'Polo',
  'Portofino',
  'Prado',
  'Premacy',
  'Premio',
  'Presage',
  'Preve',
  'Previa',
  'Prius Alpha 7-Seater Hybrid',
  'Prius Alpha Hybrid',
  'Prius C Hybrid',
  'Prius Hybrid 2009',
  'Prius Hybrid 2016',
  'Prius Hybrid',
  'Prius Plug-In Hybrid',
  'Prius+ Hybrid',
  'ProAce Diesel',
  'Proace City Electric',
  'Proace Electric',
  'Pulsar',
  'Punto Evo',
  'Purosangue',
  'Q2',
  'Q3 2016',
  'Q3 Mild Hybrid',
  'Q3 Sportback Mild Hybrid',
  'Q3 Sportback',
  'Q3',
  'Q30 Diesel',
  'Q30',
  'Q4 Sportback e-tron Electric',
  'Q4 e-tron Electric',
  'Q5 Mild Hybrid',
  'Q5 Sportback Mild Hybrid',
  'Q5',
  'Q50',
  'Q60 Convertible',
  'Q60',
  'Q7 Diesel',
  'Q7 Hybrid',
  'Q7 Mild Hybrid',
  'Q7',
  'Q70 Hybrid',
  'Q70',
  'Q8 Diesel Mild Hybrid',
  'Q8 Mild Hybrid',
  'Q8 Sportback e-tron Electric',
  'Q8 e-tron Electric',
  'QQ',
  'QX30',
  'QX50',
  'QX70',
  'QX80',
  'Qashqai +2',
  'Qashqai Mild Hybrid',
  'Qashqai',
  'Quattroporte Diesel',
  'Quattroporte Sport GT',
  'Quattroporte',
  'Qubo',
  'R-Class',
  'R1',
  'R2',
  'R8 Coupe',
  'R8 GT Coupe',
  'R8 GT Spyder',
  'R8 Spyder',
  'R8',
  'RAV4 Hybrid',
  'RAV4',
  'RC 300',
  'RC F',
  'RC',
  'RCZ',
  'RGT',
  'RS 3 Sedan',
  'RS 3 Sportback',
  'RS 4 Avant',
  'RS 4 Cabriolet',
  'RS 4',
  'RS 5 Coupe',
  'RS 5 Sportback',
  'RS 6 Avant Mild Hybrid',
  'RS 6 Avant',
  'RS 6 Sedan',
  'RS 7 Sportback Mild Hybrid',
  'RS Q3 Sportback',
  'RS Q3',
  'RS Q8 Mild Hybrid',
  'RS e-tron GT Electric',
  'RTR',
  'RX 300',
  'RX 350',
  'RX 350h Hybrid',
  'RX 450h Hybrid',
  'RX 450h+ Plug-in Hybrid',
  'RX 500h Hybrid',
  'RX Turbo',
  'RX-8',
  'RX270',
  'RX350',
  'RX400h Hybrid',
  'RX450h Hybrid',
  'RX8',
  'RZ Electric',
  'Ractis',
  'Raize Cars & Coffee Edition',
  'Raize Hybrid',
  'Raize Venture Cars Edition',
  'Raize Vin\\\'s Auto Edition',
  'Raize',
  'Range Rover Diesel',
  'Range Rover Evoque Convertible',
  'Range Rover Evoque Diesel',
  'Range Rover Evoque Mild Hybrid',
  'Range Rover Evoque',
  'Range Rover Mild Hybrid',
  'Range Rover Plug-in Hybrid',
  'Range Rover Sport Diesel',
  'Range Rover Sport Mild Hybrid',
  'Range Rover Sport Plug-in Hybrid',
  'Range Rover Sport',
  'Range Rover Velar Mild Hybrid',
  'Range Rover Velar',
  'Range Rover Vogue',
  'Range Rover',
  'Ranger Diesel',
  'Ranger Raptor Diesel',
  'Ranger Raptor Petrol',
  'Ranger Wildtrak Diesel',
  'Ranger',
  'Rapid Spaceback',
  'Rapide S',
  'Rapide',
  'Rav4',
  'RegiusAce Diesel',
  'RegiusAce Super GL',
  'Relay',
  'Renegade Diesel',
  'Renegade',
  'Revuelto Plug-in Hybrid',
  'Rexton W Diesel',
  'Rexton',
  'Rio Hatchback',
  'Rio Sedan',
  'Rio',
  'Roadster Electric',
  'Roadster',
  'Rock Star',
  'Roma 1 Auto Cars Edition',
  'Roma Spider',
  'Roma',
  'Roomster',
  'Royal Crown',
  'Rush',
  'S-Class Cabriolet',
  'S-Class Coupe',
  'S-Class Diesel',
  'S-Class Hybrid',
  'S-Class Mild Hybrid',
  'S-Class Plug-in Hybrid',
  'S-Class',
  'S-Cross Mild Hybrid',
  'S-Cross',
  'S-Max Diesel',
  'S-Max',
  'S-Type',
  'S2000',
  'S3 Sedan',
  'S3 Sportback',
  'S3',
  'S4 Avant',
  'S4 Sedan',
  'S4',
  'S40',
  'S5 Cabriolet',
  'S5 Coupe',
  'S5 Sportback',
  'S5',
  'S6',
  'S60 Cross Country',
  'S60 Diesel',
  'S60 Mild Hybrid',
  'S60 Recharge Plug-in Hybrid',
  'S60',
  'S660',
  'S7 Sportback',
  'S8 Mild Hybrid',
  'S8',
  'S80 Diesel',
  'S80',
  'S90 Diesel',
  'S90 Mild Hybrid',
  'S90',
  'SC430',
  'SCR',
  'SF90 Spider Plug-in Hybrid',
  'SF90 Stradale Plug-in Hybrid F1 Auto Edition',
  'SF90 Stradale Plug-in Hybrid',
  'SL-Class Cabriolet',
  'SL-Class',
  'SLC-Class',
  'SLK-Class',
  'SLS AMG GT',
  'SLS AMG Roadster',
  'SLS AMG',
  'SOLIO',
  'SQ5 Sportback',
  'SQ5',
  'SQ7',
  'SQ8 e-tron Electric',
  'SQ8',
  'SX4 Hatchback',
  'SX4 Sedan',
  'SX4',
  'Saga',
  'Sai Hybrid',
  'Santa Fe Diesel',
  'Santa Fe Hybrid',
  'Santa Fe Turbo Hybrid',
  'Santa Fe',
  'Satria Neo',
  'Savvy',
  'Scala',
  'Scenic Diesel',
  'Scenic',
  'Scirocco Diesel',
  'Scirocco R',
  'Scirocco',
  'Seal Electric',
  'Sealion 7 Electric',
  'Sebring Convertible',
  'Sebring',
  'Seltos',
  'Senator',
  'Serena e-POWER Hybrid Venture Cars Edition',
  'Serena e-POWER Hybrid',
  'Serena',
  'Sharan Diesel',
  'Sharan',
  'Shuttle Hybrid Speedo Motoring Edition',
  'Shuttle Hybrid Vin\\\'s Auto Edition',
  'Shuttle Hybrid',
  'Shuttle Speedo Motoring Edition',
  'Shuttle Vin\\\'s Auto Edition',
  'Shuttle',
  'Sienta Dice',
  'Sienta Hybrid 2015',
  'Sienta Hybrid Speedo Motoring Edition',
  'Sienta Hybrid Trust Motoring Edition',
  'Sienta Hybrid',
  'Sienta Venture Cars Edition',
  'Sienta',
  'Sirion',
  'Skyline',
  'Sonata VIII',
  'Sonata',
  'Sonet',
  'Sonic Hatchback',
  'Sonic Sedan',
  'Sorento Diesel',
  'Sorento Hybrid',
  'Sorento',
  'Soul',
  'Space Star',
  'Spacia Base Petrol',
  'Spacia Mild Hybrid',
  'Spark',
  'Spectre Electric',
  'Spider',
  'Splash',
  'Sportage Diesel',
  'Sportage',
  'Spyder',
  'Star MPV',
  'Star Van',
  'Starex Bus',
  'Starex Van',
  'Starex',
  'Staria',
  'Stavic Diesel',
  'Stavic',
  'Stelvio',
  'Stepwagon 2015',
  'Stepwagon Global Carz Edition',
  'Stepwagon Hybrid 2018',
  'Stepwagon Hybrid',
  'Stepwagon',
  'Stilo',
  'Stinger',
  'Stingray',
  'Stonic Mild Hybrid',
  'Stonic',
  'Stream',
  'Sunny',
  'SuperVan Electric',
  'Superb Combi',
  'Superb TDI',
  'Superb',
  'Swift Mild Hybrid 2017',
  'Swift Mild Hybrid',
  'Swift Sport Mild Hybrid',
  'Swift Sport',
  'Swift',
  'Sylphy',
  'T-Cross',
  'T11',
  'T3 Electric',
  'T3EV Electric',
  'T90 EV Electric',
  'T90 Electric',
  'T9R Electric',
  'TT Coupe',
  'TT RS Coupe',
  'TT RS Roadster',
  'TT Roadster',
  'TTS Coupe',
  'TTS Roadster',
  'Tank',
  'Tarraco',
  'Taycan Cross Turismo Electric',
  'Taycan Electric',
  'Taycan Sport Turismo Electric',
  'Teana',
  'Temerario Plug-in Hybrid',
  'Terios 7-Seater',
  'Terios',
  'Terracan',
  'Tigra',
  'Tiguan Diesel',
  'Tiguan Mild Hybrid',
  'Tiguan',
  'Tivoli Compact Diesel',
  'Tivoli Compact',
  'Tivoli Diesel',
  'Tivoli XLV Diesel',
  'Tivoli XLV',
  'Tivoli',
  'Toledo Diesel',
  'Toledo',
  'Tonale Mild Hybrid',
  'Touareg Diesel',
  'Touareg Hybrid',
  'Touareg R50',
  'Touareg TDI',
  'Touareg',
  'Touran Diesel',
  'Touran Sport',
  'Touran',
  'Townace Petrol',
  'Toyoace',
  'Trafic',
  'Trajet',
  'Transit Connect',
  'Transporter Diesel',
  'Transporter',
  'Tribeca',
  'Triton L200',
  'Tucson Diesel',
  'Tucson Hybrid',
  'Tucson',
  'Turbo Florio',
  'Tuscani',
  'UX 200',
  'UX 250h Hybrid',
  'UX 300e Electric',
  'UX 300h Hybrid',
  'Ultimate',
  'Ulysse',
  'Urus Plug-in Hybrid',
  'Urus',
  'Urvan',
  'V Electric',
  'V-Class Diesel',
  'V-Class',
  'V12 DBS',
  'V12 Vantage S',
  'V12 Vantage',
  'V40 Cross Country Diesel',
  'V40 Cross Country',
  'V40 Diesel',
  'V40',
  'V5',
  'V50',
  'V60 Cross Country Mild Hybrid',
  'V60 Cross Country',
  'V60 Diesel',
  'V60 Mild Hybrid',
  'V60',
  'V7 Electric',
  'V70',
  'V8 Vantage Roadster',
  'V8 Vantage S Roadster',
  'V8 Vantage S',
  'V8 Vantage',
  'V80 Commuter',
  'V80',
  'V90 Cross Country Mild Hybrid',
  'V90 Cross Country',
  'V90',
  'VN5 Plug-in Hybrid',
  'Vanguard',
  'Vanquish Volante',
  'Vanquish',
  'Vantage',
  'Vectra',
  'Vellfire 2018',
  'Vellfire Hybrid',
  'Vellfire',
  'Veloster',
  'Venue',
  'Verna',
  'Vezel 2014',
  'Vezel Hybrid 2021 Speedo Motoring Edition',
  'Vezel Hybrid Auto Midas Edition',
  'Vezel Hybrid',
  'Vezel Trust Motoring Edition',
  'Vezel Vin\\\'s Auto Edition',
  'Vezel',
  'Viano',
  'Viewt',
  'Vios',
  'Virage Volante',
  'Virage',
  'Vitara',
  'Vito Diesel',
  'Vito Tourer Diesel',
  'Vito',
  'Vitz Hybrid',
  'Vitz',
  'Viva',
  'Vivaro',
  'Vivaro-e Electric',
  'Volt',
  'Voxy Hybrid 2014',
  'Voxy Hybrid',
  'Voxy',
  'WR-V',
  'WRX STI',
  'WRX Wagon',
  'WRX',
  'Waja',
  'Wira',
  'Wish',
  'Wraith 1 Auto Cars Edition',
  'Wraith',
  'Wrangler Rubicon 2-Door',
  'Wrangler Rubicon 4-Door',
  'Wrangler Rubicon',
  'Wrangler Sahara 2-Door',
  'Wrangler Sahara 4-Door Diesel',
  'Wrangler Sahara 4-Door',
  'Wrangler Sahara Diesel',
  'Wrangler Unlimited Rubicon',
  'Wrangler Unlimited Sahara Diesel',
  'Wrangler Unlimited',
  'Wrangler',
  'X Electric',
  'X-Class Diesel',
  'X-Trail e-POWER Hybrid',
  'X-Trail e-POWER e-4ORCE Hybrid',
  'X-Trail',
  'X-Type',
  'X1 Diesel',
  'X1 M35i',
  'X1',
  'X2 M35i',
  'X2',
  'X3 2011',
  'X3 Diesel',
  'X3 M',
  'X3 M40i Mild Hybrid',
  'X3 M40i',
  'X3 M50 Mild Hybrid',
  'X3 Mild Hybrid',
  'X3 Plug-in Hybrid',
  'X3',
  'X30LEV Electric',
  'X4 M',
  'X4 M40i Mild Hybrid',
  'X4 M40i',
  'X4 Mild Hybrid',
  'X4',
  'X5 Diesel',
  'X5 M',
  'X5 M50d',
  'X5 M50i',
  'X5 Mild Hybrid',
  'X5 Plug-in Hybrid',
  'X5',
  'X6 M',
  'X6 M50d',
  'X6 M50i',
  'X6 Mild Hybrid',
  'X6',
  'X7 M50i',
  'X7 M60i Mild Hybrid',
  'X7',
  'X9 Electric',
  'XC40 Electric',
  'XC40 Mild Hybrid',
  'XC40 Recharge Plug-in Hybrid',
  'XC40',
  'XC60 Mild Hybrid',
  'XC60 Plug-in Hybrid',
  'XC60 Recharge Plug-in Hybrid',
  'XC60',
  'XC70',
  'XC90 Diesel',
  'XC90 Mild Hybrid',
  'XC90',
  'XD3 Bi-Turbo',
  'XD3 Diesel',
  'XE Diesel',
  'XE',
  'XF Diesel',
  'XF',
  'XJ Diesel',
  'XJ',
  'XK',
  'XM Plug-in Hybrid',
  'XML 6113',
  'XML5036 Minibus Electric',
  'XML6107 Diesel',
  'XML6112 Diesel',
  'XML6118',
  'XML6126',
  'XML6129 Diesel',
  'XML6701',
  'XML6957 Diesel',
  'XML6957',
  'XV',
  'Xbee Hybrid',
  'Y Plus Electric',
  'Yaris Cross Hybrid',
  'Yaris Cross Speedo Motoring Edition',
  'Yaris Cross',
  'Yaris',
  'Yeti',
  'Z4 Coupe',
  'Z4 Roadster',
  'Z4',
  'ZK6117H',
  'ZR-V Hybrid',
  'ZS EV',
  'Zafira Grand Tourer',
  'Zafira',
  'Zafira-e Life Electric',
  'Zoe Electric',
  'bB',
  'e-Berlingo Electric',
  'e-C4 Electric',
  'e-C4 X Sedan Electric',
  'e-Dispatch Electric',
  'e-Expert Electric',
  'e-Partner Electric',
  'e-Reliance Electric',
  'e-Response Electric',
  'e-tron Electric',
  'e-tron GT Electric',
  'e-tron S Sportback Electric',
  'e-tron Sportback Electric',
  'e6 Electric',
  'eActros Electric',
  'eDeliver 3 Electric',
  'eDeliver 5 Electric',
  'eDeliver 7 Electric',
  'eDeliver 9 Electric',
  'eTruck Mate Electric Mini Truck',
  'eVito Electric',
  'i',
  'i3 Electric',
  'i30 Fastback',
  'i30 Hatchback',
  'i30 N',
  'i30 Wagon',
  'i30',
  'i3s Electric',
  'i4 Gran Coupe Electric',
  'i4 M50 Gran Coupe Electric',
  'i40 Wagon',
  'i45',
  'i5 Electric',
  'i5 M60 Electric',
  'i5 Touring Electric',
  'i7 Electric',
  'i7 M70 Electric',
  'i8 Coupe',
  'i8 Roadster',
  'iQ',
  'iX Electric',
  'iX1 Electric',
  'iX2 Electric',
  'iX3 Electric',
];
